import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, LOCALE_ID, Inject, Input, Output, ViewEncapsulation, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@ngrx/store';
import { createFeatureSelector, createSelector, select, StoreModule } from '@ngrx/store';
import { Subscription, from, of } from 'rxjs';
import { cookie } from '@blue/services/utils';
import { first, filter, map, switchMap, concatMap, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { addDays, differenceInMilliseconds, subDays, addMonths, differenceInDays, eachMonthOfInterval, isFirstDayOfMonth, eachDayOfInterval, isBefore, isAfter, toDate, addYears, isEqual, differenceInCalendarDays, isLeapYear, isDate, formatISO } from 'date-fns';
import * as i2$1 from '@accounting/accounting-services';
import { FrequencyType, PeriodType } from '@accounting/accounting-services';
import { environment, permission, session } from '@blue/services';
import * as i1 from '@bm-uktax/uk-vat-periods';
import { UkVatPeriodsModule } from '@bm-uktax/uk-vat-periods';
import * as i5 from '@bento/bento-ng';
import { BentoModule, BentoTranslateModule } from '@bento/bento-ng';
import * as i3 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i5$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbDate, NgbDateAdapter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcCore from '@grapecity/wijmo';
import * as i8 from '@grapecity/wijmo.angular2.grid';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import * as i5$2 from '@bento/bento-ng-flexgrid-control';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import * as i3$1 from '@angular/platform-browser';
import * as i6 from '@accounting/year-end-close';
import { BluemoonYearEndCloseModule } from '@accounting/year-end-close';
import * as i9 from '@bm-uktax/uk-tax-periods';
import { UkTaxPeriodsModule } from '@bm-uktax/uk-tax-periods';
import * as i1$3 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjGridDetailModule } from '@grapecity/wijmo.angular2.grid.detail';
import { getCompanyId } from '@blue/services/session';

/**
 * Model which represents the financial-period-tabs.component inputs packed into the model.
 */
class FinancialPeriodTabsModel {
    constructor(tabsetType, hasAccounting, hasFixedAssets, hasFirm) {
        this.tabsetType = tabsetType;
        this.hasAccounting = hasAccounting;
        this.hasFixedAssets = hasFixedAssets;
        this.hasFirm = hasFirm;
    }
}

var ContactsActionTypes;
(function (ContactsActionTypes) {
    ContactsActionTypes["LoadContacts"] = "[BMPP Contacts] Load Contacts";
    ContactsActionTypes["LoadContactsSuccess"] = "[BMPP Contacts] Load Contacts Success";
    ContactsActionTypes["LoadContactsFailure"] = "[BMPP Contacts] Load Contacts Failure";
    ContactsActionTypes["LoadContact"] = "[BMPP Contacts] Load Contact";
    ContactsActionTypes["LoadContactSuccess"] = "[BMPP Contacts] Load Contact Success";
    ContactsActionTypes["LoadContactFailure"] = "[BMPP Contacts] Load Contact Failure";
    ContactsActionTypes["SetContacts"] = "[BMPP Contacts] Set Contacts";
    ContactsActionTypes["SetSelectedContact"] = "[BMPP Contacts] Set Selected Contact";
})(ContactsActionTypes || (ContactsActionTypes = {}));
class LoadContacts {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContacts;
    }
}
class LoadContactsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContactsSuccess;
    }
}
class LoadContactsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContactsFailure;
    }
}
class LoadContact {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContact;
    }
}
class LoadContactSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContactSuccess;
    }
}
class LoadContactFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.LoadContactFailure;
    }
}
class SetContacts {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.SetContacts;
    }
}
class SetSelectedContact {
    constructor(payload) {
        this.payload = payload;
        this.type = ContactsActionTypes.SetSelectedContact;
    }
}

var FiscalYearActionTypes;
(function (FiscalYearActionTypes) {
    FiscalYearActionTypes["LoadFiscalYears"] = "[BMPP FiscalYear] Load FiscalYears";
    FiscalYearActionTypes["LoadFiscalYearsSuccess"] = "[BMPP FiscalYear] Load FiscalYears Success";
    FiscalYearActionTypes["LoadFiscalYearsFailure"] = "[BMPP FiscalYear] Load FiscalYears Failure";
    FiscalYearActionTypes["SetSelectedFiscalYear"] = "[BMPP FiscalYear] Set Selected Fiscal Year";
    FiscalYearActionTypes["AddNewFiscalYear"] = "[BMPP FiscalYear] Add New Fiscal Year";
    FiscalYearActionTypes["AddNewFiscalYearSuccess"] = "[BMPP FiscalYear] Add New Fiscal Year Success";
    FiscalYearActionTypes["AddNewFiscalYearFailure"] = "[BMPP FiscalYear] Add New Fiscal Year Failure";
    FiscalYearActionTypes["UpdateFiscalYear"] = "[BMPP FiscalYear] Update Fiscal Year";
    FiscalYearActionTypes["UpdateFiscalYearSuccess"] = "[BMPP FiscalYear] Update Fiscal Year Success";
    FiscalYearActionTypes["UpdateFiscalYearFailure"] = "[BMPP FiscalYear] Update Fiscal Year Failure";
    FiscalYearActionTypes["UpdateFiscalYearFrequencyType"] = "[BMPP FiscalYear] Update Fiscal Year Frequency Type";
    FiscalYearActionTypes["UpdateFiscalYearFrequencyTypeSuccess"] = "[BMPP FiscalYear] Update Fiscal Year Frequency Type Success";
    FiscalYearActionTypes["UpdateFiscalYearFrequencyTypeFailure"] = "[BMPP FiscalYear] Update Fiscal Year Frequency Type Failure";
    FiscalYearActionTypes["UpdateFiscalYearPeriods"] = "[BMPP FiscalYear] Update Fiscal Year Periods";
    FiscalYearActionTypes["UpdateFiscalYearPeriodsSuccess"] = "[BMPP FiscalYear] Update Fiscal Year Periods Success";
    FiscalYearActionTypes["UpdateFiscalYearPeriodsFailure"] = "[BMPP FiscalYear] Update Fiscal Year Periods Failure";
    FiscalYearActionTypes["UpdateFiscalYearPeriodsYearEndCloseFailure"] = "[BMPP FiscalYear] Update Fiscal Year Periods Year End Close Failure";
    FiscalYearActionTypes["UpdateFiscalYearMappedPeriods"] = "[BMPP FiscalYear] Update Fiscal Year Mapped Periods";
    FiscalYearActionTypes["UpdateFiscalYearMappedPeriodsSuccess"] = "[BMPP FiscalYear] Update Fiscal Year Mapped Periods Success";
    FiscalYearActionTypes["UpdateFiscalYearMappedPeriodsFailure"] = "[BMPP FiscalYear] Update Fiscal Year Mapped Periods Failure";
    FiscalYearActionTypes["SetEditedFiscalYear"] = "[BMPP FiscalYear] Set New Fiscal Year";
    FiscalYearActionTypes["SetTaxCodeYear"] = "[BMPP FiscalYear] Set Tax Code Year";
    FiscalYearActionTypes["SetEditedFiscalYearDate"] = "[BMPP FiscalYear] Set Edited Fiscal Year Date";
    FiscalYearActionTypes["SetEditedFiscalYearValidationFailed"] = "[BMPP FiscalYear] Set Edited Fiscal Year Validation Failed";
    FiscalYearActionTypes["ResetEditedFiscalYear"] = "[BMPP FiscalYear] Reset Edited Fiscal Year";
    FiscalYearActionTypes["SetCurrentPeriodType"] = "[BMPP FiscalYear] Set Current Period Type";
    FiscalYearActionTypes["ResetAddFiscalYear"] = "[BMPP FiscalYear] Reset Add Fiscal Year";
    FiscalYearActionTypes["LoadAccountActivity"] = "[BMPP FiscalYear] Get Account Activty For Owner";
    FiscalYearActionTypes["LoadAccountActivitySuccess"] = "[BMPP FiscalYear] Get Account Activty For Owner Success";
    FiscalYearActionTypes["LoadAccountActivityFailure"] = "[BMPP FiscalYear] Get Account Activty For Owner Failure";
    FiscalYearActionTypes["UpdateMultipleFiscalYear"] = "[BMPP FiscalYear] Update Multiple Fiscal Year";
    FiscalYearActionTypes["UpdateMultipleFiscalYearSuccess"] = "[BMPP FiscalYear] Update Multiple Fiscal Year Success";
    FiscalYearActionTypes["UpdateMultipleFiscalYearFailure"] = "[BMPP FiscalYear] Update Multiple Fiscal Year Failure";
})(FiscalYearActionTypes || (FiscalYearActionTypes = {}));
/**
 * To load fiscal years connected to ownerId
 */
class LoadFiscalYears {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYears;
    }
}
/**
 * When fiscal years, sent in data property, successfully loaded
 */
class LoadFiscalYearsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsSuccess;
    }
}
/**
 * Loading of fiscal years failed
 */
class LoadFiscalYearsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsFailure;
    }
}
/**
 * Sets chosen fiscal year from the dropdown
 */
class SetSelectedFiscalYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetSelectedFiscalYear;
    }
}
/**
 * Adds new fiscal year
 */
class AddNewFiscalYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.AddNewFiscalYear;
    }
}
/**
 * Add new fiscal year succeeeded
 */
class AddNewFiscalYearSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.AddNewFiscalYearSuccess;
    }
}
/**
 * Add new fiscal year failed
 */
class AddNewFiscalYearFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.AddNewFiscalYearFailure;
    }
}
/**
 * Update fiscal year
 */
class UpdateFiscalYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYear;
    }
}
/**
 * Update fiscal year succeeeded
 */
class UpdateFiscalYearSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearSuccess;
    }
}
/**
 * Update fiscal year failed
 */
class UpdateFiscalYearFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearFailure;
    }
}
/**
 * Update fiscal year frequency type
 */
class UpdateFiscalYearFrequencyType {
    constructor() {
        this.type = FiscalYearActionTypes.UpdateFiscalYearFrequencyType;
    }
}
/**
 * Update fiscal year frequency type succeeeded
 */
class UpdateFiscalYearFrequencyTypeSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeSuccess;
    }
}
/**
 * Update fiscal year frequency type failed
 */
class UpdateFiscalYearFrequencyTypeFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeFailure;
    }
}
/**
 * Update fiscal year periods
 */
class UpdateFiscalYearPeriods {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearPeriods;
    }
}
/**
 * Update fiscal year periods succeeeded
 */
class UpdateFiscalYearPeriodsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearPeriodsSuccess;
    }
}
/**
 * Update fiscal year periods failed
 */
class UpdateFiscalYearPeriodsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearPeriodsFailure;
    }
}
/**
 * Update fiscal year periods failed due to year end close error
 */
class UpdateFiscalYearPeriodsYearEndCloseFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearPeriodsYearEndCloseFailure;
    }
}
/**
 * Update fiscal year with the mapped periods.
 * The `mappedPeriods` array should alredy contain the old periods
 * with set up `mappingId` and `isDeleted` flag,
 * and also should contain the new periods.
 */
class UpdateFiscalYearMappedPeriods {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearMappedPeriods;
    }
}
/**
 * Update fiscal year with the mapped periods succeeded.
 */
class UpdateFiscalYearMappedPeriodsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess;
    }
}
/**
 * Update fiscal year with the mapped periods failed.
 */
class UpdateFiscalYearMappedPeriodsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsFailure;
    }
}
/**
 * Sets fiscal year to add/edit
 */
class SetEditedFiscalYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetEditedFiscalYear;
    }
}
/**
 * Sets start and end date of added/edited fiscal year
 */
class SetEditedFiscalYearDate {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetEditedFiscalYearDate;
    }
}
/**
 * Sets edited fiscal year validation failed
 */
class SetEditedFiscalYearValidationFailed {
    constructor() {
        this.type = FiscalYearActionTypes.SetEditedFiscalYearValidationFailed;
    }
}
/**
 * sets selected tax code year for added/edited fiscal year
 */
class SetTaxCodeYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetTaxCodeYear;
    }
}
/**
 * Resets edited fiscal year, selected tax year and validation in store
 */
class ResetEditedFiscalYear {
    constructor() {
        this.type = FiscalYearActionTypes.ResetEditedFiscalYear;
    }
}
/**
 * Resets add fiscal year in store
 */
class ResetAddFiscalYear {
    constructor() {
        this.type = FiscalYearActionTypes.ResetAddFiscalYear;
    }
}
/**
 * Sets current period type when switch between tabs
 */
class SetCurrentPeriodType {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetCurrentPeriodType;
    }
}
/**
 * LoadAccountActivity for ownerId
 */
class LoadAccountActivity {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadAccountActivity;
    }
}
/**
 * When LoadAccountActivity successfully loaded
 */
class LoadAccountActivitySuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadAccountActivitySuccess;
    }
}
/**
 * When LoadAccountActivity failed
 */
class LoadAccountActivityFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadAccountActivityFailure;
    }
}
/**
 * Update multiple fiscal year
 */
class UpdateMultipleFiscalYear {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateMultipleFiscalYear;
    }
}
/**
 * Update multiple fiscal year succeeeded
 */
class UpdateMultipleFiscalYearSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateMultipleFiscalYearSuccess;
    }
}
/**
 * Update multiple fiscal year failed
 */
class UpdateMultipleFiscalYearFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.UpdateMultipleFiscalYearFailure;
    }
}

var ResetStoreActionTypes;
(function (ResetStoreActionTypes) {
    ResetStoreActionTypes["ResetStore"] = "[BMPP RESET] Reset Store";
})(ResetStoreActionTypes || (ResetStoreActionTypes = {}));
// Clears the entriety of the state
class ResetStore {
    constructor() {
        this.type = ResetStoreActionTypes.ResetStore;
    }
}

var TabsetTypes;
(function (TabsetTypes) {
    TabsetTypes["Pills"] = "pills";
    TabsetTypes["Tabs"] = "tabs";
})(TabsetTypes || (TabsetTypes = {}));

const INVALID_FORMAT_MSG = 'bmpp.ng.common.date.wrongFormat';
const INVALID_DATES_ORDER_MSG = 'bmpp.ng.addFiscalYearError.beginBeforeEnd';
const FISCAL_YEAR_DATES_HAVE_GAPS_MSG = 'bmpp.ng.addFiscalYearError.noGaps';
const FISCAL_YEAR_DATES_OVERLAP_MSG = 'bmpp.ng.addFiscalYearError.noOverlap';
const INVALID_GRID_FORMAT_MSG = 'bmpp.ng.common.grid.date.wrongFormat';
const INVALID_TAXYEAR_SELECTION_MSG = 'bmpp.ng.client.taxYearRequired';

var AlertsActionTypes;
(function (AlertsActionTypes) {
    AlertsActionTypes["AddAlert"] = "[BMPP Alert] Add Alert";
    AlertsActionTypes["RemoveAlert"] = "[BMPP Alert] Remove Alert";
})(AlertsActionTypes || (AlertsActionTypes = {}));
class AddAlert {
    constructor(payload) {
        this.payload = payload;
        this.type = AlertsActionTypes.AddAlert;
    }
}
class RemoveAlert {
    constructor(payload) {
        this.payload = payload;
        this.type = AlertsActionTypes.RemoveAlert;
    }
}

const AlertsFeatureKey = 'AlertsState';
const initialAlertsState = {
    addedAlert: undefined,
    removedAlert: undefined,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$9(state = initialAlertsState, action) {
    switch (action.type) {
        case AlertsActionTypes.AddAlert:
            return Object.assign(Object.assign({}, state), { addedAlert: action.payload.alert });
        case AlertsActionTypes.RemoveAlert:
            return Object.assign(Object.assign({}, state), { removedAlert: action.payload.alert });
        default:
            return state;
    }
}

const fiscalYearFeatureKey = 'fiscalYearState';
const initialState$2 = {
    fiscalYears: [],
    updatedFiscalYear: undefined,
    fiscalYearsLoading: false,
    fiscalYearsLoaded: false,
    fiscalYearsLoadingFailed: false,
    selectedFiscalYear: undefined,
    newFiscalYearAdding: false,
    newFiscalYearAdded: false,
    newFiscalYearAddFailed: false,
    fiscalYearUpdateFailed: false,
    fiscalYearUpdated: false,
    fiscalYearUpdating: false,
    fiscalYearFrequencyTypeUpdating: false,
    fiscalYearFrequencyTypeUpdated: false,
    fiscalYearFrequencyTypeUpdateFailed: false,
    fiscalYearPeriodsUpdateFailed: false,
    fiscalYearPeriodsUpdated: false,
    fiscalYearPeriodsUpdating: false,
    editedFiscalYearValidationFailed: false,
    newlyAddedFiscalYear: undefined,
    hasAccounts: undefined,
    hasAccountsLoadingFailed: false,
    hasAccountsLoaded: false,
    hasAccountsLoading: false,
    multipleFiscalYearUpdated: false,
    multipleFiscalYearUpdateFailed: false,
    multipleFiscalYearUpdating: false,
};
function reducer$8(state = initialState$2, action) {
    var _a;
    switch (action.type) {
        case FiscalYearActionTypes.LoadFiscalYears:
            return Object.assign(Object.assign({}, state), { fiscalYears: [], fiscalYearsLoading: true, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: false, selectedFiscalYear: undefined });
        case FiscalYearActionTypes.LoadFiscalYearsSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYears: action.payload.data, fiscalYearsLoading: false, fiscalYearsLoaded: true, fiscalYearsLoadingFailed: false, selectedFiscalYear: undefined });
        case FiscalYearActionTypes.LoadFiscalYearsFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearsLoading: false, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: true, selectedFiscalYear: undefined });
        case FiscalYearActionTypes.SetSelectedFiscalYear:
            return Object.assign(Object.assign({}, state), { selectedFiscalYear: action.payload.fiscalYear });
        case FiscalYearActionTypes.AddNewFiscalYear:
            return Object.assign(Object.assign({}, state), { newFiscalYearAdding: true, newFiscalYearAdded: false, newFiscalYearAddFailed: false });
        case FiscalYearActionTypes.AddNewFiscalYearSuccess:
            return Object.assign(Object.assign({}, state), { newlyAddedFiscalYear: action.payload.fiscalYear, newFiscalYearAdding: false, newFiscalYearAdded: true, newFiscalYearAddFailed: false });
        case FiscalYearActionTypes.AddNewFiscalYearFailure:
            return Object.assign(Object.assign({}, state), { newFiscalYearAdding: false, newFiscalYearAdded: false, newFiscalYearAddFailed: true });
        case FiscalYearActionTypes.UpdateFiscalYear:
            return Object.assign(Object.assign({}, state), { fiscalYearUpdating: true, fiscalYearUpdated: false, fiscalYearUpdateFailed: false });
        case FiscalYearActionTypes.UpdateFiscalYearSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYearUpdating: false, fiscalYearUpdated: true, fiscalYearUpdateFailed: false });
        case FiscalYearActionTypes.UpdateFiscalYearFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearUpdating: false, fiscalYearUpdated: false, fiscalYearUpdateFailed: true });
        case FiscalYearActionTypes.UpdateFiscalYearFrequencyType:
            return Object.assign(Object.assign({}, state), { fiscalYearFrequencyTypeUpdating: true, fiscalYearFrequencyTypeUpdated: false, fiscalYearFrequencyTypeUpdateFailed: false });
        case FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYearFrequencyTypeUpdating: false, fiscalYearFrequencyTypeUpdated: true, fiscalYearFrequencyTypeUpdateFailed: false });
        case FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearFrequencyTypeUpdating: false, fiscalYearFrequencyTypeUpdated: false, fiscalYearFrequencyTypeUpdateFailed: true });
        case FiscalYearActionTypes.UpdateFiscalYearPeriods: {
            const selectedPeriod = action.payload.selectedPeriod;
            const fiscalYear = action.payload.fiscalYear;
            const updatedPeriods = (_a = fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.map(period => period.id === (selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.id)
                ? Object.assign(Object.assign({}, period), { isCurrentPeriod: true }) : period.isCurrentPeriod && period.periodType === (selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.periodType)
                ? Object.assign(Object.assign({}, period), { isCurrentPeriod: false }) : period);
            return Object.assign(Object.assign({}, state), { updatedFiscalYear: Object.assign(Object.assign({}, fiscalYear), { periods: updatedPeriods }), fiscalYearPeriodsUpdateFailed: false, fiscalYearPeriodsUpdated: false, fiscalYearPeriodsUpdating: true });
        }
        case FiscalYearActionTypes.UpdateFiscalYearPeriodsSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYearPeriodsUpdateFailed: false, fiscalYearPeriodsUpdated: true, fiscalYearPeriodsUpdating: false });
        case FiscalYearActionTypes.UpdateFiscalYearMappedPeriods:
            return Object.assign(Object.assign({}, state), { fiscalYearPeriodsUpdateFailed: false, fiscalYearPeriodsUpdated: false, fiscalYearPeriodsUpdating: true });
        case FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess:
            return Object.assign(Object.assign({}, state), { selectedFiscalYear: action.payload.fiscalYear, fiscalYearPeriodsUpdateFailed: false, fiscalYearPeriodsUpdated: true, fiscalYearPeriodsUpdating: false });
        case FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearPeriodsUpdateFailed: true, fiscalYearPeriodsUpdated: false, fiscalYearPeriodsUpdating: false });
        case FiscalYearActionTypes.UpdateFiscalYearPeriodsFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearPeriodsUpdateFailed: true, fiscalYearPeriodsUpdated: false, fiscalYearPeriodsUpdating: false });
        case FiscalYearActionTypes.UpdateFiscalYearPeriodsYearEndCloseFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearPeriodsUpdateFailed: true, fiscalYearPeriodsUpdated: false, fiscalYearPeriodsUpdating: false });
        case FiscalYearActionTypes.SetEditedFiscalYear:
            return Object.assign(Object.assign({}, state), { editedFiscalYearValidationFailed: false, editedFiscalYear: action.payload.fiscalYear });
        case FiscalYearActionTypes.SetEditedFiscalYearDate:
            return Object.assign(Object.assign({}, state), { editedFiscalYearValidationFailed: false, editedFiscalYear: Object.assign(Object.assign({}, state.editedFiscalYear), { startDate: action.payload.startDate, endDate: action.payload.endDate }) });
        case FiscalYearActionTypes.SetEditedFiscalYearValidationFailed:
            return Object.assign(Object.assign({}, state), { editedFiscalYearValidationFailed: true });
        case FiscalYearActionTypes.SetTaxCodeYear:
            return Object.assign(Object.assign({}, state), { selectedTaxCodeYear: action.payload.taxCodeYear });
        case FiscalYearActionTypes.ResetEditedFiscalYear:
            return Object.assign(Object.assign({}, state), { editedFiscalYear: undefined, editedFiscalYearValidationFailed: false, selectedTaxCodeYear: undefined });
        case FiscalYearActionTypes.ResetAddFiscalYear:
            return Object.assign(Object.assign({}, state), { newlyAddedFiscalYear: undefined });
        case FiscalYearActionTypes.SetCurrentPeriodType:
            return Object.assign(Object.assign({}, state), { currentPeriodType: action.payload.periodType });
        case FiscalYearActionTypes.LoadAccountActivity:
            return Object.assign(Object.assign({}, state), { hasAccounts: undefined, hasAccountsLoading: true, hasAccountsLoaded: false, hasAccountsLoadingFailed: false });
        case FiscalYearActionTypes.LoadAccountActivitySuccess:
            return Object.assign(Object.assign({}, state), { hasAccounts: action.payload.data, hasAccountsLoadingFailed: false, hasAccountsLoading: false, hasAccountsLoaded: true });
        case FiscalYearActionTypes.LoadAccountActivityFailure:
            return Object.assign(Object.assign({}, state), { hasAccounts: undefined, hasAccountsLoadingFailed: true, hasAccountsLoading: false, hasAccountsLoaded: false });
        case FiscalYearActionTypes.UpdateMultipleFiscalYear:
            return Object.assign(Object.assign({}, state), { multipleFiscalYearUpdating: true, multipleFiscalYearUpdated: false, multipleFiscalYearUpdateFailed: false });
        case FiscalYearActionTypes.UpdateMultipleFiscalYearSuccess:
            return Object.assign(Object.assign({}, state), { multipleFiscalYearUpdating: false, multipleFiscalYearUpdated: true, multipleFiscalYearUpdateFailed: false });
        case FiscalYearActionTypes.UpdateMultipleFiscalYearFailure:
            return Object.assign(Object.assign({}, state), { multipleFiscalYearUpdating: false, multipleFiscalYearUpdated: false, multipleFiscalYearUpdateFailed: true });
        default:
            return state;
    }
}

const ContactsFeatureKey = 'contactsState';
const initialContactsState = {
    contactsLoading: false,
    contactsLoaded: false,
    contactsLoadingFailed: false,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$7(state = initialContactsState, action) {
    switch (action.type) {
        case ContactsActionTypes.LoadContacts:
            return Object.assign(Object.assign({}, state), { contactsLoading: true, contactsLoaded: false, contactsLoadingFailed: false });
        case ContactsActionTypes.LoadContactsSuccess:
            return Object.assign(Object.assign({}, state), { contacts: action.payload.data, contactsLoading: false, contactsLoaded: true, contactsLoadingFailed: false });
        case ContactsActionTypes.LoadContactsFailure:
            return Object.assign(Object.assign({}, state), { contactsLoading: false, contactsLoaded: false, contactsLoadingFailed: true });
        case ContactsActionTypes.SetContacts:
            return Object.assign(Object.assign({}, state), { contacts: action.payload.contacts, contactsLoading: false, contactsLoaded: true, contactsLoadingFailed: false });
        case ContactsActionTypes.SetSelectedContact:
            return Object.assign(Object.assign({}, state), { selectedContact: action.payload.contact });
        default:
            return state;
    }
}

var EditPeriodsActionTypes;
(function (EditPeriodsActionTypes) {
    EditPeriodsActionTypes["LoadEditPeriodsState"] = "[BMPP EditPeriods] Load Edit Periods State";
    EditPeriodsActionTypes["LoadEditPeriodsStateSuccess"] = "[BMPP EditPeriods] Load Edit Periods State Success";
    EditPeriodsActionTypes["SetEditPeriodList"] = "[BMPP EditPeriods] Set Edit Period List";
    EditPeriodsActionTypes["SetNewPeriodList"] = "[BMPP EditPeriods] Set New Period List";
    EditPeriodsActionTypes["SetPeriodType"] = "[BMPP EditPeriods] Set Period Type";
    EditPeriodsActionTypes["SetCurrentPeriodsFrequency"] = "[BMPP EditPeriods] Set Current Periods Frequency";
    EditPeriodsActionTypes["SetSelectedPeriodsFrequency"] = "[BMPP EditPeriods] Set Selected Periods Frequency";
    EditPeriodsActionTypes["SetCustomPeriodsNumber"] = "[BMPP EditPeriods] Set Custom Periods Number";
    EditPeriodsActionTypes["SetEditPeriodsStateValidity"] = "[BMPP EditPeriods] Set Edit Periods State Validity";
    EditPeriodsActionTypes["ValidateCustomPeriodsNumber"] = "[BMPP EditPeriods] Validate Custom Periods Number";
    EditPeriodsActionTypes["CustomNumberValidationSuccess"] = "[BMPP EditPeriods] Custom Periods Number Validation Success";
    EditPeriodsActionTypes["CustomNumberValidationFailure"] = "[BMPP EditPeriods] Custom Periods Number Validation Failure";
    EditPeriodsActionTypes["CalculatePeriodsList"] = "[BMPP EditPeriods] Calculate Periods List";
    EditPeriodsActionTypes["UpdatePeriodDate"] = "[BMPP EditPeriods] Update Period Date";
    EditPeriodsActionTypes["ValidatePeriodDate"] = "[BMPP EditPeriods] Validate Period Date";
    EditPeriodsActionTypes["ValidatePeriodDateSuccess"] = "[BMPP EditPeriods] Validate Period Date Success";
    EditPeriodsActionTypes["ValidatePeriodDateFailure"] = "[BMPP EditPeriods] Validate Period Date Failure";
    EditPeriodsActionTypes["UpdatePeriodsDates"] = "[BMPP EditPeriods] Update Periods Dates";
    EditPeriodsActionTypes["ResetEditPeriodState"] = "[BMPP EditPeriods] Reset Edit Period State";
    EditPeriodsActionTypes["TriggerCustomPeriodsNumberValidation"] = "[BMPP EditPeriods] Trigger Custom Periods Number Validation";
    EditPeriodsActionTypes["MapPeriod"] = "[BMPP EditPeriods] Map Period";
    EditPeriodsActionTypes["MapPeriods"] = "[BMPP EditPeriods] Map Periods";
    EditPeriodsActionTypes["DiscardMapping"] = "[BMPP EditPeriods] Discard Mapping";
    EditPeriodsActionTypes["SavePeriodsMapping"] = "[BMPP EditPeriods] Save Periods Mapping";
})(EditPeriodsActionTypes || (EditPeriodsActionTypes = {}));
/**
 * To load and set up selected periods frequency and setup period type.
 */
class LoadEditPeriodsState {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.LoadEditPeriodsState;
    }
}
/**
 * To load and set up selected periods frequency and setup period type.
 */
class LoadEditPeriodsStateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.LoadEditPeriodsStateSuccess;
    }
}
/**
 * Sets period list to be edited
 */
class SetEditPeriodList {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetEditPeriodList;
    }
}
/**
 * Sets period list to be mapped to
 */
class SetNewPeriodList {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetNewPeriodList;
    }
}
/**
 * To set up periods type.
 */
class SetPeriodType {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetPeriodType;
    }
}
/**
 * To set up current periods frequency.
 */
class SetCurrentPeriodsFrequency {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetCurrentPeriodsFrequency;
    }
}
/**
 * To set up periods frequency.
 */
class SetSelectedPeriodsFrequency {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetSelectedPeriodsFrequency;
    }
}
/**
 * To set up custom periods number.
 */
class SetCustomPeriodsNumber {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetCustomPeriodsNumber;
    }
}
/**
 * To set up isValid property of the state.
 */
class SetEditPeriodsStateValidity {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.SetEditPeriodsStateValidity;
    }
}
/**
 * To validate the custom periods number.
 */
class ValidateCustomPeriodsNumber {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.ValidateCustomPeriodsNumber;
    }
}
/**
 * When periods custom number validation is succeeded.
 */
class CustomPeriodsNumberValidationSuccess {
    constructor() {
        this.type = EditPeriodsActionTypes.CustomNumberValidationSuccess;
    }
}
/**
 * When periods custom number validation is failed.
 */
class CustomPeriodsNumberValidationFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.CustomNumberValidationFailure;
    }
}
/**
 * To calculate periods list.
 */
class CalculatePeriodsList {
    constructor() {
        this.type = EditPeriodsActionTypes.CalculatePeriodsList;
    }
}
/**
 * To update period end date.
 */
class UpdatePeriodDate {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.UpdatePeriodDate;
    }
}
/**
 * To validate period end date.
 */
class ValidatePeriodDate {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.ValidatePeriodDate;
    }
}
/**
 * When period end date validation is succeeded.
 */
class ValidatePeriodDateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.ValidatePeriodDateSuccess;
    }
}
/**
 * When period end date validation is failed.
 */
class ValidatePeriodDateFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.ValidatePeriodDateFailure;
    }
}
/**
 * To update periods dates.
 */
class UpdatePeriodsDates {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.UpdatePeriodsDates;
    }
}
/**
 * Resets period list after canceling edit
 */
class ResetEditPeriodState {
    constructor() {
        this.type = EditPeriodsActionTypes.ResetEditPeriodState;
    }
}
/**
 * To trigger validation of the custom periods number.
 */
class TriggerCustomPeriodsNumberValidation {
    constructor() {
        this.type = EditPeriodsActionTypes.TriggerCustomPeriodsNumberValidation;
    }
}
/**
 * To map old period to new period manually
 */
class MapPeriod {
    constructor(payload) {
        this.payload = payload;
        this.type = EditPeriodsActionTypes.MapPeriod;
    }
}
/**
 * To map all old periods to the new
 */
class MapPeriods {
    constructor() {
        this.type = EditPeriodsActionTypes.MapPeriods;
    }
}
/**
 * Discards manual mapping of periods
 */
class DiscardMapping {
    constructor() {
        this.type = EditPeriodsActionTypes.DiscardMapping;
    }
}
/**
 * To save mapped periods
 */
class SavePeriodsMapping {
    constructor() {
        this.type = EditPeriodsActionTypes.SavePeriodsMapping;
    }
}

const initialState$1 = {
    periodType: undefined,
    currentPeriodsFrequency: undefined,
    selectedPeriodsFrequency: undefined,
    editPeriodList: [],
    newPeriodList: [],
    periodsValidations: [],
    customPeriodsNumber: undefined,
    customPeriodsNumberErrorMessage: undefined,
    // Due to requirements, initially, we are saying that our state is valid.
    // For more details, see here: https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2590311
    isValid: true,
};
function reducer$6(state = initialState$1, action) {
    switch (action.type) {
        case EditPeriodsActionTypes.LoadEditPeriodsStateSuccess:
            return Object.assign(Object.assign({}, state), { periodType: action.payload.periodType, currentPeriodsFrequency: action.payload.periodsFrequency, selectedPeriodsFrequency: action.payload.periodsFrequency, customPeriodsNumber: action.payload.customPeriodsNumber, editPeriodList: action.payload.periods });
        case EditPeriodsActionTypes.SetEditPeriodList:
            return Object.assign(Object.assign({}, state), { editPeriodList: action.payload.periods });
        case EditPeriodsActionTypes.SetNewPeriodList:
            return Object.assign(Object.assign({}, state), { newPeriodList: action.payload.periods });
        case EditPeriodsActionTypes.SetPeriodType:
            return Object.assign(Object.assign({}, state), { periodType: action.payload.periodType });
        case EditPeriodsActionTypes.SetCurrentPeriodsFrequency:
            return Object.assign(Object.assign({}, state), { currentPeriodsFrequency: action.payload.currentPeriodsFrequency });
        case EditPeriodsActionTypes.SetSelectedPeriodsFrequency:
            return Object.assign(Object.assign({}, state), { selectedPeriodsFrequency: action.payload.selectedPeriodsFrequency, periodsValidations: [], customPeriodsNumber: undefined, customPeriodsNumberErrorMessage: undefined });
        case EditPeriodsActionTypes.SetCustomPeriodsNumber:
            return Object.assign(Object.assign({}, state), { customPeriodsNumber: action.payload.customPeriodsNumber });
        case EditPeriodsActionTypes.SetEditPeriodsStateValidity:
            return Object.assign(Object.assign({}, state), { isValid: action.payload.isValid });
        case EditPeriodsActionTypes.CustomNumberValidationSuccess:
            return Object.assign(Object.assign({}, state), { customPeriodsNumberErrorMessage: undefined, isValid: true });
        case EditPeriodsActionTypes.CustomNumberValidationFailure:
            return Object.assign(Object.assign({}, state), { newPeriodList: [], customPeriodsNumberErrorMessage: action.payload.errorMessage, isValid: false });
        case EditPeriodsActionTypes.ResetEditPeriodState:
            return {
                periodType: undefined,
                currentPeriodsFrequency: undefined,
                selectedPeriodsFrequency: undefined,
                editPeriodList: [],
                newPeriodList: [],
                periodsValidations: [],
                customPeriodsNumber: undefined,
                customPeriodsNumberErrorMessage: undefined,
                isValid: true,
            };
        case EditPeriodsActionTypes.CalculatePeriodsList:
            return Object.assign(Object.assign({}, state), { isValid: true });
        case EditPeriodsActionTypes.ValidatePeriodDateSuccess: {
            const updatedPeriodsValidations = state.periodsValidations.filter(validation => validation.sequenceNumber !== action.payload.periodSequenceNumber);
            return Object.assign(Object.assign({}, state), { periodsValidations: updatedPeriodsValidations, isValid: true });
        }
        case EditPeriodsActionTypes.ValidatePeriodDateFailure:
            return Object.assign(Object.assign({}, state), { periodsValidations: [...state.periodsValidations, action.payload.validationResult], isValid: false });
        case EditPeriodsActionTypes.UpdatePeriodsDates:
            return Object.assign(Object.assign({}, state), { isValid: true });
        default:
            return state;
    }
}

var TransactionActionTypes;
(function (TransactionActionTypes) {
    TransactionActionTypes["GetTransactionCount"] = "[BMPP Transaction] Get Transaction Count";
    TransactionActionTypes["GetTransactionCountSuccess"] = "[BMPP Transaction] Get Transaction Count Success";
    TransactionActionTypes["GetTransactionCountFailure"] = "[BMPP Transaction] Get Transaction Count Failure";
})(TransactionActionTypes || (TransactionActionTypes = {}));
class GetTransactionCount {
    constructor(payload) {
        this.payload = payload;
        this.type = TransactionActionTypes.GetTransactionCount;
    }
}
class GetTransactionCountSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = TransactionActionTypes.GetTransactionCountSuccess;
    }
}
class GetTransactionCountFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = TransactionActionTypes.GetTransactionCountFailure;
    }
}

const TransactionFeatureKey = 'TransactionState';
const initialTransactionState = {
    transactionLoading: false,
    transactionLoaded: false,
    transactionLoadingFailed: false,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$5(state = initialTransactionState, action) {
    switch (action.type) {
        case TransactionActionTypes.GetTransactionCount:
            return Object.assign(Object.assign({}, state), { transactionLoading: true, transactionLoaded: false, transactionLoadingFailed: false });
        case TransactionActionTypes.GetTransactionCountSuccess:
            return Object.assign(Object.assign({}, state), { transactionCount: action.payload.data, transactionLoading: false, transactionLoaded: true, transactionLoadingFailed: false });
        case TransactionActionTypes.GetTransactionCountFailure:
            return Object.assign(Object.assign({}, state), { transactionLoading: false, transactionLoaded: false, transactionLoadingFailed: true });
        default:
            return state;
    }
}

var PeriodsSettingsActionTypes;
(function (PeriodsSettingsActionTypes) {
    PeriodsSettingsActionTypes["SetPeriodsSettings"] = "[BMPP PeriodsSettings] Set PeriodsSettings Settings";
})(PeriodsSettingsActionTypes || (PeriodsSettingsActionTypes = {}));
class SetPeriodsSettings {
    constructor(payload) {
        this.payload = payload;
        this.type = PeriodsSettingsActionTypes.SetPeriodsSettings;
    }
}

const initialPeriodsSettingsState = {
    showRelatedContacts: undefined,
    isFirmClient: false,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$4(state = initialPeriodsSettingsState, action) {
    switch (action.type) {
        case PeriodsSettingsActionTypes.SetPeriodsSettings:
            return Object.assign(Object.assign({}, state), { isFirmClient: action.payload.isFirmClient, showRelatedContacts: action.payload.showRelatedContacts });
        default:
            return state;
    }
}

var CompanyActionTypes;
(function (CompanyActionTypes) {
    CompanyActionTypes["LoadCompanyClient"] = "[BMPP Company] Load Company Client";
    CompanyActionTypes["LoadCompanyClientSuccess"] = "[BMPP Company] Load Company Client Success";
    CompanyActionTypes["LoadCompanyClientFailure"] = "[BMPP Company] Load Company Client Failure";
})(CompanyActionTypes || (CompanyActionTypes = {}));
class LoadCompanyClient {
    constructor() {
        this.type = CompanyActionTypes.LoadCompanyClient;
    }
}
class LoadCompanyClientSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = CompanyActionTypes.LoadCompanyClientSuccess;
    }
}
class LoadCompanyClientFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = CompanyActionTypes.LoadCompanyClientFailure;
    }
}

const CompanyFeatureKey = 'CompanyState';
const initialCompanyState = {
    companyClient: undefined,
    companyClientLoading: false,
    companyClientLoaded: false,
    companyClientLoadingFailed: false,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$3(state = initialCompanyState, action) {
    switch (action.type) {
        case CompanyActionTypes.LoadCompanyClient:
            return Object.assign(Object.assign({}, state), { companyClientLoading: true, companyClientLoaded: false, companyClientLoadingFailed: false });
        case CompanyActionTypes.LoadCompanyClientSuccess:
            return Object.assign(Object.assign({}, state), { companyClient: action.payload.data, companyClientLoading: false, companyClientLoaded: true, companyClientLoadingFailed: false });
        case CompanyActionTypes.LoadCompanyClientFailure:
            return Object.assign(Object.assign({}, state), { companyClientLoading: false, companyClientLoaded: false, companyClientLoadingFailed: true });
        default:
            return state;
    }
}

var AccountsTotalActionTypes;
(function (AccountsTotalActionTypes) {
    AccountsTotalActionTypes["LoadAccountsTotal"] = "[BMPP Accounts Total] Load Accounts Total";
    AccountsTotalActionTypes["LoadAccountsTotalSuccess"] = "[BMPP Accounts Total] Load Accounts Total Success";
    AccountsTotalActionTypes["LoadAccountsTotalFailure"] = "[BMPP Accounts Total] Load Accounts Total Failure";
    AccountsTotalActionTypes["LoadAccountBalanceTypeService"] = "[BMPP Load Balance Type] Load Balance Type Service";
})(AccountsTotalActionTypes || (AccountsTotalActionTypes = {}));
class LoadAccountsTotal {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountsTotalActionTypes.LoadAccountsTotal;
    }
}
class LoadAccountsTotalSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountsTotalActionTypes.LoadAccountsTotalSuccess;
    }
}
class LoadAccountsTotalFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountsTotalActionTypes.LoadAccountsTotalFailure;
    }
}
class LoadAccountBalanceTypeService {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountsTotalActionTypes.LoadAccountBalanceTypeService;
    }
}

const initialAccountState$1 = {
    accountBalance: undefined,
    accountTotalLoading: undefined,
    accountTotalLoaded: undefined,
    accountTotalLoadingFailed: undefined,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$2(state = initialAccountState$1, action) {
    switch (action.type) {
        case AccountsTotalActionTypes.LoadAccountsTotal:
            return Object.assign(Object.assign({}, state), { accountTotalLoading: true, accountTotalLoaded: undefined, accountTotalLoadingFailed: false });
        case AccountsTotalActionTypes.LoadAccountsTotalSuccess:
            return Object.assign(Object.assign({}, state), { accountBalance: action.payload.data, accountTotalLoading: false, accountTotalLoaded: true, accountTotalLoadingFailed: false });
        case AccountsTotalActionTypes.LoadAccountsTotalFailure:
            return Object.assign(Object.assign({}, state), { accountTotalLoading: false, accountTotalLoaded: false, accountTotalLoadingFailed: true });
        case AccountsTotalActionTypes.LoadAccountBalanceTypeService:
            return Object.assign(Object.assign({}, state), { accountTotalLoading: true, accountTotalLoaded: undefined, accountTotalLoadingFailed: false });
        default:
            return state;
    }
}

var AccountGroupActionTypes;
(function (AccountGroupActionTypes) {
    AccountGroupActionTypes["LoadAccountGroup"] = "[BMPP Load Grouping Accounts] Load Grouping Accounts";
    AccountGroupActionTypes["LoadAccountGroupSuccess"] = "[BMPP Load Grouping Accounts] Load Grouping Accounts Success";
    AccountGroupActionTypes["LoadAccountGroupFailure"] = "[BMPP Load Grouping Accounts] Load Grouping Accounts Failure";
    AccountGroupActionTypes["LoadAccountGroupService"] = "[BMPP Load Grouping Accounts] Load Account Group Service";
})(AccountGroupActionTypes || (AccountGroupActionTypes = {}));
class LoadAccountGroup {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroup;
    }
}
class LoadAccountGroupSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroupSuccess;
    }
}
class LoadAccountGroupFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroupFailure;
    }
}
class LoadAccountGroupService {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroupService;
    }
}

const initialAccountState = {
    ungroupedAccounts: undefined,
    ungroupedAccountsLoading: false,
    ungroupedAccountsLoaded: undefined,
    ungroupedAccountsLoadingFailed: false,
};
/**
 * Updates the state based on the action and its payload
 */
function reducer$1(state = initialAccountState, action) {
    switch (action.type) {
        case AccountGroupActionTypes.LoadAccountGroupSuccess:
            return Object.assign(Object.assign({}, state), { ungroupedAccounts: action.payload.data, ungroupedAccountsLoading: false, ungroupedAccountsLoaded: true, ungroupedAccountsLoadingFailed: false });
        case AccountGroupActionTypes.LoadAccountGroupFailure:
            return Object.assign(Object.assign({}, state), { ungroupedAccountsLoading: false, ungroupedAccountsLoaded: false, ungroupedAccountsLoadingFailed: true });
        case AccountGroupActionTypes.LoadAccountGroupService:
            return Object.assign(Object.assign({}, state), { ungroupedAccountsLoading: true, ungroupedAccountsLoaded: undefined, ungroupedAccountsLoadingFailed: false });
        case AccountGroupActionTypes.LoadAccountGroup:
            return Object.assign(Object.assign({}, state), { ungroupedAccountsLoading: true, ungroupedAccountsLoaded: undefined, ungroupedAccountsLoadingFailed: false });
        default:
            return state;
    }
}

var LoadIacTypes;
(function (LoadIacTypes) {
    LoadIacTypes["LoadIac"] = "[BMPP IAC] Load Iac";
    LoadIacTypes["LoadIacSuccess"] = "[BMPP IAC] Load Iac Success";
    LoadIacTypes["LoadIacFailure"] = "[BMPP IAC] Load Iac Failure";
})(LoadIacTypes || (LoadIacTypes = {}));
/**
 * * NGRX Action to load the iac
 */
class LoadIac {
    constructor() {
        this.type = LoadIacTypes.LoadIac;
    }
}
/**
 * NGRX Action for when the iac is successfully loaded
 */
class LoadIacSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LoadIacTypes.LoadIacSuccess;
    }
}
/**
 * NGRX Action for when the loading of the iac fails
 */
class LoadIacFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = LoadIacTypes.LoadIacFailure;
    }
}

const initialState = {
    iac: undefined,
    iacIsLoading: false,
    iacIsLoaded: false,
    iacLoadingFailed: false,
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case LoadIacTypes.LoadIac:
            return Object.assign(Object.assign({}, state), { iac: undefined, iacIsLoading: true, iacIsLoaded: false, iacLoadingFailed: false });
        case LoadIacTypes.LoadIacSuccess: {
            return Object.assign(Object.assign({}, state), { iac: action.payload.iacs, iacIsLoading: false, iacIsLoaded: true, iacLoadingFailed: false });
        }
        case LoadIacTypes.LoadIacFailure: {
            return Object.assign(Object.assign({}, state), { iacIsLoading: false, iacIsLoaded: false, iacLoadingFailed: true });
        }
        default:
            return state;
    }
}

const periodsStateFeatureKey = 'periodsState';
const reducers = {
    accountsTotalState: reducer$2,
    alertsState: reducer$9,
    fiscalYearState: reducer$8,
    contactsState: reducer$7,
    editPeriodsState: reducer$6,
    transactionState: reducer$5,
    companyState: reducer$3,
    periodsSettingsState: reducer$4,
    accountGroupState: reducer$1,
    iacState: reducer,
};
function clearState(reducer) {
    return (state, action) => {
        if (action.type === ResetStoreActionTypes.ResetStore) {
            state = undefined;
        }
        return reducer(state, action);
    };
}
const metaReducers = [clearState];
const getPeriodsState = createFeatureSelector(periodsStateFeatureKey);

const periodFrequencies = [
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.annual',
        value: 1,
        frequencyType: FrequencyType.Annual,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.monthly',
        value: 12,
        frequencyType: FrequencyType.Monthly,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.quarterly',
        value: 4,
        frequencyType: FrequencyType.Quarterly,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.weekly',
        value: 52,
        frequencyType: FrequencyType.Weekly,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.thirteenPeriods',
        value: 13,
        frequencyType: FrequencyType.ThirteenPeriods,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.semiAnnual',
        value: 2,
        frequencyType: FrequencyType.SemiAnnual,
    },
    {
        display: 'bmpp.ng.fiscal.year.periodFrequency.custom',
        value: 0,
        frequencyType: FrequencyType.Custom,
    },
];

/**
 * Get fiscal year state
 */
const getFiscalYearState = createSelector(getPeriodsState, (state) => state.fiscalYearState);
/**
 * Get fiscal years
 */
const getFiscalYears = createSelector(getFiscalYearState, (state) => state.fiscalYears);
/**
 * Get the fiscal year periods updated
 */
const getFiscalYearPeriodsUpdated = createSelector(getFiscalYearState, (state) => state.fiscalYearPeriodsUpdated);
/**
 * Get fiscal years in descending order
 */
const getFiscalYearsInDescendingOrder = createSelector(getFiscalYears, (years) => {
    if ((years === null || years === void 0 ? void 0 : years.length) > 0) {
        const fiscalYears = [...years];
        return fiscalYears.sort((y1, y2) => y2.sequenceNumber - y1.sequenceNumber);
    }
});
/**
 * Get fiscal years loading
 */
const getFiscalYearsLoading = createSelector(getFiscalYearState, (state) => state.fiscalYearsLoading);
/**
 * Get fiscal years loaded
 */
const getFiscalYearsLoaded = createSelector(getFiscalYearState, (state) => state.fiscalYearsLoaded);
/**
 * Get new fiscal years adding
 */
const getNewFiscalYearAdding = createSelector(getFiscalYearState, (state) => state.newFiscalYearAdding);
/**
 * Get new fiscal years added successfully
 */
const newFiscalYearAdded = createSelector(getFiscalYearState, (state) => state.newFiscalYearAdded);
/**
 * Get new fiscal years add falied
 */
const getNewFiscalYearAddFailed = createSelector(getFiscalYearState, (state) => state.newFiscalYearAddFailed);
/**
 * Get fiscal years loading failed
 */
const getFiscalYearsLoadingFailed = createSelector(getFiscalYearState, (state) => state.fiscalYearsLoadingFailed);
/**
 * Get updated fiscal year
 */
const getUpdatedFiscalYear = createSelector(getFiscalYearState, (state) => state.updatedFiscalYear);
/**
 * Get fiscal year by id
 */
const getFiscalYearById = (fiscalYearId) => createSelector(getFiscalYears, (years) => years.find(year => year.id === fiscalYearId));
/**
 * Returns the fiscal years that are eligible for the current period dropdown
 */
const getEligibleFiscalYearIds = (currentPeriod) => createSelector(getFiscalYears, (years) => {
    const currentFiscalYear = years.find(year => year.id === currentPeriod.fiscalYearId);
    const eligibleYears = years.filter(year => year.sequenceNumber <= currentFiscalYear.sequenceNumber + 1);
    return eligibleYears.map(year => {
        return year.id;
    });
});
/**
 * Returns the tax code year for the current fiscal year.
 * Current fiscal year is defined as the year with the current period.
 */
const getCurrentTaxYear = createSelector(getFiscalYears, (years) => {
    // Find the fiscal year with a period that is set as the current period. Return the tax code year for that fiscal year
    const yearWithCurrentPeriod = years.find(year => (year === null || year === void 0 ? void 0 : year.periods) && year.periods.find(period => period.isCurrentPeriod) !== undefined);
    return yearWithCurrentPeriod === null || yearWithCurrentPeriod === void 0 ? void 0 : yearWithCurrentPeriod.taxCodeYear;
});
/**
 * Returns the fiscal year with a current period and specific period type
 * Period types: Accounting, Practice, FixedAssets
 */
const getCurrentFiscalYear = (periodType) => createSelector(getFiscalYears, (years) => years.find(year => { var _a; return ((_a = year === null || year === void 0 ? void 0 : year.periods) === null || _a === void 0 ? void 0 : _a.find(period => period.isCurrentPeriod && period.periodType === periodType)) !== undefined; }));
/**
 * Returns the fiscal year selected from dropdown options
 */
const getSelectedFiscalYear = createSelector(getFiscalYearState, (state) => state.selectedFiscalYear);
/**
 * Returns the current period of the current fiscal year by period type
 */
const getCurrentPeriod = (periodType) => createSelector(getCurrentFiscalYear(periodType), (fiscalYear) => fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods.find(period => period.isCurrentPeriod && period.periodType === periodType));
/**
 * Returns the period frequency info of the current fiscal year by period type
 */
const getFiscalYearPeriodFrequency = (periodType) => createSelector(getSelectedFiscalYear, (fiscalYear) => {
    if (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) {
        // gets the periods number for the application/period type
        const periodsCountOfPeriodType = fiscalYear.periods.filter(p => p.periodType === periodType).length;
        // sets default frequency type in case there is no periods for period type
        if (periodsCountOfPeriodType === 0) {
            return periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Annual);
        }
        // gets the frequency type depended on periods number
        const periodFrequency = periodFrequencies.find(frequency => frequency.value === periodsCountOfPeriodType);
        // if period frequencies have no predefined periods number
        // return custom frequency type
        if (periodFrequency === undefined) {
            return periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Custom);
        }
        return periodFrequency;
    }
});
/**
 * Returns the period list of the current fiscal year by period type
 */
const getPeriodList = (periodType) => createSelector(getSelectedFiscalYear, (fiscalYear) => {
    if (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) {
        return fiscalYear.periods
            .filter(period => period.periodType === periodType)
            .sort((p1, p2) => p1.sequenceNumber - p2.sequenceNumber);
    }
});
/**
 * Checks if taxYear already belongs for any fiscal year
 */
const isTaxYearUsed = (taxYear, editFiscalYearId) => createSelector(getFiscalYears, (fiscalYears) => Boolean(fiscalYears.find(year => year.taxCodeYear === taxYear && year.id !== editFiscalYearId)));
/**
 * Checks if new fiscal year is valid
 */
const isNewFiscalYearValid = (fiscalYear) => createSelector(getFiscalYears, (fiscalYears) => {
    var _a, _b;
    const { startDate, endDate } = fiscalYear;
    const fiscalYearsIntervalStart = (_a = fiscalYears[0]) === null || _a === void 0 ? void 0 : _a.startDate;
    const fiscalYearsIntervalEnd = (_b = fiscalYears[fiscalYears.length - 1]) === null || _b === void 0 ? void 0 : _b.endDate;
    let startDateErrorMsg;
    let endDateErrorMsg;
    // If we have added first fiscal year, we don't need any
    if (fiscalYears.length > 0) {
        // If start date after end date
        if (startDate > endDate) {
            startDateErrorMsg = INVALID_DATES_ORDER_MSG;
            endDateErrorMsg = INVALID_DATES_ORDER_MSG;
            // If start date before and end date after fiscal years interval
        }
        else if (startDate < fiscalYearsIntervalStart && endDate > fiscalYearsIntervalEnd) {
            startDateErrorMsg = FISCAL_YEAR_DATES_OVERLAP_MSG;
            endDateErrorMsg = FISCAL_YEAR_DATES_OVERLAP_MSG;
        }
        // If added year after all fiscal years years and presents a gap
        if (startDate > fiscalYearsIntervalEnd && startDate.getTime() !== addDays(fiscalYearsIntervalEnd, 1).getTime()) {
            startDateErrorMsg = FISCAL_YEAR_DATES_HAVE_GAPS_MSG;
            // If start date overlaps all fiscal years interval
        }
        else if (startDate <= fiscalYearsIntervalEnd && startDate >= fiscalYearsIntervalStart) {
            startDateErrorMsg = FISCAL_YEAR_DATES_OVERLAP_MSG;
        }
        // If added year before year after all fiscal years and presents a gap
        if (endDate < fiscalYearsIntervalStart && endDate.getTime() !== addDays(fiscalYearsIntervalStart, -1).getTime()) {
            endDateErrorMsg = FISCAL_YEAR_DATES_HAVE_GAPS_MSG;
            // If end date overlaps all fiscal years interval
        }
        else if (endDate >= fiscalYearsIntervalStart && endDate < fiscalYearsIntervalEnd) {
            endDateErrorMsg = FISCAL_YEAR_DATES_OVERLAP_MSG;
        }
    }
    return { invalid: Boolean(startDateErrorMsg || endDateErrorMsg), startDateErrorMsg, endDateErrorMsg };
});
/**
 * Checks if fiscal year is valid.
 * Returns boolean if fiscal year is invalid width message for start date control and end date control.
 */
const isEditFiscalYearValid = (fiscalYear) => createSelector(getFiscalYears, (fiscalYears) => {
    let startDateErrorMsg;
    let endDateErrorMsg;
    // Return if fiscal year is valid.
    if (fiscalYear.startDate < fiscalYear.endDate) {
        return { invalid: false };
    }
    // Selects the message if the start date is invalid.
    if (fiscalYear.sequenceNumber <= fiscalYears.length && fiscalYear.sequenceNumber === 1) {
        startDateErrorMsg = INVALID_DATES_ORDER_MSG;
    }
    // Selects the message if the end date is invalid.
    if (fiscalYear.sequenceNumber >= 1 && fiscalYear.sequenceNumber === fiscalYears.length) {
        endDateErrorMsg = INVALID_DATES_ORDER_MSG;
    }
    // Return a validation error. The error message is selected by the previous two IF.
    return { invalid: Boolean(startDateErrorMsg || endDateErrorMsg), startDateErrorMsg, endDateErrorMsg };
});
/**
 * Returns fiscal year to be added/edited.
 */
const getEditedFiscalYear = createSelector(getFiscalYearState, (state) => state.editedFiscalYear);
/**
 * Returns unused tax years among fiscal years and in interval of fiscal year.
 */
const getTaxYears = (startYear, endYear) => createSelector(getFiscalYears, getEditedFiscalYear, (fiscalYears, editedFiscalYear) => {
    // all assigned tax years except tax year of current edited fiscal year
    const usedTaxYears = fiscalYears
        .map(fiscalYear => fiscalYear.taxCodeYear)
        .filter(taxCodeYear => Boolean(taxCodeYear) && (editedFiscalYear === null || editedFiscalYear === void 0 ? void 0 : editedFiscalYear.taxCodeYear) !== taxCodeYear);
    // all possible tax years of edited fiscal year interval
    const taxYearsInInterval = [...Array(endYear - startYear + 1).keys()].map(key => startYear + key);
    // years in interval that are not used as tax years for other fiscal years
    const unusedTaxYearsInInterval = taxYearsInInterval.filter(taxYear => !usedTaxYears.includes(taxYear));
    // result of all unique and sorted unused tax years
    const taxYears = unusedTaxYearsInInterval
        .filter((value, index, array) => array.indexOf(value) === index)
        // sort ascending
        .sort((a, b) => a - b);
    return taxYears;
});
/**
 * Returns edited fiscal year validation
 */
const isEditedFiscalYearValidationFailed = createSelector(getFiscalYearState, (state) => state.editedFiscalYearValidationFailed);
/**
 * Gets selected tax year of edited fiscal year.
 */
const getSelectedTaxCodeYear = createSelector(getFiscalYearState, (state) => state.selectedTaxCodeYear);
/**
 * Gets current period type.
 */
const getCurrentPeriodType = createSelector(getFiscalYearState, (state) => state.currentPeriodType);
/**
 * Get fiscal year updating
 */
const getFiscalYearUpdating = createSelector(getFiscalYearState, (state) => state.fiscalYearUpdating);
/**
 * Get multiple fiscal year updating
 */
const getMultipleFiscalYearUpdating = createSelector(getFiscalYearState, (state) => state.multipleFiscalYearUpdating);
/**
 *  Return validation selector by dialog mode.
 */
const getValidationSelector = (editDialog, fiscalYear) => {
    return editDialog ? isEditFiscalYearValid(fiscalYear) : isNewFiscalYearValid(fiscalYear);
};
/**
 * Returns the newly added row
 */
const getNewlyAddedFiscalYear = createSelector(getFiscalYearState, (state) => state.newlyAddedFiscalYear);
/**
 * Get Account Activity
 */
const getAccountActivity = createSelector(getFiscalYearState, (state) => state.hasAccounts);
/**
 * Get Account Activity Failed
 */
const getAccountActivityFailed = createSelector(getFiscalYearState, (state) => state.hasAccountsLoadingFailed);
/**
 * Get Account Activity Loaded
 */
const getAccountActivityLoaded = createSelector(getFiscalYearState, (state) => state.hasAccountsLoaded);
/**
 * Get Account Activity Loading
 */
const getAccountActivityLoading = createSelector(getFiscalYearState, (state) => state.hasAccountsLoading);
/**
 * Returns the tax code year for the current fiscal year.
 * Current fiscal year is defined as the year with the current period.
 */
const getEditFiscalYearsGridData = createSelector(getFiscalYears, (years) => {
    return mapFiscalYearForGrid(years);
});
/**
 * Returns the all possible tax years between the start date and end dates.
 */
function getAllTaxYears(startYear, endYear) {
    // all possible tax years of edited fiscal year interval
    const taxYearsInInterval = [...Array(endYear - startYear + 1).keys()].map(key => startYear + key);
    // result of all unique and sorted  tax years
    const taxYears = taxYearsInInterval
        .filter((value, index, array) => array.indexOf(value) === index)
        // sort descending
        .sort((a, b) => b - a);
    return taxYears;
}
/*
 * Returns unused tax years among fiscal years and in interval of fiscal year. we pass all the fiscal years and also the fiscal year we are trying to get the taxyears
 *
 */
function getTaxYearsForGrid(fiscalYears, fiscalYear, inUseTaxYears) {
    // all assigned tax years except tax year of fiscal year we are om
    const usedTaxYears = inUseTaxYears === undefined
        ? fiscalYears
            .map(fiscalYear => fiscalYear.taxCodeYear)
            .filter(taxCodeYear => Boolean(taxCodeYear) && (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.taxCodeYear) !== taxCodeYear)
        : inUseTaxYears;
    // all possible tax years of edited fiscal year interval
    const taxYearsInInterval = [
        ...Array(fiscalYear.endDate.getFullYear() - fiscalYear.startDate.getFullYear() + 1).keys(),
    ].map(key => fiscalYear.startDate.getFullYear() + key);
    // years in interval that are not used as tax years for other fiscal years
    const unusedTaxYearsInInterval = taxYearsInInterval.filter(taxYear => !usedTaxYears.includes(taxYear));
    // result of all unique and sorted unused tax years
    const taxYears = unusedTaxYearsInInterval
        .filter((value, index, array) => array.indexOf(value) === index)
        // sort descending
        .sort((a, b) => b - a);
    return taxYears;
}
/**
 * Returns the FiscalYearsGridData, which maps from the FiscalYear .
 */
function mapFiscalYearForGrid(fiscalYears) {
    return fiscalYears.map(fiscalYear => {
        return {
            id: fiscalYear.id,
            startDate: fiscalYear.startDate,
            endDate: fiscalYear.endDate,
            sequenceNumber: fiscalYear.sequenceNumber,
            taxYear: fiscalYear.taxCodeYear,
            taxYears: getTaxYearsForGrid(fiscalYears, fiscalYear),
        };
    });
}

const EntryPoints = {
    contact: 'Contact',
    client: 'Client',
    firmClient: 'Firm',
    cancelButton: 'CancelButton',
    previousButton: 'PreviousButton',
};

/**
 * Returns transaction state
 */
const getPeriodsSettingsState = createSelector(getPeriodsState, (state) => state.periodsSettingsState);
/**
 * Returns the count of transactions for contact
 */
const getIsFirmClient = createSelector(getPeriodsSettingsState, (state) => state.isFirmClient);
/**
 * Returns the count of transactions for contact
 */
const getShowRelatedContacts = createSelector(getPeriodsSettingsState, (state) => state.showRelatedContacts);
/**
 * Returns the specific entry point (Contact, Client or Firm)
 */
const getEntryPoint = createSelector(getPeriodsSettingsState, (state) => {
    let entryPoint;
    if (state.isFirmClient) {
        entryPoint = EntryPoints.firmClient;
    }
    else if (state.showRelatedContacts) {
        entryPoint = EntryPoints.client;
    }
    else {
        entryPoint = EntryPoints.contact;
    }
    return entryPoint;
});

var CompanyClientCode;
(function (CompanyClientCode) {
    CompanyClientCode["Firm"] = "FIRM";
})(CompanyClientCode || (CompanyClientCode = {}));
/**
 * Returns company state
 */
const getCompanyState = createSelector(getPeriodsState, (state) => state.companyState);
/**
 * Returns the name of the Firm client
 */
const getFirmClientName = createSelector(getCompanyState, getIsFirmClient, (state, isFirmClient) => {
    if (isFirmClient && state.companyClient.code === CompanyClientCode.Firm) {
        return state.companyClient.name;
    }
});

/**
 * Returns contacts state
 */
const getContactsState = createSelector(getPeriodsState, (state) => state.contactsState);
/**
 * Returns contacts
 */
const getContacts = createSelector(getContactsState, (state) => state.contacts);
/**
 * Returns selected contact
 */
const getSelectedContact = createSelector(getContactsState, (state) => state.selectedContact);
/**
 * Returns selected contact
 */
const getContactDisplayName = createSelector(getSelectedContact, getIsFirmClient, getFirmClientName, (contact, isFirmClient, firmClientName) => isFirmClient ? firmClientName : contact.fullName);

const TabSetIds = {
    accountingTabId: 'accountingTab',
    financialPeriodsTabId: 'financialPeriodsTab',
    firmTabId: 'firmTab',
    fixedAssetsTabId: 'fixedAssetsTab',
};

/**
 * Returns alerts state
 */
const getAlertsState = createSelector(getPeriodsState, (state) => state.alertsState);
/**
 * Returns the last added alert
 */
const getAddedAlert = createSelector(getAlertsState, (state) => {
    return state.addedAlert;
});
/**
 * Returns the removed alert
 */
const getRemovedAlert = createSelector(getAlertsState, (state) => {
    return state.removedAlert;
});

class BmppOwnerService {
    setOwnerId(ownerId) {
        this.ownerId = ownerId;
    }
    getOwnerId() {
        return this.ownerId;
    }
}
BmppOwnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppOwnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BmppOwnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppOwnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppOwnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const countryCodes = {
    // US country code
    US: 'US',
    // Canada country code
    CA: 'CA',
    // UK country code
    UK: 'GB',
    // Argentina country code
    AR: 'AR',
};

/**
 * Service to store and reutrn the current country code
 */
class LocaleService {
    /**
     * Sets the current country code
     */
    loadCountryCodeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const environmentInfo = yield environment.getEnvironmentAsync();
            this.currentCountryCode = environmentInfo.countryCode;
        });
    }
    /**
     * Returns current country code
     */
    getCountryCode() {
        return this.currentCountryCode;
    }
    /**
     * Returns true if current country is Argentina
     */
    isArgentina() {
        return this.currentCountryCode === countryCodes.AR;
    }
    /**
     * Returns true if current country is UK
     */
    isCountryUK() {
        return this.currentCountryCode === countryCodes.UK;
    }
    /**
     * Returns true if current country is US
     */
    isCountryUS() {
        return this.currentCountryCode === countryCodes.US;
    }
    /**
     * Returns true if current country is CA
     */
    isCountryCanada() {
        return this.currentCountryCode === countryCodes.CA;
    }
    /**
     * Returns true if current country is CA or US
     */
    isCountryCanadaOrUS() {
        return this.currentCountryCode === countryCodes.CA || this.currentCountryCode === countryCodes.US;
    }
}
LocaleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LocaleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const permissionsKeys = {
    accounting: 'OnvioSetup.AccountingPeriods',
    fixedAssets: 'USFixedAssets.FixedAssetsPeriods',
    ukVat: 'Applications.UKVAT',
    ukTax: 'Applications.UKTax',
    currentDevelopment: 'Internal.CurrentDevelopment',
};

/**
 * Service which is used to wrapup the \@blue/permission functions set.
 * Before to use service you have to call the loadFrps() method, that will load permissions to the private settings field.
 * After that you will be available to use the permission values as a readonly properties of this service.
 */
class BmppFeatureResourcePermissionService {
    constructor(ukVatService) {
        this.ukVatService = ukVatService;
        this.permission = permission;
        this._isUkVat = false;
        this._ishUKTax = false;
        this._hasAccounting = false;
        this._hasFixedAssets = false;
        this._currentDevelopment = false;
    }
    /**
     * Loads all permission which are accessible through readonly properties.
     */
    loadFrps(ownerId) {
        return __awaiter(this, void 0, void 0, function* () {
            this._isUkVat =
                (yield this.permission.has(permissionsKeys.ukVat)) && (yield this.ukVatService.getShowVatTabByContactId(ownerId));
            this._hasAccounting = yield this.permission.has(permissionsKeys.accounting);
            this._hasFixedAssets = yield this.permission.has(permissionsKeys.fixedAssets);
            this._ishUKTax = yield this.permission.has(permissionsKeys.ukTax);
            this._currentDevelopment = yield this.permission.has(permissionsKeys.currentDevelopment);
        });
    }
    /**
     * Represents does the user has the Applications.UKVAT permission.
     */
    get isUkVat() {
        return this._isUkVat;
    }
    /**
     * Represents does the user has the Applications.UKTax permission.
     */
    get isUkTax() {
        return this._ishUKTax;
    }
    /**
     * Represents does the user has the OnvioSetup.AccountingPeriods permission.
     */
    get hasAccounting() {
        return this._hasAccounting;
    }
    /**
     * Represents does the user has the USFixedAssets.FixedAssetsPeriods permission.
     */
    get hasFixedAssets() {
        return this._hasFixedAssets;
    }
    /**
     * Represents does the feature is under current development.
     */
    get isCurrentDevelopment() {
        return this._currentDevelopment;
    }
}
BmppFeatureResourcePermissionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppFeatureResourcePermissionService, deps: [{ token: i1.UkVatPeriodsService }], target: i0.ɵɵFactoryTarget.Injectable });
BmppFeatureResourcePermissionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppFeatureResourcePermissionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppFeatureResourcePermissionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.UkVatPeriodsService }]; } });

class CreatePeriodListModel {
}

const MILLISECONDS_IN_MONTHS = 2.628e9;
const THIRTEEN_PERIODS_COUNT = 13;
/**
 * Service to maintain periods frequency list
 * Mostly all logic in the service was migrated from periods legacy code
 * Only calculation months range were changed
 * due to using date-fns instead of moment lib
 */
class PeriodFrequencyService {
    /**
     * Creates new paeriod list depends on frequency type
     * @param frequencyType - what frequency type period list is created
     * @param numberOfPeriods -  number of periods for custom frequency type
     * @param yearBeginDate - start date of periods
     * @param yearEndDate - end date of periods
     * @param periodType - what period type periods list is created
     */
    createPeriodList(createPeriodListModel) {
        const yearInterval = {
            start: createPeriodListModel.yearBeginDate,
            end: createPeriodListModel.yearEndDate,
        };
        switch (createPeriodListModel.frequencyType) {
            case FrequencyType.Annual: {
                return this.createAnnualPeriod(yearInterval, createPeriodListModel.periodType);
            }
            case FrequencyType.SemiAnnual: {
                return this.createSemiAnnualPeriods(yearInterval, createPeriodListModel.periodType);
            }
            case FrequencyType.Quarterly: {
                return this.createQuarterlyPeriods(yearInterval, createPeriodListModel.periodType);
            }
            case FrequencyType.Monthly: {
                return this.createMonthlyPeriods(yearInterval, createPeriodListModel.periodType);
            }
            case FrequencyType.ThirteenPeriods: {
                return this.createCustomPeriods(yearInterval, THIRTEEN_PERIODS_COUNT, createPeriodListModel.periodType);
            }
            case FrequencyType.Weekly: {
                return this.createWeeklyPeriods(yearInterval, createPeriodListModel.periodType);
            }
            case FrequencyType.Custom: {
                return this.createCustomPeriods(yearInterval, createPeriodListModel.numberOfPeriods, createPeriodListModel.periodType);
            }
            default:
                break;
        }
    }
    /**
     * Creates one period per year
     * @param yearInterval - represents year begin and end dates
     * @param periodType - what period type periods list is created
     */
    createAnnualPeriod(yearInterval, periodType) {
        const period = this.createPeriod(yearInterval.start, yearInterval.end, 1, periodType);
        return [period];
    }
    /**
     * Creates two periods per year
     * @param yearInterval - represents year begin and end dates
     * @param periodType - what period type periods list is created
     */
    createSemiAnnualPeriods(yearInterval, periodType) {
        // Transferred logic to make periods compatible with the legacy for now
        const millisecondsInInterval = differenceInMilliseconds(yearInterval.end, yearInterval.start);
        const monthsInInterval = Math.round(millisecondsInInterval / MILLISECONDS_IN_MONTHS);
        const semiInterval = Math.round(monthsInInterval / 2);
        const firstPeriodEndDate = subDays(addMonths(yearInterval.start, semiInterval), 1);
        const secondPeriodStartDate = addDays(firstPeriodEndDate, 1);
        return [
            this.createPeriod(yearInterval.start, firstPeriodEndDate, 1, periodType),
            this.createPeriod(secondPeriodStartDate, yearInterval.end, 2, periodType),
        ];
    }
    /**
     * Creates four periods per year
     * @param yearInterval - represents year begin and end dates
     * @param periodType - what period type periods list is created
     */
    createQuarterlyPeriods(yearInterval, periodType) {
        const dateRangeInDays = differenceInDays(yearInterval.end, yearInterval.start);
        let periods = [];
        // if they are using a full fiscal year, then we want to use the last day of every three months for their periods
        if (dateRangeInDays === 364 || dateRangeInDays === 365) {
            // returns start date for each month in interval
            let dateRange = eachMonthOfInterval(yearInterval);
            let periodBegin;
            let sequenceNumber = 1;
            // we want to create a period every three months
            let iterationNumber = 1;
            // gets the same day of the month in interval
            if (!isFirstDayOfMonth(yearInterval.start)) {
                let months = 0;
                dateRange = dateRange.map(startDate => {
                    startDate = addMonths(yearInterval.start, months);
                    months++;
                    return startDate;
                });
            }
            dateRange.forEach(startDate => {
                const periodEnd = subDays(startDate, 1);
                if (!periodBegin) {
                    periodBegin = startDate;
                    // this is the first time through so we want to decrement down to zero, as it will be incremented back to 1 below
                    iterationNumber--;
                }
                else if (iterationNumber === 3 && periodEnd < yearInterval.end) {
                    periods.push(this.createPeriod(periodBegin, periodEnd, sequenceNumber, periodType));
                    periodBegin = startDate;
                    sequenceNumber++;
                    iterationNumber = 0; // reset the iteration number back to 1
                }
                iterationNumber++;
            });
            // add in the final period
            periods.push(this.createPeriod(periodBegin, yearInterval.end, sequenceNumber, periodType));
        }
        else {
            // otherwise take your best guess
            periods = this.createCustomPeriods(yearInterval, 4, periodType);
        }
        return periods;
    }
    /**
     * Creates each month periods per year
     * @param yearInterval - represents year begin and end dates
     * @param periodType - period type periods list is created for
     */
    createMonthlyPeriods(yearInterval, periodType) {
        // returns start date for each month in interval
        const dateRangeInDays = differenceInDays(yearInterval.end, yearInterval.start);
        if (dateRangeInDays > -1) {
            let dateRange = eachMonthOfInterval(yearInterval);
            const periods = [];
            let periodBegin;
            let sequenceNumber = 1;
            // gets the same day of the month in interval
            if (!isFirstDayOfMonth(yearInterval.start)) {
                let months = 0;
                dateRange = dateRange
                    .map(startDate => {
                    startDate = addMonths(yearInterval.start, months);
                    months++;
                    return startDate;
                })
                    .filter(startDate => startDate < yearInterval.end);
            }
            dateRange.forEach(startDate => {
                const periodEnd = subDays(startDate, 1);
                if (periodBegin && periodEnd < yearInterval.end) {
                    periods.push(this.createPeriod(periodBegin, periodEnd, sequenceNumber, periodType));
                    periodBegin = startDate;
                    sequenceNumber++;
                }
                else {
                    periodBegin = startDate;
                }
            });
            // add in the final period
            periods.push(this.createPeriod(periodBegin, yearInterval.end, sequenceNumber, periodType));
            return periods;
        }
        // otherwise take your best guess
        return this.createCustomPeriods(yearInterval, 12, periodType);
    }
    /**
     * Creates each week periods per year
     * @param yearInterval - represents year begin and end dates
     * @param periodType - period type periods list is created for
     */
    createWeeklyPeriods(yearInterval, periodType) {
        const dateRangeInDays = differenceInDays(yearInterval.end, yearInterval.start);
        if (dateRangeInDays > -1) {
            const dateRange = eachDayOfInterval(yearInterval);
            let periodBegin;
            let sequenceNumber = 1;
            let periods = [];
            // gets start dates for each week(seven days)
            const weeksStartDates = dateRange.filter((d, i) => i % 7 === 0);
            weeksStartDates.forEach(startDate => {
                if (!periodBegin) {
                    periodBegin = startDate;
                }
                else if (sequenceNumber === 52) {
                    periods.push(this.createPeriod(periodBegin, yearInterval.end, sequenceNumber, periodType));
                }
                else {
                    const periodEnd = subDays(startDate, 1);
                    periods.push(this.createPeriod(periodBegin, periodEnd, sequenceNumber, periodType));
                    periodBegin = startDate;
                    sequenceNumber++;
                }
            });
            // there are cases (in short years) where this iteration will not include the last week of the year
            // check to see if the last period is before the fiscal year endDate
            // if it is, add another period with the fiscal year end
            // add in the final period
            const lastPeriod = periods.slice(-1)[0];
            if (isBefore(lastPeriod.endDate, yearInterval.end)) {
                periods.push(this.createPeriod(periodBegin, yearInterval.end, sequenceNumber, periodType));
            }
            else if (periods.length > 52) {
                // When a fiscal year extends more than 52 weeks, we end up with multiple copies of the last period on the array
                // In this case, we want to just use the first 52 elements
                periods = periods.slice(0, 52);
            }
            return periods;
        }
        // otherwise take your best guess
        return this.createCustomPeriods(yearInterval, 52, periodType);
    }
    /**
     * Creates custom list of periods per year
     * @param yearInterval - represents year begin and end dates
     * @param numberOfPeriods -  number of peiods needs create
     * @param periodType - period type periods list is created for
     */
    createCustomPeriods(yearInterval, numberOfPeriods, periodType) {
        numberOfPeriods = Number(numberOfPeriods);
        const periods = [];
        if (numberOfPeriods === 0) {
            return periods;
        }
        const daysInRange = differenceInDays(yearInterval.end, yearInterval.start);
        const daysPerPeriod = Math.floor(daysInRange / numberOfPeriods);
        let periodBegin = yearInterval.start;
        // iterate over the number of periods, and add a new period of each interval
        for (let sequenceNumber = 1; sequenceNumber <= numberOfPeriods; ++sequenceNumber) {
            let periodEnd;
            // if we're on the last period, use the fiscal year end date as the period end
            if (sequenceNumber === numberOfPeriods) {
                periodEnd = yearInterval.end;
            }
            else {
                periodEnd = addDays(periodBegin, daysPerPeriod - 1);
            }
            // for the last period use the fiscal year end date
            if (sequenceNumber === numberOfPeriods) {
                // add a period for the last date
                periods.push(this.createPeriod(periodBegin, yearInterval.end, sequenceNumber, periodType));
            }
            else {
                // otherwise use the calculated period end
                periods.push(this.createPeriod(periodBegin, periodEnd, sequenceNumber, periodType));
            }
            periodBegin = addDays(periodEnd, 1);
        }
        return periods;
    }
    /**
     * Creates period entity
     * @param startDate -start date of period
     * @param endDate - end date of period
     * @param sequenceNumber -  sequence number of period
     * @param periodType - period type periods list is created for
     */
    createPeriod(startDate, endDate, sequenceNumber, periodType) {
        return { startDate, endDate, sequenceNumber, periodType };
    }
    /**
     * Updates periods of fiscal year based on its start and/or end dates
     * Sets deleted previous periods
     * @param fiscalYear - fiscal year
     * @returns fiscal year with new periods and deleted previous periods
     */
    updateFiscalYearPeriods(fiscalYear) {
        const previousPeriods = fiscalYear.periods;
        // update accounting periods
        const accountingPeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.Accounting);
        // set period mappingId
        accountingPeriods.forEach(period => (period.mappingId = period.sequenceNumber));
        // update fixed assets periods
        const fixedAssetsPeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.FixedAssets);
        // update firm periods
        const firmPeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.Practice);
        // set deleted previous periods
        let deletedPeriods = previousPeriods.map(period => (Object.assign(Object.assign({}, period), { isDeleted: true })));
        // set period mappingId for previous accounting periods
        deletedPeriods = this.mapPeriods(deletedPeriods, [...accountingPeriods, ...fixedAssetsPeriods, ...firmPeriods]);
        // concat all periods
        const updatedPeriods = [...deletedPeriods, ...accountingPeriods, ...fixedAssetsPeriods, ...firmPeriods];
        return Object.assign(Object.assign({}, fiscalYear), { periods: updatedPeriods });
    }
    /**
     * Maps previous current period to new period
     * @param previousPeriods - previous periods
     * @param newPeriods - new periods
     * @param periodType - period type to update periods for
     */
    mapCurrentPeriod(previousPeriods, newPeriods, periodType) {
        var _a;
        const previousCurrentPeriod = previousPeriods.find(period => period.periodType === periodType && period.isCurrentPeriod);
        const newCurrentPeriod = (_a = newPeriods.find(period => period.sequenceNumber === (previousCurrentPeriod === null || previousCurrentPeriod === void 0 ? void 0 : previousCurrentPeriod.sequenceNumber))) !== null && _a !== void 0 ? _a : newPeriods.find(period => previousCurrentPeriod !== undefined && period !== undefined);
        if (newCurrentPeriod) {
            newCurrentPeriod.isCurrentPeriod = true;
        }
    }
    /**
     * Creates new list of periods based on previous period period frequency and new start or end date
     * @param periods - previous periods
     * @param startDate - start date of fiscal year interval
     * @param endDate -  end date of fiscal year interval
     * @param periodType - period type to update periods for
     * @returns new list of periods
     */
    updatePeriods(periods, startDate, endDate, periodType) {
        const frequencyType = this.getPeriodsFrequencyType(periods, periodType);
        const numberOfCustomPeriods = frequencyType === FrequencyType.Custom ? periods.filter(period => period.periodType === periodType).length : null;
        const createPeriodListModel = {
            frequencyType,
            yearBeginDate: startDate,
            yearEndDate: endDate,
            numberOfPeriods: numberOfCustomPeriods,
            periodType,
        };
        const newPeriods = this.createPeriodList(createPeriodListModel);
        this.mapCurrentPeriod(periods, newPeriods, periodType);
        return newPeriods;
    }
    /**
     * Gets periods frequency type based on number of periods and by period type
     * @param periods - periods
     * @param periodType - periods type
     */
    getPeriodsFrequencyType(periods, periodType) {
        return this.getPeriodsFrequencyInfo(periods, periodType).frequencyType;
    }
    /**
     * Gets periods frequency info based on number of periods and by period type
     * @param periods - periods
     * @param periodType - periods type
     */
    getPeriodsFrequencyInfo(periods, periodType) {
        // gets the periods number for the application/period type
        const periodsCountOfPeriodType = periods.filter(p => p.periodType === periodType).length;
        // sets default frequency type in case there is no periods for period type
        if (periodsCountOfPeriodType === 0) {
            return periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Annual);
        }
        // gets the frequency type depended on periods number
        const periodFrequency = periodFrequencies.find(frequency => frequency.value === periodsCountOfPeriodType);
        // if period frequencies have no predefined periods number
        // return custom frequency type
        return periodFrequency === undefined
            ? periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Custom)
            : periodFrequency;
    }
    /**
     * Maps periods with default mapping rules
     * For now this logic completly moved from periods legacy
     * @param existingPeriods -periods that should be mapped to
     * @param newPeriods- periods that should be mapping from
     * @returns default mapped periods
     */
    mapPeriods(existingPeriods, newPeriods) {
        const isSameFrequency = existingPeriods.length === newPeriods.length;
        // if the same number of periods - map one to one
        if (isSameFrequency) {
            return existingPeriods.map(period => (Object.assign(Object.assign({}, period), { mappingId: period.sequenceNumber })));
        }
        // map existing periods to new periods with closest date
        return existingPeriods.map(existingPeriod => {
            const existingPeriodEndDate = existingPeriod.endDate;
            let mappingId = -1;
            let closestDate = Infinity;
            newPeriods.forEach(newPeriod => {
                let distance;
                // if we have changed the dates and the newPeriods are before the existing periods
                // then we need to reverse the condition.
                const isLaterDate = isAfter(existingPeriodEndDate, newPeriod.endDate);
                if (isLaterDate) {
                    const diffInMilliseconds = differenceInMilliseconds(existingPeriodEndDate.getTime(), newPeriod.endDate.getTime());
                    distance = toDate(Math.abs(diffInMilliseconds));
                    // only do this when the existingPeriod date is equal or lesser date
                    if (distance < closestDate && newPeriod.endDate <= existingPeriodEndDate) {
                        closestDate = distance;
                        mappingId = newPeriod.sequenceNumber;
                    }
                }
                else {
                    const diffInMilliseconds = differenceInMilliseconds(existingPeriodEndDate.getTime(), newPeriod.endDate.getTime());
                    distance = toDate(Math.abs(diffInMilliseconds));
                    // only do this when the existingPeriod date is equal or lesser date
                    if (distance < closestDate && existingPeriodEndDate <= newPeriod.endDate) {
                        closestDate = distance;
                        mappingId = newPeriod.sequenceNumber;
                    }
                }
            });
            // we found the matching now assign it to the existing period date mapping id
            return Object.assign(Object.assign({}, existingPeriod), { mappingId });
        });
    }
    /**
     * Updates periods of multiple fiscal year based on its start and/or end dates
     * @param fiscalYears - multiple fiscal years
     * @returns multiple fiscal years with updated periods
     */
    updateMultipleFiscalYearPeriods(fiscalYears) {
        fiscalYears.map(fiscalYear => {
            const previousPeriods = fiscalYear.periods;
            // update accounting periods
            const accountingPeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.Accounting);
            // update fixed assets periods
            const fixedAssetsPeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.FixedAssets);
            // update practice periods
            const practicePeriods = this.updatePeriods(previousPeriods, fiscalYear.startDate, fiscalYear.endDate, PeriodType.Practice);
            // concat all periods
            const updatedPeriods = [...accountingPeriods, ...fixedAssetsPeriods, ...practicePeriods];
            previousPeriods.map(previousPeriod => {
                const filteredPeriod = updatedPeriods.find(period => period.periodType === previousPeriod.periodType && period.sequenceNumber === previousPeriod.sequenceNumber);
                previousPeriod.startDate = filteredPeriod.startDate;
                previousPeriod.endDate = filteredPeriod.endDate;
                return previousPeriod;
            });
            return fiscalYear;
        });
        return fiscalYears;
    }
}
PeriodFrequencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PeriodFrequencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencyService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class NewFiscalYearPeriodsService {
    constructor(periodFrequencyService) {
        this.periodFrequencyService = periodFrequencyService;
        this.isVatTaxTab = false;
    }
    /**
     * Get isVatTaxTab
     * @param bool - boolean value
     */
    setVatTax(bool) {
        this.isVatTaxTab = bool;
    }
    /**
     * Get period frequency type of fiscal year
     * @param fiscalYear - fiscal year
     * @param periodType - periodType
     * @param periodCount - set true to get periodCount, false to get frequencytype
     */
    getPeriodFrequency(fiscalYear, periodType, periodCount) {
        if (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) {
            // gets the periods number for the application/period type
            const periodsCountOfPeriodType = fiscalYear.periods.filter(p => p.periodType === periodType).length;
            // if periodCount is true return periodsCountOfPeriodType
            if (periodCount) {
                return periodsCountOfPeriodType;
            }
            // sets default frequency type in case there is no periods for period type
            if (periodsCountOfPeriodType === 0) {
                return periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Annual).frequencyType;
            }
            // gets the frequency type depended on periods number
            const periodFrequency = periodFrequencies.find(frequency => frequency.value === periodsCountOfPeriodType);
            // if period frequencies have no predefined periods number
            // return custom frequency type
            if (periodFrequency === undefined) {
                return periodFrequencies.find(frequency => frequency.frequencyType === FrequencyType.Custom).frequencyType;
            }
            return periodFrequency.frequencyType;
        }
    }
    /**
     * Get first or previous fiscal year if exists
     * @param fiscalYears - fiscal years list
     * @param sequenceNumber - sequenceNumber of fiscal year
     */
    getFiscalYear(fiscalYears, sequenceNumber) {
        return fiscalYears.find(year => sequenceNumber === 1 ? year.sequenceNumber === 1 : year.sequenceNumber === sequenceNumber - 1);
    }
    /**
     * Set the new fiscal year with periods
     * @param startDate - start date of fiscal year
     * @param endDate - end date of fiscal year
     * @param sequenceNumber - sequence number of fiscal year
     * @param fiscalYears - fiscal years list
     * @param periodType - periodType
     */
    setNewFiscalYearPeriods(startDate, endDate, sequenceNumber, fiscalYears, periodType) {
        // get first or previous fiscal year if exists
        const fiscalYear = this.getFiscalYear(fiscalYears, sequenceNumber);
        const periodList = new CreatePeriodListModel();
        if (fiscalYear) {
            // get the freqeuncy type of first or previous fiscal year
            periodList.frequencyType = this.getPeriodFrequency(fiscalYear, periodType, false);
            periodList.yearBeginDate = startDate;
            periodList.yearEndDate = endDate;
            periodList.numberOfPeriods = this.getPeriodFrequency(fiscalYear, periodType, true);
            periodList.periodType = periodType;
            // creating the new fiscal year periods with previous or first fiscal year's frequency type
            const periods = this.periodFrequencyService.createPeriodList(periodList);
            return periods;
        }
    }
}
NewFiscalYearPeriodsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NewFiscalYearPeriodsService, deps: [{ token: PeriodFrequencyService }], target: i0.ɵɵFactoryTarget.Injectable });
NewFiscalYearPeriodsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NewFiscalYearPeriodsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NewFiscalYearPeriodsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PeriodFrequencyService }]; } });

class ContactDropdownComponent {
    constructor(ownerService, store) {
        this.ownerService = ownerService;
        this.store = store;
    }
    ngOnInit() {
        this.store
            .pipe(select(getContactsState), first(state => state.contacts !== undefined && state.contacts.length > 0))
            .toPromise()
            .then(contactsState => this.onContactsLoad(contactsState));
    }
    /**
     * On contacts load event handler
     * @param state - ContactsState from store
     */
    onContactsLoad({ contacts, selectedContact }) {
        const defaultContactId = selectedContact ? selectedContact.id : this.ownerService.getOwnerId();
        const defaultContact = contacts.find(item => item.id === defaultContactId);
        this.contacts = contacts;
        this.selectedContact = defaultContact;
    }
    /**
     * Contact selection event handler
     * @param contact - selected contact
     */
    onContactChange(contact) {
        this.store.dispatch(new SetSelectedContact({ contact }));
    }
}
ContactDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ContactDropdownComponent, deps: [{ token: BmppOwnerService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
ContactDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: ContactDropdownComponent, selector: "bmpp-contact-dropdown", ngImport: i0, template: "<label for=\"contactSelect\">{{ 'bmpp.ng.contactCombo.contact' | translate }}</label>\n<select\n\tclass=\"form-control\"\n\tbentoSelect\n\tid=\"contactSelect\"\n\t*ngIf=\"contacts\"\n\t[(ngModel)]=\"selectedContact\"\n\t(ngModelChange)=\"onContactChange($event)\"\n\tdata-qe-id=\"bmpp.contactSelect\"\n>\n\t<option *ngFor=\"let contact of contacts\" [ngValue]=\"contact\">{{ contact.displayAs }}</option>\n</select>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ContactDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-contact-dropdown', template: "<label for=\"contactSelect\">{{ 'bmpp.ng.contactCombo.contact' | translate }}</label>\n<select\n\tclass=\"form-control\"\n\tbentoSelect\n\tid=\"contactSelect\"\n\t*ngIf=\"contacts\"\n\t[(ngModel)]=\"selectedContact\"\n\t(ngModelChange)=\"onContactChange($event)\"\n\tdata-qe-id=\"bmpp.contactSelect\"\n>\n\t<option *ngFor=\"let contact of contacts\" [ngValue]=\"contact\">{{ contact.displayAs }}</option>\n</select>\n" }]
        }], ctorParameters: function () { return [{ type: BmppOwnerService }, { type: i2.Store }]; } });

/**
 * returns accountTotalState
 * @param getPeriodsState -
 * @param PeriodsState -
 */
const getAccountState = createSelector(getPeriodsState, (state) => state.accountsTotalState);
/**
 * returns a boolean value validating if accountBalance is different from zero stored in AccountsTotalState
 * @param getAccountState -
 * @param AccountsTotalState -
 */
const isUnbalancedAmount = createSelector(getAccountState, (state) => {
    return state.accountBalance !== 0;
});
/**
 * returns the accountBalance stored in AccountsTotalState
 * @param  getAccountState -
 * @param  AccountsTotalState -
 */
const getUnbalancedAmount = createSelector(getAccountState, (state) => {
    return state.accountBalance;
});
/**
 * returns the accountTotalLoading stored in AccountsTotalState
 * @param getAccountState -
 * @param AccountsTotalState -
 */
const getTotalsAccountLoading = createSelector(getAccountState, (state) => {
    return state.accountTotalLoading;
});
/**
 * returns the accountTotalLoaded stored in AccountsTotalState
 * @param getAccountState -
 * @param AccountsTotalState -
 */
const getTotalsAccountLoaded = createSelector(getAccountState, (state) => {
    return state.accountTotalLoaded;
});
/**
 * returns the accountTotalLoadingFailed stored in AccountsTotalState
 * @param getAccountState -
 * @param AccountsTotalState -
 */
const getTotalsAccountFailed = createSelector(getAccountState, (state) => {
    return state.accountTotalLoadingFailed;
});

/**
 * return account group state
 * @param  getPeriodsState -
 * @param  PeriodsState -
 */
const getAccountGroupState = createSelector(getPeriodsState, (state) => state.accountGroupState);
/**
 * get ungrouped accounts loading
 * @param  getAccountGroupState -
 * @param  AccountGroupState -
 */
const getUngroupedAccountsLoading = createSelector(getAccountGroupState, (state) => {
    return state.ungroupedAccountsLoading;
});
/**
 * get ungrouped accounts loaded
 * @param  getAccountGroupState -
 * @param  AccountGroupState -
 */
const getUngroupedAccountsLoaded = createSelector(getAccountGroupState, (state) => {
    return state.ungroupedAccountsLoaded;
});
/**
 * get ungrouped accounts loading failed
 * @param  getAccountGroupState -
 * @param  AccountGroupState -
 */
const getUngroupedAccountsLoadingFailed = createSelector(getAccountGroupState, (state) => {
    return state.ungroupedAccountsLoadingFailed;
});
/**
 * has ungrouped accounts
 * @param  getAccountGroupState -
 * @param  AccountGroupState -
 */
const hasUngroupedAccounts = createSelector(getAccountGroupState, (state) => {
    return state.ungroupedAccounts > 0;
});

/**
 * Get periods wizard state.
 */
const getEditPeriodsState = createSelector(getPeriodsState, (state) => state.editPeriodsState);
/**
 * Returns a current year's period list for selected period frequency.
 */
const getEditPeriodList = createSelector(getEditPeriodsState, (state) => state.editPeriodList);
/**
 * Returns a calculated new period list for selected period frequency.
 */
const getNewPeriodList = createSelector(getEditPeriodsState, (state) => state.newPeriodList);
/**
 * Returns current periods type.
 */
const getPeriodType = createSelector(getEditPeriodsState, (state) => state.periodType);
/**
 * Returns current periods frequency stored in the state.
 */
const getCurrentPeriodsFrequency = createSelector(getEditPeriodsState, (state) => state.currentPeriodsFrequency);
/**
 * Returns selected periods frequency stored in the state.
 */
const getSelectedPeriodsFrequency = createSelector(getEditPeriodsState, (state) => state.selectedPeriodsFrequency);
/**
 * Returns boolean flag does the selected periods frequency is the custom one.
 */
const getIsCustomPeriodsFrequency = createSelector(getSelectedPeriodsFrequency, (selectedPeriodsFrequency) => (selectedPeriodsFrequency === null || selectedPeriodsFrequency === void 0 ? void 0 : selectedPeriodsFrequency.frequencyType) === FrequencyType.Custom);
/**
 * Returns the number of the custom periods.
 */
const getCustomPeriodsNumber = createSelector(getEditPeriodsState, (state) => state.customPeriodsNumber);
/**
 * Returns the error message if custom periods number is not valid.
 */
const getCustomPeriodsNumberErrorMessage = createSelector(getEditPeriodsState, (state) => state.customPeriodsNumberErrorMessage);
/**
 * Returns state\`s isValid property.
 */
const getIsValid = createSelector(getEditPeriodsState, (state) => state.isValid);
/**
 * Returns the array of validation results for the periods dates.
 */
const getPeriodsValidations = createSelector(getEditPeriodsState, (state) => state.periodsValidations);
/**
 * Returns the flag does the periods' frequency is changed.
 */
const getIsFrequencyChanged = createSelector(getCurrentPeriodsFrequency, getSelectedPeriodsFrequency, (currentPeriodsFrequency, selectedPeriodsFrequency) => (currentPeriodsFrequency === null || currentPeriodsFrequency === void 0 ? void 0 : currentPeriodsFrequency.frequencyType) !== (selectedPeriodsFrequency === null || selectedPeriodsFrequency === void 0 ? void 0 : selectedPeriodsFrequency.frequencyType));
/**
 * Returns the flag does the period list or period frequency is changed.
 */
const getIsEdited = createSelector(getSelectedFiscalYear, getIsFrequencyChanged, getPeriodType, getEditPeriodList, getCurrentPeriodsFrequency, getCustomPeriodsNumber, (fiscalYear, isFrequencyChanged, periodType, editPeriodList, currentPeriodFrequency, customPeriodsNumber = 0) => {
    var _a;
    // If period frequency of the selected fiscal year is changed
    let isEdited = Boolean(isFrequencyChanged);
    const currentPeriodList = (_a = fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.filter(period => period.periodType === periodType);
    // If number of periods of the selected fiscal year, which has Custom period frequency, is changed
    if ((currentPeriodFrequency === null || currentPeriodFrequency === void 0 ? void 0 : currentPeriodFrequency.frequencyType) === FrequencyType.Custom &&
        customPeriodsNumber !== currentPeriodList.length) {
        isEdited = true;
    }
    const differenceOfPeriodLists = editPeriodList.filter(editedPeriod => !currentPeriodList.some(period => period.endDate.getTime() === editedPeriod.endDate.getTime() &&
        period.sequenceNumber === editedPeriod.sequenceNumber));
    // If period list of the selected fiscal year is modified
    if (differenceOfPeriodLists.length > 0) {
        isEdited = true;
    }
    return isEdited;
});
/**
 * Returns the flag does the custom periods' number remains the same.
 */
const getIsCustomPeriodsNumberSame = createSelector(getEditPeriodList, getCustomPeriodsNumber, getIsCustomPeriodsFrequency, (periods, customPeriodsNumber, isCustomPeriodsFrequency) => !isCustomPeriodsFrequency || (periods === null || periods === void 0 ? void 0 : periods.length) === customPeriodsNumber);
/**
 * Returns the flag does the state in the mapping mode. It's based does the periods' frequency or custom periods' number is changed.
 */
const getIsMappingMode = createSelector(getIsFrequencyChanged, getIsCustomPeriodsNumberSame, (isFrequencyChanged, isCustomPeriodsNumberSame) => isFrequencyChanged || !isCustomPeriodsNumberSame);
/**
 * Return periods based on the state of the isMappingMode flag.
 */
const getCurrentPeriodList = createSelector(getEditPeriodList, getNewPeriodList, getIsMappingMode, (editPeriods, newPeriods, isMappingMode) => (isMappingMode ? newPeriods : editPeriods));
/**
 * Return periods mapped to the view model type.
 */
const getPeriodsViewModels = createSelector(getCurrentPeriodList, (periods) => periods.map(periodToViewModelMapFunction));
/**
 * Based on the `isMappingMode`'s value, either returns the `editPeriodsList` or selected fiscal year's periods.
 */
const getExistedPeriods = createSelector(getIsMappingMode, getEditPeriodList, getSelectedFiscalYear, getPeriodType, (isMappingMode, editPeriodsList, selectedFiscalYear, periodType) => isMappingMode
    ? editPeriodsList
    : selectedFiscalYear === null || selectedFiscalYear === void 0 ? void 0 : selectedFiscalYear.periods.filter(period => period.periodType === periodType).map(period => (Object.assign(Object.assign({}, period), { mappingId: period.sequenceNumber }))).sort((p1, p2) => p1.sequenceNumber - p2.sequenceNumber));
/**
 * Based on the `isMappingMode`'s value, either returns the `newPeriodList` or `editPeriodsList`.
 */
const getNewPeriods = createSelector(getIsMappingMode, getEditPeriodList, getNewPeriodList, (isMappingMode, editPeriodList, newPeriodList) => isMappingMode ? newPeriodList : editPeriodList);
/**
 * Returns both `newPeriods` and `exitedPeriods`.
 */
const getPeriodsForMapping = createSelector(getNewPeriods, getExistedPeriods, (newPeriods, existedPeriods) => ({
    newPeriods,
    existedPeriods,
}));
/**
 * Maps `Period` to the `PeriodView` model.
 * @param period -  to map to the view model
 * @returns `PeriodView` model.
 */
function periodToViewModelMapFunction(period) {
    return {
        endDate: period.endDate,
        sequenceNumber: period.sequenceNumber,
    };
}

var EditPeriodsWizardSteps;
(function (EditPeriodsWizardSteps) {
    EditPeriodsWizardSteps[EditPeriodsWizardSteps["EditStep"] = 0] = "EditStep";
    EditPeriodsWizardSteps[EditPeriodsWizardSteps["MapStep"] = 1] = "MapStep";
})(EditPeriodsWizardSteps || (EditPeriodsWizardSteps = {}));

var AlertItemOptionsTypes;
(function (AlertItemOptionsTypes) {
    AlertItemOptionsTypes["success"] = "success";
    AlertItemOptionsTypes["info"] = "info";
    AlertItemOptionsTypes["warning"] = "warning";
    AlertItemOptionsTypes["danger"] = "danger";
})(AlertItemOptionsTypes || (AlertItemOptionsTypes = {}));

const DEFAULT_TIMEOUT_FOR_SUCCESS_ALERT = 20000;
class BmppAlertService {
    constructor(translateService) {
        this.translateService = translateService;
        this.onAlertAdded = new EventEmitter();
        this.clearAll = new EventEmitter();
    }
    /**
     * Adds warning alert
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addWarningAlert(msg, translationParams) {
        this.addAlert(AlertItemOptionsTypes.warning, msg, translationParams);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addAlert(type, msg, translationParams, milliseconds = null) {
        const option = {
            type,
            msg: this.translateService.instant(msg, translationParams),
            closeable: true,
            timeout: milliseconds,
        };
        this.onAlertAdded.emit(option);
    }
}
BmppAlertService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppAlertService, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
BmppAlertService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppAlertService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppAlertService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

class BmppDateHelperService {
    constructor(translateService) {
        this.translateService = translateService;
    }
    get formatObj() {
        const locale = this.translateService.currentLang;
        return new Intl.DateTimeFormat(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
    // this should set the place holder for the date picker
    getFormatPlaceHolder(lang) {
        lang = lang.toLowerCase();
        const formats = {
            'en-us': 'mm/dd/yyyy',
            'en-au': 'dd/mm/yyyy',
            'en-gb': 'dd/mm/yyyy',
            'en-ca': 'yy-mm-dd',
            'es-ar': 'dd/mm/yyyy',
            'fr-ca': 'yy-mm-dd',
        };
        return formats[lang] || 'mm/dd/yyyy';
    }
    /**
     * Converts an NgbDateStruct to a Javascript Date
     * @param date - NgbDateStruct to convert
     */
    getUTCDateFormatFromStruct(date) {
        return date === null || date === undefined ? null : new Date(date.year, date.month - 1, date.day);
    }
    /**
     * Does the work of separating a string into the three parts of a date struct
     * @param date - string to turn into a struct
     * @param format - format of the date being parsed
     */
    parseFromFormat(date, format) {
        const parts = format.formatToParts(new Date());
        if (parts.length === 0 || date === null || date === undefined) {
            return null;
        }
        let year;
        let month;
        let day;
        for (const part of parts) {
            switch (part.type) {
                case 'year':
                    year = Number(date.substr(0, part.value.length)) === 0 ? null : Number(date.substr(0, part.value.length));
                    break;
                case 'month':
                    month = Number(date.substr(0, part.value.length)) === 0 ? null : Number(date.substr(0, part.value.length));
                    break;
                case 'day':
                    day = Number(date.substr(0, part.value.length)) === 0 ? null : Number(date.substr(0, part.value.length));
                    break;
                default:
                    break;
            }
            date = date.substr(part.value.length);
        }
        return { year, month, day };
    }
    /**
     * Takes in a string and turns it into an NgbDateStruct
     * @param value - string to turn into an NgbDateStruct
     */
    parseFromString(value) {
        let result = null;
        result = this.parseFromFormat(value, this.formatObj);
        // if any part is not a number then return null
        if (result === null || isNaN(result.day) || isNaN(result.month) || isNaN(result.year)) {
            return null;
        }
        return result;
    }
    /**
     * Transforms date to \{NgbDate\} compatible with ngbDatePicker
     * @param selectedDate - date for conversion
     */
    dateToNgbDateStruct(selectedDate) {
        const day = selectedDate.getDate();
        const month = selectedDate.getMonth() + 1;
        const year = selectedDate.getFullYear();
        return new NgbDate(year, month, day);
    }
    /**
     * Transforms \{NgbDate\} to\{Date\}
     * @param ngbDate - NgbDate for conversion
     */
    ngbDateStructToDate(ngbDate) {
        return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    }
    /**
     * Returns the formatted date
     * @param date - Date for formatting
     */
    getFormattedDate(date) {
        let formattedDate;
        if (date) {
            formattedDate = this.formatObj.format(new Date(date));
        }
        return formattedDate;
    }
    /**
     * Returns the formatted to UTC date.
     */
    transformDateToUTC(date) {
        const millisecondsInMinute = 60000;
        const userTimezoneOffset = date.getTimezoneOffset() * millisecondsInMinute;
        return new Date(date.getTime() - userTimezoneOffset);
    }
}
BmppDateHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateHelperService, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
BmppDateHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateHelperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

/**
 * Custom adapter for NgbDateStruct
 * Implement original NgbDateStructAdapter logic
 * Defines custom adapter to avoid conflicting between other packages
 * that have their own NgbDateAdapter provider on root level
 */
class BmppNgbDateStructAdapter extends NgbDateAdapter {
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param date - date struct
     */
    // This is a valid use of null
    // eslint-disable-next-line @rushstack/no-new-null
    fromModel(date) {
        return date && this.isInteger(date.year) && this.isInteger(date.month) && this.isInteger(date.day)
            ? { year: date.year, month: date.month, day: date.day }
            : null;
    }
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param date - date struct
     */
    // This is a valid use of null
    // eslint-disable-next-line @rushstack/no-new-null
    toModel(date) {
        return date && this.isInteger(date.year) && this.isInteger(date.month) && this.isInteger(date.day)
            ? { year: date.year, month: date.month, day: date.day }
            : null;
    }
    /**
     * Checks if value is number
     * @param value - integer number
     */
    isInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }
}
BmppNgbDateStructAdapter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppNgbDateStructAdapter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BmppNgbDateStructAdapter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppNgbDateStructAdapter, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppNgbDateStructAdapter, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class BmppDateValidatorService {
    validateDate(date) {
        if (!date) {
            return false;
        }
        // If the NGB DatePicker isn't able to validate a date, it returns a pure string
        // In that case, we want to say the date is invalid
        if (typeof date === 'string') {
            return false;
        }
        // Length of months (will update for leap years)
        const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const { month, year, day } = date;
        // Make sure date is in range
        if (year < 2000 || year > 3000 || month === 0 || month > 12) {
            return false;
        }
        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
            monthLength[1] = 29;
        }
        // Check range of the month
        if (month <= 0 || month > 12) {
            return false;
        }
        // Check the range of the day
        if (day < 0 || day > monthLength[month - 1]) {
            return false;
        }
        return true;
    }
}
BmppDateValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BmppDateValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppDateValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DatePickerComponent {
    constructor(locale, dateHelperService, dateValidatorService) {
        this.locale = locale;
        this.dateHelperService = dateHelperService;
        this.dateValidatorService = dateValidatorService;
        this.disableInternalMessage = false;
        this.selectedDateChange = new EventEmitter();
        this.selectedDateInvalid = new EventEmitter();
        this.dateConfig = { type: 'recent', format: 'mm/dd/yyyy' }; // config for bento date picker
        this.errorClass = false; // Indicates invalid field
        this.uniqueInputId = `id_${Math.floor(Math.random() * Date.now())}`;
    }
    get selectedDate() {
        return this.currentDate ? this.dateHelperService.ngbDateStructToDate(this.currentDate) : null;
    }
    set selectedDate(date) {
        this.previousDate = this.dateHelperService.dateToNgbDateStruct(date);
        this.currentDate = this.previousDate;
    }
    get errorMsg() {
        return this.internalValidationMessage || this.validationMessage;
    }
    ngOnInit() {
        const format = this.dateHelperService.getFormatPlaceHolder(this.locale.toLowerCase());
        this.dateConfig = Object.assign(Object.assign({}, this.dateConfig), { format });
    }
    /**
     * Closes the HTML DatePicker if it necessary, validates the date and tells the parent whether or not its valid
     * @param datePicker- NgbDatePicker element ref from the HTML
     */
    onValueApply(datePicker) {
        var _a, _b, _c, _d, _e, _f;
        if (datePicker) {
            datePicker.close();
        }
        // check if date has changed
        if (((_a = this.previousDate) === null || _a === void 0 ? void 0 : _a.day) === ((_b = this.currentDate) === null || _b === void 0 ? void 0 : _b.day) &&
            ((_c = this.previousDate) === null || _c === void 0 ? void 0 : _c.month) === ((_d = this.currentDate) === null || _d === void 0 ? void 0 : _d.month) &&
            ((_e = this.previousDate) === null || _e === void 0 ? void 0 : _e.year) === ((_f = this.currentDate) === null || _f === void 0 ? void 0 : _f.year)) {
            // returns if date has not changed
            return;
        }
        this.previousDate = this.currentDate;
        this.errorClass = !this.dateValidatorService.validateDate(this.currentDate) || (this.required && !this.currentDate);
        this.internalValidationMessage = this.errorClass ? INVALID_FORMAT_MSG : undefined;
        if (this.currentDate && !this.errorClass) {
            this.selectedDateChange.emit(this.selectedDate);
        }
        else {
            // notify parent about date validation failed
            this.selectedDateInvalid.emit({
                date: this.selectedDate,
                message: this.internalValidationMessage,
            });
        }
    }
}
DatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DatePickerComponent, deps: [{ token: LOCALE_ID }, { token: BmppDateHelperService }, { token: BmppDateValidatorService }], target: i0.ɵɵFactoryTarget.Component });
DatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DatePickerComponent, selector: "bmpp-date-picker", inputs: { dataQeIdNamespace: "dataQeIdNamespace", disabled: "disabled", disabledMessage: "disabledMessage", label: "label", required: "required", isExternalValidationError: "isExternalValidationError", selectedDate: "selectedDate", validationMessage: "validationMessage", disableInternalMessage: "disableInternalMessage" }, outputs: { selectedDateChange: "selectedDateChange", selectedDateInvalid: "selectedDateInvalid" }, providers: [{ provide: NgbDateAdapter, useClass: BmppNgbDateStructAdapter }], ngImport: i0, template: "<div\n\tclass=\"form-group bmpp-date-component\"\n\t[ngClass]=\"{ 'bmpp-has-error': errorClass || errorMsg || isExternalValidationError }\"\n>\n\t<label for=\"datePicker\" *ngIf=\"label\">{{ label }}</label>\n\t<span class=\"disabled-label\" *ngIf=\"disabledMessage\">{{ disabledMessage | translate }}</span>\n\t<div class=\"input-group\">\n\t\t<input\n\t\t\tclass=\"form-control bento-datepicker bmpp-date-input\"\n\t\t\tname=\"datePicker\"\n\t\t\tplaceholder=\"{{ dateConfig.format | uppercase }}\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.datePickerInput'\"\n\t\t\tngbDatepicker\n\t\t\t#datePickerInput=\"ngbDatepicker\"\n\t\t\t#dateInput\n\t\t\t[(ngModel)]=\"currentDate\"\n\t\t\t[bentoDatepickerConfig]=\"dateConfig\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\t[firstDayOfWeek]=\"7\"\n\t\t\t[attr.aria-label]=\"label\"\n\t\t\t[attr.aria-invalid]=\"errorMsg && !disableInternalMessage\"\n\t\t\t[attr.aria-describedBy]=\"uniqueInputId\"\n\t\t\t(blur)=\"onValueApply(datePickerInput)\"\n\t\t\t(closed)=\"onValueApply()\"\n\t\t/>\n\t\t<button\n\t\t\taria-haspopup=\"true\"\n\t\t\tclass=\"btn btn-outline-primary btn-icon ml-2\"\n\t\t\ttitle=\"{{ 'bmpp.ng.common.openCalendar' | translate }}\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.datePickerOpenCalendarButton'\"\n\t\t\ttype=\"button\"\n\t\t\t[bentoDatepickerToggle]=\"datePickerInput\"\n\t\t\t[disabled]=\"disabled\"\n\t\t>\n\t\t\t<i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n\t\t</button>\n\t</div>\n\t<div class=\"bmpp-validation-message mt-1\" *ngIf=\"errorMsg && !disableInternalMessage\">\n\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t<span id=\"{{ uniqueInputId }}\">\n\t\t\t{{ errorMsg | translate: { field: label | lowercase, format: dateConfig.format } }}\n\t\t</span>\n\t</div>\n</div>\n", styles: [".disabled-label{color:#939393;display:block;font-size:.9em}.bmpp-date-component .ngb-dp-day.hidden{display:block!important}.bmpp-has-error .form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}\n"], directives: [{ type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.BentoDatepickerConfigDirective, selector: "[bentoDatepickerConfig]", inputs: ["bentoDatepickerConfig"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoDatepickerToggleDirective, selector: "[bentoDatepickerToggle]", inputs: ["bentoDatepickerToggle"] }], pipes: { "translate": i1$1.TranslatePipe, "uppercase": i3.UpperCasePipe, "lowercase": i3.LowerCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-date-picker', providers: [{ provide: NgbDateAdapter, useClass: BmppNgbDateStructAdapter }], template: "<div\n\tclass=\"form-group bmpp-date-component\"\n\t[ngClass]=\"{ 'bmpp-has-error': errorClass || errorMsg || isExternalValidationError }\"\n>\n\t<label for=\"datePicker\" *ngIf=\"label\">{{ label }}</label>\n\t<span class=\"disabled-label\" *ngIf=\"disabledMessage\">{{ disabledMessage | translate }}</span>\n\t<div class=\"input-group\">\n\t\t<input\n\t\t\tclass=\"form-control bento-datepicker bmpp-date-input\"\n\t\t\tname=\"datePicker\"\n\t\t\tplaceholder=\"{{ dateConfig.format | uppercase }}\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.datePickerInput'\"\n\t\t\tngbDatepicker\n\t\t\t#datePickerInput=\"ngbDatepicker\"\n\t\t\t#dateInput\n\t\t\t[(ngModel)]=\"currentDate\"\n\t\t\t[bentoDatepickerConfig]=\"dateConfig\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\t[firstDayOfWeek]=\"7\"\n\t\t\t[attr.aria-label]=\"label\"\n\t\t\t[attr.aria-invalid]=\"errorMsg && !disableInternalMessage\"\n\t\t\t[attr.aria-describedBy]=\"uniqueInputId\"\n\t\t\t(blur)=\"onValueApply(datePickerInput)\"\n\t\t\t(closed)=\"onValueApply()\"\n\t\t/>\n\t\t<button\n\t\t\taria-haspopup=\"true\"\n\t\t\tclass=\"btn btn-outline-primary btn-icon ml-2\"\n\t\t\ttitle=\"{{ 'bmpp.ng.common.openCalendar' | translate }}\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.datePickerOpenCalendarButton'\"\n\t\t\ttype=\"button\"\n\t\t\t[bentoDatepickerToggle]=\"datePickerInput\"\n\t\t\t[disabled]=\"disabled\"\n\t\t>\n\t\t\t<i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n\t\t</button>\n\t</div>\n\t<div class=\"bmpp-validation-message mt-1\" *ngIf=\"errorMsg && !disableInternalMessage\">\n\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t<span id=\"{{ uniqueInputId }}\">\n\t\t\t{{ errorMsg | translate: { field: label | lowercase, format: dateConfig.format } }}\n\t\t</span>\n\t</div>\n</div>\n", styles: [".disabled-label{color:#939393;display:block;font-size:.9em}.bmpp-date-component .ngb-dp-day.hidden{display:block!important}.bmpp-has-error .form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }, { type: BmppDateHelperService }, { type: BmppDateValidatorService }];
    }, propDecorators: { dataQeIdNamespace: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledMessage: [{
                type: Input
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }], isExternalValidationError: [{
                type: Input
            }], selectedDate: [{
                type: Input
            }], validationMessage: [{
                type: Input
            }], disableInternalMessage: [{
                type: Input
            }], selectedDateChange: [{
                type: Output
            }], selectedDateInvalid: [{
                type: Output
            }] } });

/**
 * Renders period frequency select
 */
class PeriodFrequencySelectComponent {
    constructor(locale, dateHelper, store) {
        this.locale = locale;
        this.dateHelper = dateHelper;
        this.store = store;
        this.subscription$ = new Subscription();
        this.periodFrequencies = periodFrequencies;
    }
    ngOnInit() {
        this.selectedPeriodsFrequency$ = this.store.pipe(select(getSelectedPeriodsFrequency));
        this.isCustomPeriodFrequency$ = this.store.pipe(select(getIsCustomPeriodsFrequency));
        this.customPeriodsNumber$ = this.store.pipe(select(getCustomPeriodsNumber));
        this.customPeriodsNumberErrorMessage$ = this.store.pipe(select(getCustomPeriodsNumberErrorMessage));
        const editPeriodsListSubscription$ = this.store.select(getPeriodsViewModels).subscribe(periods => {
            this.periodList = periods;
        });
        const editPeriodsValidationsSubscription$ = this.store
            .select(getPeriodsValidations)
            .subscribe(validations => validations.forEach(validation => this.setPeriodValidationMessage(validation.validationMessage, validation.sequenceNumber)));
        this.store.dispatch(new LoadEditPeriodsState({ periodType: this.periodType }));
        this.dateFormat = this.dateHelper.getFormatPlaceHolder(this.locale);
        this.subscription$.add(editPeriodsListSubscription$);
        this.subscription$.add(editPeriodsValidationsSubscription$);
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    /**
     * Sets validation message for specific period by sequence number
     * @param message - validation message
     * @param periodSequenceNumber - period sequence number
     */
    setPeriodValidationMessage(message, periodSequenceNumber) {
        const period = this.periodList.find(p => p.sequenceNumber === periodSequenceNumber);
        period.validationMessage = message;
    }
    /**
     * Dispatches the `SetSelectedPeriodsFrequency` action.
     * @param periodFrequencyInfo - selected period frequency
     */
    onPeriodFrequencyChange(periodFrequencyInfo) {
        this.store.dispatch(new SetSelectedPeriodsFrequency({ selectedPeriodsFrequency: periodFrequencyInfo }));
    }
    /**
     * Dispatches the `SetCustomPeriodsNumber` action.
     * @param numberOfPeriods - custom periods number
     */
    onNumberOfPeriodsChange(numberOfPeriods) {
        this.store.dispatch(new SetCustomPeriodsNumber({ customPeriodsNumber: numberOfPeriods }));
    }
    /**
     * Parses the `ngbDate` to the `Date` and dispatches the `UpdatePeriodDate` action.
     * @param periodNewEndDate - changed period date
     * @param periodSequenceNumber - period sequence number
     */
    onPeriodDateChange(periodNewEndDate, periodSequenceNumber) {
        this.store.dispatch(new UpdatePeriodDate({ periodNewEndDate, periodSequenceNumber }));
    }
    /**
     * Dispatches the `ValidatePeriodDateFailure` action.
     * @param periodSequenceNumber - sequence number of the period.
     */
    onPeriodDateInvalid(event, periodSequenceNumber) {
        this.store.dispatch(new ValidatePeriodDateFailure({
            validationResult: {
                validationMessage: event.message,
                sequenceNumber: periodSequenceNumber,
            },
        }));
    }
}
PeriodFrequencySelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencySelectComponent, deps: [{ token: LOCALE_ID }, { token: BmppDateHelperService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
PeriodFrequencySelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: PeriodFrequencySelectComponent, selector: "bmpp-period-frequency-select", inputs: { periodType: "periodType", dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<div class=\"row\">\n\t<div class=\"col-6 mb-4\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-4 col-md-6 col-sm-10\">\n\t\t\t\t<label for=\"periodFrequencySelect\">{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"periodFrequencySelect\"\n\t\t\t\t\t[ngModel]=\"selectedPeriodsFrequency$ | async\"\n\t\t\t\t\t(ngModelChange)=\"onPeriodFrequencyChange($event)\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.PeriodFrequencySelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option *ngFor=\"let periodFrequency of periodFrequencies\" [ngValue]=\"periodFrequency\">\n\t\t\t\t\t\t{{ periodFrequency.display | translate }}\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class=\"col-lg-8\" *ngIf=\"isCustomPeriodFrequency$ | async\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-lg-6 col-md-6 col-sm-10\">\n\t\t\t\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.numberOfPeriods' | translate }}</label>\n\t\t\t\t\t\t<input\n\t\t\t\t\t\t\tclass=\"form-control bmpp-date-input\"\n\t\t\t\t\t\t\t[ngClass]=\"{'bmpp-has-error': customPeriodsNumberErrorMessage$ | async}\"\n\t\t\t\t\t\t\t[ngModel]=\"customPeriodsNumber$ | async\"\n\t\t\t\t\t\t\t(ngModelChange)=\"onNumberOfPeriodsChange($event)\"\n\t\t\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.NumberOfPeriodsInput'\"\n\t\t\t\t\t\t\ttype=\"number\"\n\t\t\t\t\t\t/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" *ngIf=\"customPeriodsNumberErrorMessage$ | async\">\n\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 bmpp-validation-message mt-1\">\n\t\t\t\t\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t\t\t\t\t<span>{{ customPeriodsNumberErrorMessage$ | async | translate }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"row\">\n\t<div class=\"col-6 mb-4\">\n\t\t<ng-container *ngIf=\"periodList\">\n\t\t\t<div class=\"row\" *ngFor=\"let period of periodList; let last=last\">\n\t\t\t\t<div class=\"col-12\">\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<div class=\"col-lg-4 col-md-6 col-sm-10\">\n\t\t\t\t\t\t\t<label for=\"periodDatePicker\"\n\t\t\t\t\t\t\t\t>{{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber }}</label\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<bmpp-date-picker\n\t\t\t\t\t\t\t\t[disabled]=\"last\"\n\t\t\t\t\t\t\t\tdisableInternalMessage=\"true\"\n\t\t\t\t\t\t\t\tattr.data-qe-id=\"{{dataQeIdNamespace}}.periodListWizard.periodEndDateSelect-{{period.sequenceNumber}}\"\n\t\t\t\t\t\t\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.periodEndDateSelect-' + period.sequenceNumber\"\n\t\t\t\t\t\t\t\t(selectedDateChange)=\"onPeriodDateChange($event, period.sequenceNumber)\"\n\t\t\t\t\t\t\t\t(selectedDateInvalid)=\"onPeriodDateInvalid($event, period.sequenceNumber)\"\n\t\t\t\t\t\t\t\t[selectedDate]=\"period.endDate\"\n\t\t\t\t\t\t\t\t[isExternalValidationError]=\"!!period.validationMessage\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t</bmpp-date-picker>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"row\" *ngIf=\"period.validationMessage\">\n\t\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 bmpp-validation-message mb-3\">\n\t\t\t\t\t\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t>{{ period.validationMessage | translate : { field: 'bmpp.ng.periods.edit.wizard.step1.periodEndDate' |\n\t\t\t\t\t\t\t\ttranslate | lowercase, format: dateFormat } }}</span\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</ng-container>\n\t</div>\n</div>\n", styles: [".bmpp-has-error.form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}\n"], components: [{ type: DatePickerComponent, selector: "bmpp-date-picker", inputs: ["dataQeIdNamespace", "disabled", "disabledMessage", "label", "required", "isExternalValidationError", "selectedDate", "validationMessage", "disableInternalMessage"], outputs: ["selectedDateChange", "selectedDateInvalid"] }], directives: [{ type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i1$1.TranslatePipe, "async": i3.AsyncPipe, "lowercase": i3.LowerCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencySelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-period-frequency-select', template: "<div class=\"row\">\n\t<div class=\"col-6 mb-4\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-4 col-md-6 col-sm-10\">\n\t\t\t\t<label for=\"periodFrequencySelect\">{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"periodFrequencySelect\"\n\t\t\t\t\t[ngModel]=\"selectedPeriodsFrequency$ | async\"\n\t\t\t\t\t(ngModelChange)=\"onPeriodFrequencyChange($event)\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.PeriodFrequencySelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option *ngFor=\"let periodFrequency of periodFrequencies\" [ngValue]=\"periodFrequency\">\n\t\t\t\t\t\t{{ periodFrequency.display | translate }}\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div class=\"col-lg-8\" *ngIf=\"isCustomPeriodFrequency$ | async\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-lg-6 col-md-6 col-sm-10\">\n\t\t\t\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.numberOfPeriods' | translate }}</label>\n\t\t\t\t\t\t<input\n\t\t\t\t\t\t\tclass=\"form-control bmpp-date-input\"\n\t\t\t\t\t\t\t[ngClass]=\"{'bmpp-has-error': customPeriodsNumberErrorMessage$ | async}\"\n\t\t\t\t\t\t\t[ngModel]=\"customPeriodsNumber$ | async\"\n\t\t\t\t\t\t\t(ngModelChange)=\"onNumberOfPeriodsChange($event)\"\n\t\t\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.NumberOfPeriodsInput'\"\n\t\t\t\t\t\t\ttype=\"number\"\n\t\t\t\t\t\t/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" *ngIf=\"customPeriodsNumberErrorMessage$ | async\">\n\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 bmpp-validation-message mt-1\">\n\t\t\t\t\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t\t\t\t\t<span>{{ customPeriodsNumberErrorMessage$ | async | translate }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"row\">\n\t<div class=\"col-6 mb-4\">\n\t\t<ng-container *ngIf=\"periodList\">\n\t\t\t<div class=\"row\" *ngFor=\"let period of periodList; let last=last\">\n\t\t\t\t<div class=\"col-12\">\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<div class=\"col-lg-4 col-md-6 col-sm-10\">\n\t\t\t\t\t\t\t<label for=\"periodDatePicker\"\n\t\t\t\t\t\t\t\t>{{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber }}</label\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<bmpp-date-picker\n\t\t\t\t\t\t\t\t[disabled]=\"last\"\n\t\t\t\t\t\t\t\tdisableInternalMessage=\"true\"\n\t\t\t\t\t\t\t\tattr.data-qe-id=\"{{dataQeIdNamespace}}.periodListWizard.periodEndDateSelect-{{period.sequenceNumber}}\"\n\t\t\t\t\t\t\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.periodEndDateSelect-' + period.sequenceNumber\"\n\t\t\t\t\t\t\t\t(selectedDateChange)=\"onPeriodDateChange($event, period.sequenceNumber)\"\n\t\t\t\t\t\t\t\t(selectedDateInvalid)=\"onPeriodDateInvalid($event, period.sequenceNumber)\"\n\t\t\t\t\t\t\t\t[selectedDate]=\"period.endDate\"\n\t\t\t\t\t\t\t\t[isExternalValidationError]=\"!!period.validationMessage\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t</bmpp-date-picker>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"row\" *ngIf=\"period.validationMessage\">\n\t\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 bmpp-validation-message mb-3\">\n\t\t\t\t\t\t\t<i class=\"bento-icon-warning-filled\"></i>\n\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t>{{ period.validationMessage | translate : { field: 'bmpp.ng.periods.edit.wizard.step1.periodEndDate' |\n\t\t\t\t\t\t\t\ttranslate | lowercase, format: dateFormat } }}</span\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</ng-container>\n\t</div>\n</div>\n", styles: [".bmpp-has-error.form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }, { type: BmppDateHelperService }, { type: i2.Store }];
    }, propDecorators: { periodType: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }] } });

class EditPeriodsFrequencyInformationComponent {
    constructor(dateHelperService, store) {
        this.dateHelperService = dateHelperService;
        this.store = store;
    }
    ngOnInit() {
        // starts watching selected fiscal year to get its begin and end date
        this.fiscalYear$ = this.store.pipe(select(getSelectedFiscalYear), filter(year => year !== undefined));
        // starts watching selected fiscal year to get its tax code year
        this.taxCodeYear$ = this.store.pipe(select(getSelectedFiscalYear), filter(year => year !== undefined), map(year => year.taxCodeYear));
    }
    /**
     * Presents date in current region format
     * @param date - date of fiscal year to be fromated depends on region
     */
    formatDate(date) {
        return this.dateHelperService.getFormattedDate(date);
    }
}
EditPeriodsFrequencyInformationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditPeriodsFrequencyInformationComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
EditPeriodsFrequencyInformationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EditPeriodsFrequencyInformationComponent, selector: "bmpp-edit-periods-frequency-information", inputs: { periodType: "periodType", dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<div class=\"container-fluid pl-0 pt-4\">\n\t<div class=\"row\">\n\t\t<div class=\"col-12 mb-4\">\n\t\t\t<label> {{ 'bmpp.ng.periods.edit.wizard.step1.text' | translate }} </label>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"fiscalYear$ | async as fiscalYear\">\n\t\t<div class=\"col-auto mr-5\">\n\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.yearBeginDate' | translate }}</label><br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ formatDate(fiscalYear.startDate) }} </span>\n\t\t</div>\n\t\t<div class=\"col-auto mb-4\">\n\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.yearEndDate' | translate }}</label><br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ formatDate(fiscalYear.endDate) }} </span>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"taxCodeYear$ | async as taxCodeYear\">\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-3 mb-4\">\n\t\t\t<label\n\t\t\t\t>{{ 'bmpp.ng.periods.edit.wizard.step1.taxYear' | translate }}\n\t\t\t\t<i\n\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t[attr.aria-label]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\t\t\t\tngbTooltip=\"{{ 'bmpp.ng.client.taxYearTooltip' | translate }}\"\n\t\t\t\t\tplacement=\"right\"\n\t\t\t\t\tclass=\"bento-icon-info-filled bmpp-icon-info-tooltip pl-2\"\n\t\t\t\t></i>\n\t\t\t</label>\n\t\t\t<br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ taxCodeYear }} </span>\n\t\t</div>\n\t</div>\n\t<bmpp-period-frequency-select\n\t\t[periodType]=\"periodType\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace\"\n\t></bmpp-period-frequency-select>\n</div>\n", components: [{ type: PeriodFrequencySelectComponent, selector: "bmpp-period-frequency-select", inputs: ["periodType", "dataQeIdNamespace"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }], pipes: { "translate": i1$1.TranslatePipe, "async": i3.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditPeriodsFrequencyInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-edit-periods-frequency-information', template: "<div class=\"container-fluid pl-0 pt-4\">\n\t<div class=\"row\">\n\t\t<div class=\"col-12 mb-4\">\n\t\t\t<label> {{ 'bmpp.ng.periods.edit.wizard.step1.text' | translate }} </label>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"fiscalYear$ | async as fiscalYear\">\n\t\t<div class=\"col-auto mr-5\">\n\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.yearBeginDate' | translate }}</label><br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ formatDate(fiscalYear.startDate) }} </span>\n\t\t</div>\n\t\t<div class=\"col-auto mb-4\">\n\t\t\t<label>{{ 'bmpp.ng.periods.edit.wizard.step1.yearEndDate' | translate }}</label><br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ formatDate(fiscalYear.endDate) }} </span>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"taxCodeYear$ | async as taxCodeYear\">\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-3 mb-4\">\n\t\t\t<label\n\t\t\t\t>{{ 'bmpp.ng.periods.edit.wizard.step1.taxYear' | translate }}\n\t\t\t\t<i\n\t\t\t\t\ttabindex=\"0\"\n\t\t\t\t\t[attr.aria-label]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\t\t\t\tngbTooltip=\"{{ 'bmpp.ng.client.taxYearTooltip' | translate }}\"\n\t\t\t\t\tplacement=\"right\"\n\t\t\t\t\tclass=\"bento-icon-info-filled bmpp-icon-info-tooltip pl-2\"\n\t\t\t\t></i>\n\t\t\t</label>\n\t\t\t<br />\n\t\t\t<span class=\"font-weight-bold pl-2\">{{ taxCodeYear }} </span>\n\t\t</div>\n\t</div>\n\t<bmpp-period-frequency-select\n\t\t[periodType]=\"periodType\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace\"\n\t></bmpp-period-frequency-select>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }] } });

/**
 * Renders period list of selected period frequency or selected fiscal year
 */
class PeriodsMappingComponent {
    constructor(dateHelper, store) {
        this.dateHelper = dateHelper;
        this.store = store;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        this.newPeriodsFrequencyName$ = this.store.select(getSelectedPeriodsFrequency);
        this.currentPeriodsFrequencyName$ = this.store.select(getCurrentPeriodsFrequency);
        const getPeriodsForMappingSubscription$ = this.store
            .select(getPeriodsForMapping)
            .subscribe(({ newPeriods, existedPeriods }) => {
            // We need the timeout here to correctly show the bento sticky footer
            setTimeout(() => {
                this.mapToPeriods = newPeriods.map(period => this.mapPeriodToMappingView(period));
                this.setMappingView(existedPeriods, newPeriods);
            });
        });
        this.subscription$.add(getPeriodsForMappingSubscription$);
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    /**
     * Set view model to represent mapping data on mapping table
     * @param mappedPeriods - periods mapped into new
     * @param newPeriods - periods with mapping ids
     */
    setMappingView(mappedPeriods, newPeriods) {
        this.periodsMappingView = newPeriods.map(period => {
            const mappedPeriodsView = mappedPeriods
                .filter(mappedPeriod => mappedPeriod.mappingId === period.mappingId)
                .map(p => this.mapPeriodToMappingView(p));
            return this.mapPeriodToMappingView(period, mappedPeriodsView);
        });
    }
    /**
     * Handler on mapping change event
     * @param sequenceNumber - sequence number of period to be mapped
     * @param mappingId - mapping id of period to map to
     */
    onMappingChange(sequenceNumber, mappingId) {
        this.store.dispatch(new MapPeriod({ periodSequenceNumber: sequenceNumber, newMappingId: mappingId }));
    }
    /**
     * Presents date in current region format
     * @param periodEndDate - date of period end to be formated depends on region
     */
    formatPeriodEndDate(periodEndDate) {
        return this.dateHelper.getFormattedDate(periodEndDate);
    }
    /**
     * Map function for mapping `Period` to `PeriodMappingView`.
     * @param period - Period to map.
     * @param mappedPeriodsView - Optional parameter. The already mapped periods view for current period.
     * @returns PeridMappingView instance.
     */
    mapPeriodToMappingView(period, mappedPeriodsView) {
        return {
            endDate: this.formatPeriodEndDate(period.endDate),
            mappingId: period.mappingId,
            sequenceNumber: period.sequenceNumber,
            mappedPeriods: mappedPeriodsView !== null && mappedPeriodsView !== void 0 ? mappedPeriodsView : [],
        };
    }
}
PeriodsMappingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsMappingComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
PeriodsMappingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: PeriodsMappingComponent, selector: "bmpp-periods-mapping", inputs: { periodType: "periodType" }, ngImport: i0, template: "<div class=\"container-fluid pl-0 pt-4\">\n\t<div class=\"row\">\n\t\t<div class=\"col-12 mb-3\">\n\t\t\t<label> {{ 'bmpp.ng.periods.edit.wizard.step2.text' | translate }} </label>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-6 mb-3\">\n\t\t\t<table class=\"table table-bordered\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"w-50\" scope=\"col\">\n\t\t\t\t\t\t\t{{ 'bmpp.ng.periods.edit.wizard.step2.existingPeriods' | translate }} ({{ (currentPeriodsFrequencyName$ |\n\t\t\t\t\t\t\tasync).display | translate }})\n\t\t\t\t\t\t</th>\n\t\t\t\t\t\t<th class=\"w-50\" scope=\"col\">\n\t\t\t\t\t\t\t{{ 'bmpp.ng.periods.edit.wizard.step2.newPeriods' | translate }} ({{ (newPeriodsFrequencyName$ | async).display |\n\t\t\t\t\t\t\ttranslate }})\n\t\t\t\t\t\t</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr *ngFor=\"let mappingPeriod of periodsMappingView\">\n\t\t\t\t\t\t<td class=\"\" style=\"padding: 0\">\n\t\t\t\t\t\t\t<ul class=\"list-group list-group-flush\">\n\t\t\t\t\t\t\t\t<li\n\t\t\t\t\t\t\t\t\t[ngClass]=\"{ highlight: mappedPeriodSequenceNumber === mappedPeriod.sequenceNumber }\"\n\t\t\t\t\t\t\t\t\t*ngFor=\"let mappedPeriod of mappingPeriod.mappedPeriods\"\n\t\t\t\t\t\t\t\t\tclass=\"list-group-item nothighlight\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappedPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappedPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t\t<div ngbDropdown class=\"dropdown grid-dropdown float-right\">\n\t\t\t\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-outline-primary btn-xs dropdown-toggle\"\n\t\t\t\t\t\t\t\t\t\t\tdata-qe-id=\"bmpp.periodListWizard.mapToButton\"\n\t\t\t\t\t\t\t\t\t\t\tngbDropdownToggle\n\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t<b>{{ 'bmpp.ng.periods.edit.wizard.step2.mapTo' | translate }}</b>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"bento-icon-caret-down-filled\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<div ngbDropdownMenu class=\"dropdown-menu grid-dropdown\" aria-labelledby=\"dropdownBasic1\">\n\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let mapToPeriod of mapToPeriods\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t\t\t\t\t\tngbDropdownItem\n\t\t\t\t\t\t\t\t\t\t\t\t\tclass=\"dropdown-item\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t[disabled]=\"mappingPeriod.mappingId === mapToPeriod.mappingId\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t(click)=\"onMappingChange(mappedPeriod.sequenceNumber, mapToPeriod.mappingId)\"\n\t\t\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{ mapToPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\t\t\t\t\tmapToPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=\"align-middle\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t\tclass=\"font-weight-bold\"\n\t\t\t\t\t\t\t\t\t*ngIf=\"\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods &&\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0] &&\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0].mappingId === mappingPeriod.mappingId\n\t\t\t\t\t\t\t\t\t\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappingPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappingPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t\t*ngIf=\"\n\t\t\t\t\t\t\t\t\t\t!(\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods &&\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0] &&\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0].mappingId === mappingPeriod.mappingId\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappingPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappingPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#bentoNGModalContainer.ng-bento .dropdown-menu{max-height:250px;overflow-x:hidden;overflow-y:auto;padding:0 10px 0 5px;width:-moz-max-content;width:max-content}#bentoNGModalContainer.ng-bento .highlight{animation:highlight-in .1s ease-in 5s forwards;background-color:#d4ebf4}.bmpp-float-right{float:right}@keyframes highlight-in{0%{background-color:#d4ebf4}to{background-color:#fff}}\n"], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i5.BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe, "async": i3.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsMappingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-periods-mapping', encapsulation: ViewEncapsulation.None, template: "<div class=\"container-fluid pl-0 pt-4\">\n\t<div class=\"row\">\n\t\t<div class=\"col-12 mb-3\">\n\t\t\t<label> {{ 'bmpp.ng.periods.edit.wizard.step2.text' | translate }} </label>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-6 mb-3\">\n\t\t\t<table class=\"table table-bordered\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"w-50\" scope=\"col\">\n\t\t\t\t\t\t\t{{ 'bmpp.ng.periods.edit.wizard.step2.existingPeriods' | translate }} ({{ (currentPeriodsFrequencyName$ |\n\t\t\t\t\t\t\tasync).display | translate }})\n\t\t\t\t\t\t</th>\n\t\t\t\t\t\t<th class=\"w-50\" scope=\"col\">\n\t\t\t\t\t\t\t{{ 'bmpp.ng.periods.edit.wizard.step2.newPeriods' | translate }} ({{ (newPeriodsFrequencyName$ | async).display |\n\t\t\t\t\t\t\ttranslate }})\n\t\t\t\t\t\t</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr *ngFor=\"let mappingPeriod of periodsMappingView\">\n\t\t\t\t\t\t<td class=\"\" style=\"padding: 0\">\n\t\t\t\t\t\t\t<ul class=\"list-group list-group-flush\">\n\t\t\t\t\t\t\t\t<li\n\t\t\t\t\t\t\t\t\t[ngClass]=\"{ highlight: mappedPeriodSequenceNumber === mappedPeriod.sequenceNumber }\"\n\t\t\t\t\t\t\t\t\t*ngFor=\"let mappedPeriod of mappingPeriod.mappedPeriods\"\n\t\t\t\t\t\t\t\t\tclass=\"list-group-item nothighlight\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappedPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappedPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t\t<div ngbDropdown class=\"dropdown grid-dropdown float-right\">\n\t\t\t\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-outline-primary btn-xs dropdown-toggle\"\n\t\t\t\t\t\t\t\t\t\t\tdata-qe-id=\"bmpp.periodListWizard.mapToButton\"\n\t\t\t\t\t\t\t\t\t\t\tngbDropdownToggle\n\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t<b>{{ 'bmpp.ng.periods.edit.wizard.step2.mapTo' | translate }}</b>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"bento-icon-caret-down-filled\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<div ngbDropdownMenu class=\"dropdown-menu grid-dropdown\" aria-labelledby=\"dropdownBasic1\">\n\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let mapToPeriod of mapToPeriods\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t\t\t\t\t\tngbDropdownItem\n\t\t\t\t\t\t\t\t\t\t\t\t\tclass=\"dropdown-item\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t[disabled]=\"mappingPeriod.mappingId === mapToPeriod.mappingId\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t(click)=\"onMappingChange(mappedPeriod.sequenceNumber, mapToPeriod.mappingId)\"\n\t\t\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{ mapToPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\t\t\t\t\tmapToPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td class=\"align-middle\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t\tclass=\"font-weight-bold\"\n\t\t\t\t\t\t\t\t\t*ngIf=\"\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods &&\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0] &&\n\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0].mappingId === mappingPeriod.mappingId\n\t\t\t\t\t\t\t\t\t\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappingPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappingPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\t\t*ngIf=\"\n\t\t\t\t\t\t\t\t\t\t!(\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods &&\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0] &&\n\t\t\t\t\t\t\t\t\t\t\tmappingPeriod.mappedPeriods[0].mappingId === mappingPeriod.mappingId\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{ mappingPeriod.endDate }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\t\t\t\tmappingPeriod.sequenceNumber }})\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#bentoNGModalContainer.ng-bento .dropdown-menu{max-height:250px;overflow-x:hidden;overflow-y:auto;padding:0 10px 0 5px;width:-moz-max-content;width:max-content}#bentoNGModalContainer.ng-bento .highlight{animation:highlight-in .1s ease-in 5s forwards;background-color:#d4ebf4}.bmpp-float-right{float:right}@keyframes highlight-in{0%{background-color:#d4ebf4}to{background-color:#fff}}\n"] }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }] } });

var ConfirmComponentDefaultButtonsText;
(function (ConfirmComponentDefaultButtonsText) {
    ConfirmComponentDefaultButtonsText["Confirm"] = "bmpp.ng.common.confirm";
    ConfirmComponentDefaultButtonsText["Cancel"] = "bmpp.ng.common.cancel";
})(ConfirmComponentDefaultButtonsText || (ConfirmComponentDefaultButtonsText = {}));

class ConfirmationDialogComponent {
    constructor(store) {
        this.store = store;
        this.confirmButtonText = ConfirmComponentDefaultButtonsText.Confirm;
        this.cancelButtonText = ConfirmComponentDefaultButtonsText.Cancel;
    }
    ngOnInit() {
        this.loadEntryPoint();
    }
    /**
     * Loades the specific entry point (Contact, Client or Firm)
     */
    loadEntryPoint() {
        return __awaiter(this, void 0, void 0, function* () {
            this.entryPoint = yield this.store
                .pipe(select(getEntryPoint), first(entryPoint => entryPoint !== undefined))
                .toPromise();
        });
    }
    /**
     * Closes the modal successfully
     */
    confirm() {
        this.activeModal.close();
    }
    /**
     * Dismiss the modal on cancel button click
     */
    cancel() {
        this.activeModal.dismiss();
    }
}
ConfirmationDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ConfirmationDialogComponent, deps: [{ token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
ConfirmationDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: ConfirmationDialogComponent, selector: "bmpp-confirmation-dialog", inputs: { confirmButtonText: "confirmButtonText", cancelButtonText: "cancelButtonText", activeModal: "activeModal", dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<div class=\"modal-body modal-confirm-body\">\n\t<div class=\"modal-confirm-message\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t[attr.data-qe-id]=\"'bmpp.' + entryPoint + '.' +  dataQeIdNamespace + '.confirmDialog.confirmButton'\"\n\t\t(click)=\"confirm()\"\n\t>\n\t\t{{ confirmButtonText | translate }}\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-outline-primary\"\n\t\t[attr.data-qe-id]=\"'bmpp.' + entryPoint + '.' + dataQeIdNamespace + '.confirmDialog.cancelButton'\"\n\t\t(click)=\"cancel()\"\n\t>\n\t\t{{ cancelButtonText | translate }}\n\t</button>\n</div>\n", directives: [{ type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-confirmation-dialog', template: "<div class=\"modal-body modal-confirm-body\">\n\t<div class=\"modal-confirm-message\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t[attr.data-qe-id]=\"'bmpp.' + entryPoint + '.' +  dataQeIdNamespace + '.confirmDialog.confirmButton'\"\n\t\t(click)=\"confirm()\"\n\t>\n\t\t{{ confirmButtonText | translate }}\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-outline-primary\"\n\t\t[attr.data-qe-id]=\"'bmpp.' + entryPoint + '.' + dataQeIdNamespace + '.confirmDialog.cancelButton'\"\n\t\t(click)=\"cancel()\"\n\t>\n\t\t{{ cancelButtonText | translate }}\n\t</button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i2.Store }]; }, propDecorators: { confirmButtonText: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], activeModal: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }] } });

class EditAccountingPeriodsModalComponent {
    constructor(activeModal, modalService, store, alertService) {
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.store = store;
        this.alertService = alertService;
        this.alerts = [];
        this.isMappingDisabled = false;
        this.subscription$ = new Subscription();
        this.currentStep = EditPeriodsWizardSteps.EditStep;
        this.modalOptions = {
            backdrop: 'static',
            size: 'md',
            windowClass: 'bmpp-confirmation-dialog',
            container: '#bentoNGModalContainer',
        };
    }
    ngOnInit() {
        const editPeriodsIsValidSubscription$ = this.store
            .select(getIsValid)
            .subscribe(isValid => (this.isMappingDisabled = !isValid));
        const editPeriodsIsEditedSubscription$ = this.store
            .select(getIsEdited)
            .subscribe(isEdited => (this.isPeriodListEdited = isEdited));
        this.subscription$.add(editPeriodsIsValidSubscription$);
        this.subscription$.add(editPeriodsIsEditedSubscription$);
        // subscribe to alerts service ahead, following async actions can eventualy push alert
        this.subscription$.add(this.alertService.onAlertAdded.subscribe((alert) => this.alerts.push(alert)));
        this.subscription$.add(this.alertService.clearAll.subscribe(() => (this.alerts = [])));
    }
    ngOnDestroy() {
        this.alertService.clearAll.emit();
        this.store.dispatch(new ResetEditPeriodState());
        this.subscription$.unsubscribe();
    }
    /**
     * cancel button click handler
     */
    onCancel() {
        if (this.currentStep === EditPeriodsWizardSteps.MapStep) {
            this.openDiscardChangesConfirmationModal(EntryPoints.cancelButton, true);
        }
        else {
            this.activeModal.dismiss();
        }
    }
    /**
     * On step changing handler
     * @param event - wizard component event
     */
    onStepChanging(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const step = event.step;
            this.store.dispatch(new TriggerCustomPeriodsNumberValidation());
            if (this.stopStepChangePropagation(step)) {
                event.stopPropagation();
                return;
            }
            this.stepChange(step);
        });
    }
    stopStepChangePropagation(step) {
        if (step === EditPeriodsWizardSteps.EditStep) {
            this.openDiscardChangesConfirmationModal(EntryPoints.previousButton);
            return true;
        }
        if (!this.isPeriodListEdited) {
            this.alertService.addWarningAlert('bmpp.ng.periods.edit.wizard.step1.mustMakeChangesWarning');
            return true;
        }
        return this.isMappingDisabled;
    }
    stepChange(step) {
        this.currentStep = step;
        this.isFirstStepComplete = !this.isFirstStepComplete;
        switch (step) {
            case EditPeriodsWizardSteps.MapStep:
                this.store.dispatch(new MapPeriods());
                break;
            case EditPeriodsWizardSteps.EditStep:
                this.store.dispatch(new DiscardMapping());
                break;
            default:
                break;
        }
    }
    /**
     * Open the confirmation pop-up of the cancellation of mapping changes
     * @param entryPointBtn - entry point button for the confirmation pop-up
     */
    openDiscardChangesConfirmationModal(entryPointBtn, dismissModal) {
        return __awaiter(this, void 0, void 0, function* () {
            this.modalService
                .open(this.discardChangesConfirmation, this.modalOptions)
                .result.then(() => (dismissModal ? this.activeModal.dismiss() : this.onDiscardChangesCofirmed()));
            this.entryPointButton = entryPointBtn;
        });
    }
    onDiscardChangesCofirmed() {
        this.wizard.currentStep = EditPeriodsWizardSteps.EditStep;
        this.currentStep = EditPeriodsWizardSteps.EditStep;
        this.store.dispatch(new DiscardMapping());
    }
    openSaveConfirmationModal() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.modalService.open(this.saveConfirmation, this.modalOptions).result.then(() => {
                this.store.dispatch(new SavePeriodsMapping());
                this.activeModal.close();
            });
        });
    }
}
EditAccountingPeriodsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditAccountingPeriodsModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: i1$2.NgbModal }, { token: i2.Store }, { token: BmppAlertService }], target: i0.ɵɵFactoryTarget.Component });
EditAccountingPeriodsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EditAccountingPeriodsModalComponent, selector: "bmpp-edit-accounting-periods-modal", inputs: { periodType: "periodType" }, viewQueries: [{ propertyName: "wizard", first: true, predicate: ["wizard"], descendants: true, static: true }, { propertyName: "discardChangesConfirmation", first: true, predicate: ["discardChangesConfirmation"], descendants: true, static: true }, { propertyName: "saveConfirmation", first: true, predicate: ["saveConfirmation"], descendants: true, static: true }], ngImport: i0, template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"modal-header\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row py-2\">\n\t\t\t<div class=\"col-md-4 col-sm-4 hidden-xs text-left\">\n\t\t\t\t<h3 id=\"modal-basic-title\">{{ 'bmpp.ng.fiscal.year.periods.editAccountingPeriods' | translate | titlecase }}</h3>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-outline-primary mt-1\"\n\t\t\t\t\taria-label=\"Cancel\"\n\t\t\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.cancelButton\"\n\t\t\t\t\t(click)=\"onCancel()\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.periods.edit.cancel' | translate | titlecase }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"modal-body\">\n\t<bento-wizard\n\t\t#wizard\n\t\t[useStickyFooter]=\"true\"\n\t\t[stickyFooterFullWidth]=\"true\"\n\t\t(currentStepChanging)=\"onStepChanging($event)\"\n\t\t(done)=\"openSaveConfirmationModal()\"\n\t>\n\t\t<bento-wizard-step\n\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.editPeriodsStep1Hyperlink\"\n\t\t\t[title]=\"'bmpp.ng.periods.edit.wizard.step1.title' | translate\"\n\t\t\tdescription=\"{{ 'bmpp.ng.periods.edit.wizard.step1.description' | translate }}\"\n\t\t\t[completed]=\"isFirstStepComplete\"\n\t\t>\n\t\t\t<bmpp-edit-periods-frequency-information\n\t\t\t\t[periodType]=\"periodType\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.editPeriodsModal'\"\n\t\t\t></bmpp-edit-periods-frequency-information>\n\t\t</bento-wizard-step>\n\t\t<bento-wizard-step\n\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.mapPeriodsStep2Hyperlink\"\n\t\t\t[title]=\"'bmpp.ng.periods.edit.wizard.step2.title' | translate\"\n\t\t\tdescription=\"{{ 'bmpp.ng.periods.edit.wizard.step2.description' | translate }}\"\n\t\t\t[disabled]=\"isMappingDisabled\"\n\t\t>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-9\">\n\t\t\t\t\t<bmpp-periods-mapping [periodType]=\"periodType\" *ngIf=\"isPeriodListEdited\"></bmpp-periods-mapping>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</bento-wizard-step>\n\t</bento-wizard>\n</div>\n\n<ng-template #discardChangesConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-step-back-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"entryPointButton + '.discardMappingChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-confirmation-text-body\">\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.discardChanges.bodyText' | translate }}</span>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n\n<ng-template #saveConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-save-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"'saveMappingChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-confirmation-text-body\">\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.saveConfirmation.bodyText' | translate }}</span>\n\t\t\t<br />\n\t\t\t<br />\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.saveConfirmation.question' | translate }}</span>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n", styles: [".ng-bento ngb-modal-window.bmpp-edit-accounting-periods-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}.bmpp-step-back-confirmation .bmpp-confirmation-text-body,.bmpp-save-confirmation .bmpp-confirmation-text-body{vertical-align:top;width:85%}\n"], components: [{ type: i5.BentoAlertComponent, selector: "bento-alert", inputs: ["items", "inline", "grabFocus"], outputs: ["close"] }, { type: i5.BentoWizardComponent, selector: "bento-wizard", inputs: ["hideDefaultButtons", "hidePreviousButton", "hideNextButton", "hideDoneButton", "showCancelButton", "useStickyFooter", "stickyFooterFullWidth", "currentStep", "hTag"], outputs: ["currentStepChange", "currentStepChanging", "cancel", "done"] }, { type: i5.BentoWizardStepComponent, selector: "bento-wizard-step", inputs: ["title", "description", "disabled", "completed"] }, { type: EditPeriodsFrequencyInformationComponent, selector: "bmpp-edit-periods-frequency-information", inputs: ["periodType", "dataQeIdNamespace"] }, { type: PeriodsMappingComponent, selector: "bmpp-periods-mapping", inputs: ["periodType"] }, { type: ConfirmationDialogComponent, selector: "bmpp-confirmation-dialog", inputs: ["confirmButtonText", "cancelButtonText", "activeModal", "dataQeIdNamespace"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "titlecase": i3.TitleCasePipe, "translate": i1$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditAccountingPeriodsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-edit-accounting-periods-modal', encapsulation: ViewEncapsulation.None, template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"modal-header\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row py-2\">\n\t\t\t<div class=\"col-md-4 col-sm-4 hidden-xs text-left\">\n\t\t\t\t<h3 id=\"modal-basic-title\">{{ 'bmpp.ng.fiscal.year.periods.editAccountingPeriods' | translate | titlecase }}</h3>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-outline-primary mt-1\"\n\t\t\t\t\taria-label=\"Cancel\"\n\t\t\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.cancelButton\"\n\t\t\t\t\t(click)=\"onCancel()\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.periods.edit.cancel' | translate | titlecase }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"modal-body\">\n\t<bento-wizard\n\t\t#wizard\n\t\t[useStickyFooter]=\"true\"\n\t\t[stickyFooterFullWidth]=\"true\"\n\t\t(currentStepChanging)=\"onStepChanging($event)\"\n\t\t(done)=\"openSaveConfirmationModal()\"\n\t>\n\t\t<bento-wizard-step\n\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.editPeriodsStep1Hyperlink\"\n\t\t\t[title]=\"'bmpp.ng.periods.edit.wizard.step1.title' | translate\"\n\t\t\tdescription=\"{{ 'bmpp.ng.periods.edit.wizard.step1.description' | translate }}\"\n\t\t\t[completed]=\"isFirstStepComplete\"\n\t\t>\n\t\t\t<bmpp-edit-periods-frequency-information\n\t\t\t\t[periodType]=\"periodType\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.editPeriodsModal'\"\n\t\t\t></bmpp-edit-periods-frequency-information>\n\t\t</bento-wizard-step>\n\t\t<bento-wizard-step\n\t\t\tdata-qe-id=\"bmpp.editPeriodsModal.mapPeriodsStep2Hyperlink\"\n\t\t\t[title]=\"'bmpp.ng.periods.edit.wizard.step2.title' | translate\"\n\t\t\tdescription=\"{{ 'bmpp.ng.periods.edit.wizard.step2.description' | translate }}\"\n\t\t\t[disabled]=\"isMappingDisabled\"\n\t\t>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-9\">\n\t\t\t\t\t<bmpp-periods-mapping [periodType]=\"periodType\" *ngIf=\"isPeriodListEdited\"></bmpp-periods-mapping>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</bento-wizard-step>\n\t</bento-wizard>\n</div>\n\n<ng-template #discardChangesConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-step-back-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"entryPointButton + '.discardMappingChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-confirmation-text-body\">\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.discardChanges.bodyText' | translate }}</span>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n\n<ng-template #saveConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-save-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"'saveMappingChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-confirmation-text-body\">\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.saveConfirmation.bodyText' | translate }}</span>\n\t\t\t<br />\n\t\t\t<br />\n\t\t\t<span>{{ 'bmpp.ng.periods.edit.wizard.saveConfirmation.question' | translate }}</span>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n", styles: [".ng-bento ngb-modal-window.bmpp-edit-accounting-periods-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}.bmpp-step-back-confirmation .bmpp-confirmation-text-body,.bmpp-save-confirmation .bmpp-confirmation-text-body{vertical-align:top;width:85%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: i1$2.NgbModal }, { type: i2.Store }, { type: BmppAlertService }]; }, propDecorators: { wizard: [{
                type: ViewChild,
                args: ['wizard', { static: true }]
            }], discardChangesConfirmation: [{
                type: ViewChild,
                args: ['discardChangesConfirmation', { static: true }]
            }], saveConfirmation: [{
                type: ViewChild,
                args: ['saveConfirmation', { static: true }]
            }], periodType: [{
                type: Input
            }] } });

class SelectTaxYearComponent {
    constructor(store) {
        this.store = store;
        this.subscription$ = new Subscription();
        this.uniqueInputId = `id_${Math.floor(Math.random() * Date.now())}`;
        this.hasTouched = new EventEmitter();
    }
    ngOnInit() {
        // gets edited fiscal year to calculate tax years
        // and get current tax code year if exists
        this.subscription$.add(this.store
            .pipe(select(getEditedFiscalYear), filter(fiscalYear => Boolean(fiscalYear)))
            .subscribe((fiscalYear) => __awaiter(this, void 0, void 0, function* () { return this.onFiscalYearLoad(fiscalYear); })));
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    /**
     * Inits tax year drop down once added/edited fiscal year loaded
     * @param fiscalYear - begin of interval
     */
    onFiscalYearLoad(fiscalYear) {
        return __awaiter(this, void 0, void 0, function* () {
            this.taxYears = yield this.getTaxYears(fiscalYear.startDate, fiscalYear.endDate);
            this.isTaxYearsEmpty = this.taxYears.length === 0;
            if (this.isTaxYearsEmpty) {
                this.store.dispatch(new SetEditedFiscalYearValidationFailed());
                return;
            }
            this.selectedTaxYear = this.taxYears.includes(fiscalYear.taxCodeYear)
                ? fiscalYear.taxCodeYear
                : this.isEditDialog
                    ? null
                    : this.taxYears[0];
            this.store.dispatch(new SetTaxCodeYear({ taxCodeYear: this.selectedTaxYear }));
        });
    }
    /**
     * Gets tax years in interval and unused tax years yet
     * @param startDate - begin of interval
     * @param startDate - end of interval
     */
    getTaxYears(startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            return endDate >= startDate
                ? this.store
                    .pipe(select(getTaxYears(startDate.getFullYear(), endDate.getFullYear())), first(taxYears => Boolean(taxYears)))
                    .toPromise()
                : [];
        });
    }
    /**
     * Dispatched selected tax year in store
     * @param year- new taxCode year for the fiscalYear
     */
    onTaxYearChange(taxCode) {
        this.hasTouched.emit(true);
        this.store.dispatch(new SetTaxCodeYear({ taxCodeYear: taxCode }));
    }
}
SelectTaxYearComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SelectTaxYearComponent, deps: [{ token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
SelectTaxYearComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: SelectTaxYearComponent, selector: "bmpp-select-tax-year", inputs: { dataQeId: "dataQeId", isEditDialog: "isEditDialog" }, outputs: { hasTouched: "hasTouched" }, ngImport: i0, template: "<label class=\"d-block\" for=\"taxYearSelect\">\n\t{{ 'bmpp.ng.client.taxYear' | translate }}\n\t<i\n\t\ttabindex=\"0\"\n\t\t[attr.aria-label]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\t[ngbTooltip]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\tclass=\"bento-icon-info-filled bmpp-select-tax-year-info-icon\"\n\t></i>\n</label>\n<div>\n\t<select\n\t\tclass=\"form-control\"\n\t\tid=\"taxYearSelect\"\n\t\tbentoSelect\n\t\t[(ngModel)]=\"selectedTaxYear\"\n\t\t(ngModelChange)=\"onTaxYearChange($event)\"\n\t\t[attr.data-qe-id]=\"dataQeId\"\n\t\t[ngClass]=\"{ 'bmpp-has-error': isTaxYearsEmpty || !selectedTaxYear }\"\n\t\t[attr.aria-invalid]=\"isTaxYearsEmpty || !selectedTaxYear\"\n\t\t[attr.aria-describedBy]=\"uniqueInputId\"\n\t\taria-labelledby=\"tax-year\"\n\t>\n\t\t<option *ngFor=\"let taxYear of taxYears\" [ngValue]=\"taxYear\">{{ taxYear }}</option>\n\t</select>\n</div>\n<label class=\"hide\" id=\"tax-year\">{{ 'bmpp.ng.client.taxYear' | translate }}</label>\n<div class=\"bmpp-validation-message mt-1\" *ngIf=\"isTaxYearsEmpty || !selectedTaxYear\">\n\t<i class=\"bento-icon-warning-filled\"></i>\n\t<span id=\"{{ uniqueInputId }}\">{{ 'bmpp.ng.client.taxYearRequired' | translate }}</span>\n</div>\n", styles: [".bmpp-has-error.form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}.bmpp-select-tax-year-info-icon:focus{border-radius:5px;outline:1px solid black}\n"], directives: [{ type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SelectTaxYearComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-select-tax-year', template: "<label class=\"d-block\" for=\"taxYearSelect\">\n\t{{ 'bmpp.ng.client.taxYear' | translate }}\n\t<i\n\t\ttabindex=\"0\"\n\t\t[attr.aria-label]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\t[ngbTooltip]=\"'bmpp.ng.client.taxYearTooltip' | translate\"\n\t\tclass=\"bento-icon-info-filled bmpp-select-tax-year-info-icon\"\n\t></i>\n</label>\n<div>\n\t<select\n\t\tclass=\"form-control\"\n\t\tid=\"taxYearSelect\"\n\t\tbentoSelect\n\t\t[(ngModel)]=\"selectedTaxYear\"\n\t\t(ngModelChange)=\"onTaxYearChange($event)\"\n\t\t[attr.data-qe-id]=\"dataQeId\"\n\t\t[ngClass]=\"{ 'bmpp-has-error': isTaxYearsEmpty || !selectedTaxYear }\"\n\t\t[attr.aria-invalid]=\"isTaxYearsEmpty || !selectedTaxYear\"\n\t\t[attr.aria-describedBy]=\"uniqueInputId\"\n\t\taria-labelledby=\"tax-year\"\n\t>\n\t\t<option *ngFor=\"let taxYear of taxYears\" [ngValue]=\"taxYear\">{{ taxYear }}</option>\n\t</select>\n</div>\n<label class=\"hide\" id=\"tax-year\">{{ 'bmpp.ng.client.taxYear' | translate }}</label>\n<div class=\"bmpp-validation-message mt-1\" *ngIf=\"isTaxYearsEmpty || !selectedTaxYear\">\n\t<i class=\"bento-icon-warning-filled\"></i>\n\t<span id=\"{{ uniqueInputId }}\">{{ 'bmpp.ng.client.taxYearRequired' | translate }}</span>\n</div>\n", styles: [".bmpp-has-error.form-control{border-color:#dc0a0a;box-shadow:inset 0 1px 1px #00000014}.bmpp-select-tax-year-info-icon:focus{border-radius:5px;outline:1px solid black}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.Store }]; }, propDecorators: { dataQeId: [{
                type: Input
            }], isEditDialog: [{
                type: Input
            }], hasTouched: [{
                type: Output
            }] } });

const addFiscalYearModalName = 'bmpp.ng.common.addFiscalYear';
const editFiscalYearModalName = 'bmpp.ng.common.editFiscalYear';
const notEditableStartDate = 'bmpp.ng.editFiscal.notEditableWhenPreviousExists';
const notEditableEndDate = 'bmpp.ng.editFiscal.notEditableWhenNextExists';
class AddEditFiscalYearComponent {
    constructor(ownerService, frpService, store, activeModal, newFiscalYearPeriodsService) {
        this.ownerService = ownerService;
        this.frpService = frpService;
        this.store = store;
        this.activeModal = activeModal;
        this.newFiscalYearPeriodsService = newFiscalYearPeriodsService;
        this.fiscalYearAdded = new EventEmitter();
        this.editDialog = false;
        this.modalName = addFiscalYearModalName;
        this.startControl = {};
        this.endControl = {};
    }
    /**
     * Returns curently selected fiscalYear
     */
    get fiscalYear() {
        const startDate = this.startControl.date;
        const endDate = this.endControl.date;
        const sequenceNumber = this.getSequenceNumber(endDate);
        // if its neither Vat/Tax tab(UK) nor edit dialog
        if (!this.editDialog && !this.newFiscalYearPeriodsService.isVatTaxTab) {
            const periods = this.newFiscalYearPeriodsService.setNewFiscalYearPeriods(startDate, endDate, sequenceNumber, this.fiscalYears, this.periodType);
            return Object.assign(Object.assign({}, this._fiscalYear), { startDate, endDate, periods, sequenceNumber });
        }
        if (this.editDialog) {
            return Object.assign(Object.assign({}, this._fiscalYear), { startDate, endDate });
        }
        const periods = [{ startDate, endDate, sequenceNumber: 1, periodType: 1 }];
        return Object.assign(Object.assign({}, this._fiscalYear), { startDate, endDate, periods, sequenceNumber });
    }
    set fiscalYear(year) {
        this.editDialog = true;
        this.modalName = editFiscalYearModalName;
        this._fiscalYear = year;
    }
    ngOnInit() {
        this.formTouched = false;
        if (this.dataQeIdNamespace) {
            this.dataQeIdNamespace += this.editDialog ? '.editFiscalYearModal' : '.addFiscalYearModal';
        }
        else {
            this.dataQeIdNamespace = this.editDialog ? 'bmpp.editFiscalYearModal' : 'bmpp.addFiscalYearModal';
        }
        this.showTaxYearField = this.frpService.hasFixedAssets || this.frpService.hasAccounting;
        this.selectedOwnerId = this.ownerService.getOwnerId();
        this.initStoreData();
        this.initEditedFiscalYear(this.fiscalYears);
        this.setControlsSettings();
    }
    /**
     * Unsubscribe from all store subscriptions
     */
    ngOnDestroy() {
        this.storeSubscription$.unsubscribe();
    }
    /**
     * Sets fiscal year to be added or edited
     * @param fiscalYears - fiscal years list
     */
    initEditedFiscalYear(fiscalYears) {
        if (!this.editDialog) {
            this._fiscalYear = this.initNewFiscalYear(fiscalYears);
        }
        this.isFirstFiscalYear = this._fiscalYear.sequenceNumber === 1;
        this.isLastFiscalYear = this._fiscalYear.sequenceNumber === fiscalYears.length;
        this.store.dispatch(new SetEditedFiscalYear({ fiscalYear: this._fiscalYear }));
    }
    /**
     * Gets sequence number for added fiscal year
     * @param endDate - end date of new fiscal year
     */
    getSequenceNumber(endDate) {
        const isFirstYear = this.fiscalYears.some(fiscalYear => fiscalYear.startDate > endDate);
        return isFirstYear ? 1 : this.fiscalYears.length + 1;
    }
    /**
     * Sets start and end date pickers controls
     */
    setControlsSettings() {
        const startControlDisabled = this.editDialog && !this.isFirstFiscalYear;
        const endControlDisabled = this.editDialog && !this.isLastFiscalYear;
        this.startControl = {
            date: this._fiscalYear.startDate,
            disabled: startControlDisabled,
            disabledMessage: startControlDisabled ? notEditableStartDate : undefined,
        };
        this.endControl = {
            date: this._fiscalYear.endDate,
            disabled: endControlDisabled,
            disabledMessage: endControlDisabled ? notEditableEndDate : undefined,
        };
    }
    /**
     * Gets data from the store
     * Initializes subscription to listen to data changes
     */
    initStoreData() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Setting up default owner of modal
            this.storeSubscription$ = new Subscription();
            // get selected tax code year
            this.storeSubscription$.add(this.store
                .pipe(select(getSelectedTaxCodeYear), filter(taxCodeYear => Boolean(taxCodeYear)))
                .subscribe(taxYear => this.onTaxYearChange(taxYear)));
            // get status of fiscal year validation
            this.storeSubscription$.add(this.store.pipe(select(isEditedFiscalYearValidationFailed)).subscribe(invalid => (this.formInvalid = invalid)));
            // get existing fiscal years from store
            this.storeSubscription$.add(this.store
                .pipe(select(getFiscalYears), first(years => years && years.length > 0))
                .subscribe(years => (this.fiscalYears = years)));
            const contact = yield this.store.pipe(select(getSelectedContact), first()).toPromise();
            this.selectedOwnerId = (_a = contact === null || contact === void 0 ? void 0 : contact.id) !== null && _a !== void 0 ? _a : this.selectedOwnerId;
        });
    }
    /**
     * Saves result after successful modal close
     */
    saveResult() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.dispatch(new ResetAddFiscalYear());
            const payload = {
                ownerId: this.selectedOwnerId,
                fiscalYear: this.fiscalYear,
            };
            const action = this.editDialog ? new UpdateFiscalYear(payload) : new AddNewFiscalYear(payload);
            this.store.dispatch(action);
            // we need to emit an event for the fiscalYear Added.  This is required when we use this modal from the settings
            // current period combo and add the fiscal year on the fly.  We have a wrapper that launches the AddFiscalYearModal without having the period screen.
            // we also added a new selector that gives the newly added fiscal year
            this.store
                .pipe(select(getNewlyAddedFiscalYear), first(fiscalYear => fiscalYear !== undefined))
                .toPromise()
                .then(newFiscalYear => {
                this.fiscalYearAdded.emit(newFiscalYear);
            });
            this.onClose();
        });
    }
    /**
     * Handles modal close without save.
     */
    onCancel() {
        this.store.dispatch(new ResetEditedFiscalYear());
        this.activeModal.dismiss();
    }
    /**
     * Handles modal close without saving changes
     */
    onClose() {
        this.activeModal.close();
    }
    /**
     * Initialize a new fiscal year
     * @param fiscalYears - fiscal years list
     */
    initNewFiscalYear(fiscalYears) {
        const lastYear = fiscalYears[fiscalYears.length - 1];
        const startDate = addDays(lastYear.endDate, 1);
        // we subtract the last day from the end date in order to indicate the correct boundary for the fiscal year
        const endDate = subDays(addYears(startDate, 1), 1);
        return { startDate, endDate, sequenceNumber: 0 };
    }
    /**
     * Updates selected yearStartDate
     * @param date - new date for the yearStartDate
     */
    onStartDateChange(date) {
        this.startControl.date = date;
        this.formTouched = true;
        this.validateFiscalYearDates();
        this.updateFiscalYearDates();
    }
    /**
     * Updates selected yearEndDate
     * @param date - new date for the yearEndDate
     */
    onEndDateChange(date) {
        this.endControl.date = date;
        this.formTouched = true;
        this.validateFiscalYearDates();
        this.updateFiscalYearDates();
    }
    /**
     * Disables save button on invalid date format event
     */
    onSelectedDateInvalid() {
        this.formInvalid = true;
    }
    /**
     * Updates selected tax code year
     * @param taxCodeYear - tax code year number
     */
    onTaxYearChange(taxCodeYear) {
        this._fiscalYear = Object.assign(Object.assign({}, this._fiscalYear), { taxCodeYear });
    }
    /**
     * Checks if save button should be disabled
     */
    isSaveDisabled() {
        var _a;
        return ((this.editDialog ? this.formInvalid || !this.formTouched : this.formInvalid) ||
            (this.showTaxYearField && !((_a = this._fiscalYear) === null || _a === void 0 ? void 0 : _a.taxCodeYear)));
    }
    /**
     * Handler for tax year touched event
     * Sets formTouched when tax code year element is also thouched
     * @param hasTouched - tax code year number
     */
    onTaxYearTouch(hasTouched) {
        this.formTouched = hasTouched;
    }
    /**
     * Updates fiscal year dates in store
     */
    updateFiscalYearDates() {
        const payload = {
            startDate: this.startControl.date,
            endDate: this.endControl.date,
        };
        this.store.dispatch(new SetEditedFiscalYearDate(payload));
    }
    /**
     * Validates fiscal year  dates
     */
    validateFiscalYearDates() {
        return __awaiter(this, void 0, void 0, function* () {
            const { invalid, startDateErrorMsg, endDateErrorMsg } = yield this.store
                .pipe(select(getValidationSelector(this.editDialog, this.fiscalYear)), first())
                .toPromise();
            this.startControl.validationResult = startDateErrorMsg;
            this.endControl.validationResult = endDateErrorMsg;
            this.formInvalid = invalid;
        });
    }
}
AddEditFiscalYearComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AddEditFiscalYearComponent, deps: [{ token: BmppOwnerService }, { token: BmppFeatureResourcePermissionService }, { token: i2.Store }, { token: i1$2.NgbActiveModal }, { token: NewFiscalYearPeriodsService }], target: i0.ɵɵFactoryTarget.Component });
AddEditFiscalYearComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: AddEditFiscalYearComponent, selector: "bmpp-add-edit-fiscal-year", inputs: { periodType: "periodType", dataQeIdNamespace: "dataQeIdNamespace", fiscalYear: "fiscalYear" }, outputs: { fiscalYearAdded: "fiscalYearAdded" }, ngImport: i0, template: "<div class=\"modal-header\">\n\t<h3 class=\"modal-title\" id=\"modal-basic-title\">{{ modalName | translate }}</h3>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.cancelCrossButton'\"\n\t\t(click)=\"onCancel()\"\n\t>\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n</div>\n<div class=\"modal-body\">\n\t<p *ngIf=\"editDialog\">{{ 'bmpp.ng.common.periodDates' | translate }}</p>\n\t<bmpp-date-picker\n\t\t[disabled]=\"startControl?.disabled\"\n\t\t[disabledMessage]=\"startControl?.disabledMessage\"\n\t\t[label]=\"'bmpp.ng.common.yearBeginDate' | translate\"\n\t\t[selectedDate]=\"startControl?.date\"\n\t\t[required]=\"true\"\n\t\t[validationMessage]=\"startControl?.validationResult\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.FiscalYearStartSelect'\"\n\t\t(selectedDateChange)=\"onStartDateChange($event)\"\n\t\t(selectedDateInvalid)=\"onSelectedDateInvalid()\"\n\t></bmpp-date-picker>\n\t<bmpp-date-picker\n\t\t[disabled]=\"endControl?.disabled\"\n\t\t[disabledMessage]=\"endControl?.disabledMessage\"\n\t\t[label]=\"'bmpp.ng.common.yearEndDate' | translate\"\n\t\t[selectedDate]=\"endControl?.date\"\n\t\t[required]=\"true\"\n\t\t[validationMessage]=\"endControl?.validationResult\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.FiscalYearEndSelect'\"\n\t\t(selectedDateChange)=\"onEndDateChange($event)\"\n\t\t(selectedDateInvalid)=\"onSelectedDateInvalid()\"\n\t></bmpp-date-picker>\n\t<bmpp-select-tax-year\n\t\t[isEditDialog]=\"editDialog\"\n\t\t*ngIf=\"showTaxYearField\"\n\t\t[dataQeId]=\"dataQeIdNamespace + '.TaxYearSelect'\"\n\t\t(hasTouched)=\"onTaxYearTouch($event)\"\n\t>\n\t</bmpp-select-tax-year>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t(click)=\"saveResult()\"\n\t\t[disabled]=\"isSaveDisabled()\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.saveButton'\"\n\t>\n\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-outline-dark btn-outline-primary\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.cancelButton'\"\n\t\t(click)=\"onCancel()\"\n\t>\n\t\t{{ 'bmpp.ng.common.cancel' | translate }}\n\t</button>\n</div>\n", styles: [".bmpp-add-edit-fiscal-year-modal bmpp-date-picker input,.bmpp-add-edit-fiscal-year-modal bmpp-select-tax-year .bento-select{max-width:25%}\n"], components: [{ type: DatePickerComponent, selector: "bmpp-date-picker", inputs: ["dataQeIdNamespace", "disabled", "disabledMessage", "label", "required", "isExternalValidationError", "selectedDate", "validationMessage", "disableInternalMessage"], outputs: ["selectedDateChange", "selectedDateInvalid"] }, { type: SelectTaxYearComponent, selector: "bmpp-select-tax-year", inputs: ["dataQeId", "isEditDialog"], outputs: ["hasTouched"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AddEditFiscalYearComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-add-edit-fiscal-year', encapsulation: ViewEncapsulation.None, template: "<div class=\"modal-header\">\n\t<h3 class=\"modal-title\" id=\"modal-basic-title\">{{ modalName | translate }}</h3>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.cancelCrossButton'\"\n\t\t(click)=\"onCancel()\"\n\t>\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n</div>\n<div class=\"modal-body\">\n\t<p *ngIf=\"editDialog\">{{ 'bmpp.ng.common.periodDates' | translate }}</p>\n\t<bmpp-date-picker\n\t\t[disabled]=\"startControl?.disabled\"\n\t\t[disabledMessage]=\"startControl?.disabledMessage\"\n\t\t[label]=\"'bmpp.ng.common.yearBeginDate' | translate\"\n\t\t[selectedDate]=\"startControl?.date\"\n\t\t[required]=\"true\"\n\t\t[validationMessage]=\"startControl?.validationResult\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.FiscalYearStartSelect'\"\n\t\t(selectedDateChange)=\"onStartDateChange($event)\"\n\t\t(selectedDateInvalid)=\"onSelectedDateInvalid()\"\n\t></bmpp-date-picker>\n\t<bmpp-date-picker\n\t\t[disabled]=\"endControl?.disabled\"\n\t\t[disabledMessage]=\"endControl?.disabledMessage\"\n\t\t[label]=\"'bmpp.ng.common.yearEndDate' | translate\"\n\t\t[selectedDate]=\"endControl?.date\"\n\t\t[required]=\"true\"\n\t\t[validationMessage]=\"endControl?.validationResult\"\n\t\t[dataQeIdNamespace]=\"dataQeIdNamespace + '.FiscalYearEndSelect'\"\n\t\t(selectedDateChange)=\"onEndDateChange($event)\"\n\t\t(selectedDateInvalid)=\"onSelectedDateInvalid()\"\n\t></bmpp-date-picker>\n\t<bmpp-select-tax-year\n\t\t[isEditDialog]=\"editDialog\"\n\t\t*ngIf=\"showTaxYearField\"\n\t\t[dataQeId]=\"dataQeIdNamespace + '.TaxYearSelect'\"\n\t\t(hasTouched)=\"onTaxYearTouch($event)\"\n\t>\n\t</bmpp-select-tax-year>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-primary\"\n\t\t(click)=\"saveResult()\"\n\t\t[disabled]=\"isSaveDisabled()\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.saveButton'\"\n\t>\n\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t</button>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-outline-dark btn-outline-primary\"\n\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.cancelButton'\"\n\t\t(click)=\"onCancel()\"\n\t>\n\t\t{{ 'bmpp.ng.common.cancel' | translate }}\n\t</button>\n</div>\n", styles: [".bmpp-add-edit-fiscal-year-modal bmpp-date-picker input,.bmpp-add-edit-fiscal-year-modal bmpp-select-tax-year .bento-select{max-width:25%}\n"] }]
        }], ctorParameters: function () { return [{ type: BmppOwnerService }, { type: BmppFeatureResourcePermissionService }, { type: i2.Store }, { type: i1$2.NgbActiveModal }, { type: NewFiscalYearPeriodsService }]; }, propDecorators: { periodType: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }], fiscalYearAdded: [{
                type: Output
            }], fiscalYear: [{
                type: Input
            }] } });

// Modal helper is used for temporary fix for all stacked modals
// Known issue when we use AngularJS and Angular NG
// and has no way to track number of stacked modals
// due to using NgbModal service and legacy custom modal service
// from bm-practice-common. When all modules migrate to Angular NG
// it can be fixed by using NgbModal singleton
// Modal helper is used to track stacked modals in DOM
class BmppModalHelperService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(document, rendererFactory2) {
        this.document = document;
        this.rendererFactory2 = rendererFactory2;
        this.renderer2 = rendererFactory2.createRenderer(null, null);
    }
    /**
     * Call when modal is closed or dismissed
     * it adds 'modal-open' class to body el to fix the issue with stacked modals
     */
    postCloseModalCallback(hasParentModal) {
        if (hasParentModal) {
            this.renderer2.addClass(document.body, 'modal-open');
        }
    }
    /**
     * Check if modal-open class present in DOM body element
     */
    hasModalOpenClass() {
        const elements = this.document.getElementsByClassName('modal-open');
        return elements.length > 0;
    }
}
BmppModalHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppModalHelperService, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
BmppModalHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppModalHelperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppModalHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i0.RendererFactory2 }];
    } });

class OpenModalHelperService {
    constructor(modalHelper, modalService) {
        this.modalHelper = modalHelper;
        this.modalService = modalService;
    }
    /**
     * Opens a new modal with the specified options and configuration
     * @param modalComponent - A component that represents a modal template
     * @param options - Specific NgbModalOptions options
     * @param configureComponent - Data for component instance that represents a modal template.
     */
    openModal(modalComponent, options, componentConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            // Verify if we're opening modal in parent modal
            // Known issue when we use AngularJS and Angular NG
            // and has no way to track number of stacked modals
            // due to using NgbModal service and legacy custom modal service
            // from bm-practice-common. When all modules migrate to Angular NG
            // it can be fixed by using NgbModal singleton
            const hasParentModal = this.modalHelper.hasModalOpenClass();
            const modalOptions = Object.assign({ ariaLabelledBy: 'modal-basic-title', container: '#bentoNGModalContainer' }, options);
            const modalRef = this.modalService.open(modalComponent, modalOptions);
            if (componentConfig) {
                Object.keys(componentConfig).forEach((key) => {
                    modalRef.componentInstance[key] = componentConfig[key];
                });
            }
            return modalRef.result.then(
            // Add handler for onSaveClick
            () => {
                this.modalHelper.postCloseModalCallback(hasParentModal);
            }, 
            // Add handler for onCancelClick
            () => {
                this.modalHelper.postCloseModalCallback(hasParentModal);
            });
        });
    }
}
OpenModalHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OpenModalHelperService, deps: [{ token: BmppModalHelperService }, { token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
OpenModalHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OpenModalHelperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OpenModalHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: BmppModalHelperService }, { type: i1$2.NgbModal }]; } });

class FiscalYearDropdownComponent {
    constructor(dateHelperService, store) {
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.subscriptions = [];
    }
    ngOnInit() {
        // updates loaded fiscal years in dropdown
        this.subscriptions.push(this.store
            .pipe(select(getFiscalYearsInDescendingOrder))
            .subscribe(fiscalYears => this.onFiscalYearsLoad(fiscalYears)));
        // retrieves current fiscal year once and set it as selected in sore
        this.subscriptions.push(this.store
            .pipe(select(getCurrentFiscalYear(this.periodType)))
            .subscribe(fiscalYear => this.setSelectedFiscalYear(fiscalYear)));
        // gets selected fiscal year and set it as selected in dropdown
        this.subscriptions.push(this.store.pipe(select(getSelectedFiscalYear)).subscribe(fiscalYear => (this.selectedFiscalYear = fiscalYear)));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    /**
     * Updates fiscal years dropdown once years were loaded
     *  @param fiscalYears - list of fiscal years to be rendered on dropdown
     */
    onFiscalYearsLoad(fiscalYears) {
        if ((fiscalYears === null || fiscalYears === void 0 ? void 0 : fiscalYears.length) > 0) {
            // re-struct array to make it mutable
            this.fiscalYears = [...fiscalYears];
            // first set the default(earliest) fical year from the list
            this.setSelectedFiscalYear(this.fiscalYears[this.fiscalYears.length - 1]);
        }
    }
    /**
     * Presents date in current region format
     * @param fiscalYearDate - date of fiscal year to be fromated depends on region
     */
    formatFiscalYearDate(fiscalYearDate) {
        return this.dateHelperService.getFormattedDate(fiscalYearDate);
    }
    /**
     * Sets chosen fiscal year from dropdown in store and view
     * Also, used to set current fiscal year as a selected at initialization.
     * @param fiscalYear - to be set as selected option and dispatch to store
     */
    setSelectedFiscalYear(fiscalYear) {
        if (fiscalYear) {
            this.store.dispatch(new SetSelectedFiscalYear({ fiscalYear }));
        }
    }
    /**
     * Handler when user select fiscal year from the dropdown
     * @param fiscalYear - passed on change event triggered
     */
    onFiscalYearChange(fiscalYear) {
        this.setSelectedFiscalYear(fiscalYear);
    }
}
FiscalYearDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearDropdownComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
FiscalYearDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FiscalYearDropdownComponent, selector: "bmpp-fiscal-year-dropdown", inputs: { periodType: "periodType", dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<select\n\tclass=\"form-control\"\n\tbentoSelect\n\taria-label=\"Fiscal Year\"\n\tid=\"fiscalYearSelect\"\n\t*ngIf=\"fiscalYears\"\n\t[(ngModel)]=\"selectedFiscalYear\"\n\t(ngModelChange)=\"onFiscalYearChange($event)\"\n\t[attr.data-qe-id]=\"dataQeIdNamespace + '.FiscalYearEndSelect'\"\n>\n\t<option *ngFor=\"let fiscalYear of fiscalYears\" [ngValue]=\"fiscalYear\">\n\t\t{{ formatFiscalYearDate(fiscalYear.endDate) }}\n\t</option>\n</select>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-fiscal-year-dropdown', template: "<select\n\tclass=\"form-control\"\n\tbentoSelect\n\taria-label=\"Fiscal Year\"\n\tid=\"fiscalYearSelect\"\n\t*ngIf=\"fiscalYears\"\n\t[(ngModel)]=\"selectedFiscalYear\"\n\t(ngModelChange)=\"onFiscalYearChange($event)\"\n\t[attr.data-qe-id]=\"dataQeIdNamespace + '.FiscalYearEndSelect'\"\n>\n\t<option *ngFor=\"let fiscalYear of fiscalYears\" [ngValue]=\"fiscalYear\">\n\t\t{{ formatFiscalYearDate(fiscalYear.endDate) }}\n\t</option>\n</select>\n" }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }] } });

class OpenModalLinkComponent {
    constructor() {
        this.linkClick = new EventEmitter();
    }
    // Emit events provided by parent component
    onLinkClick() {
        this.linkClick.emit();
    }
}
OpenModalLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OpenModalLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OpenModalLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: { dataQeId: "dataQeId", linkIconClass: "linkIconClass", linkTextResource: "linkTextResource" }, outputs: { linkClick: "linkClick" }, ngImport: i0, template: "<button class=\"btn btn-link btn-icon bmpp-icon\" (click)=\"onLinkClick()\" [attr.data-qe-id]=\"dataQeId\">\n\t<i [ngClass]=\"linkIconClass\"></i>\n\t{{ linkTextResource | translate }}\n</button>\n", styles: [".bmpp-icon i{margin-right:.5em!important}\n"], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OpenModalLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-open-modal-link', template: "<button class=\"btn btn-link btn-icon bmpp-icon\" (click)=\"onLinkClick()\" [attr.data-qe-id]=\"dataQeId\">\n\t<i [ngClass]=\"linkIconClass\"></i>\n\t{{ linkTextResource | translate }}\n</button>\n", styles: [".bmpp-icon i{margin-right:.5em!important}\n"] }]
        }], propDecorators: { dataQeId: [{
                type: Input
            }], linkIconClass: [{
                type: Input
            }], linkTextResource: [{
                type: Input
            }], linkClick: [{
                type: Output
            }] } });

var EditFiscalYearGridColumnType;
(function (EditFiscalYearGridColumnType) {
    EditFiscalYearGridColumnType["StartDate"] = "startDate";
    EditFiscalYearGridColumnType["EndDate"] = "endDate";
    EditFiscalYearGridColumnType["TaxYears"] = "taxYear";
})(EditFiscalYearGridColumnType || (EditFiscalYearGridColumnType = {}));

class EditMultipleFiscalYearsService {
    constructor(translateService, dateValidationService, dateHelperService, locale) {
        this.translateService = translateService;
        this.dateValidationService = dateValidationService;
        this.dateHelperService = dateHelperService;
        this.locale = locale;
        this.originalFiscalYears = [];
        this.taxYearModel = [];
        this.format = this.dateHelperService.getFormatPlaceHolder(this.locale.toLowerCase());
    }
    /**
     * Validating every cell of the grid.
     * @param item - FiscalYearGridData
     * @param column - string
     * @param fiscalYears - FiscalYearGridData array
     * @param isGridUpdated - boolean
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @rushstack/no-new-null
    isCellValid(item, column, fiscalYears, isGridUpdated) {
        const columnBinding = column;
        switch (columnBinding) {
            case EditFiscalYearGridColumnType.StartDate:
                return this.validateStartDate(item, fiscalYears, isGridUpdated);
            case EditFiscalYearGridColumnType.EndDate:
                return this.validateEndDate(item, fiscalYears, isGridUpdated);
            default:
                return null;
        }
    }
    /**
     * set originalFiscalYears
     * @param fiscalYears - FiscalYearGridData array
     */
    setOriginalFiscalYears(fiscalYears) {
        this.originalFiscalYears = fiscalYears;
    }
    /**
     * Validating startDate.
     * @param item - FiscalYearGridData
     * @param fiscalYears - FiscalYearGridData array
     * @param isGridUpdated - boolean
     */
    // eslint-disable-next-line @rushstack/no-new-null
    validateStartDate(item, fiscalYears, isGridUpdated) {
        let startDateErrorMsg;
        const isValid = this.dateValidationService.validateDate(this.dateHelperService.dateToNgbDateStruct(item.startDate));
        const findFiscalYear = this.originalFiscalYears.find(fiscalYear => fiscalYear.sequenceNumber === item.sequenceNumber);
        // checking if date is changed or not
        const isSameStartDate = isEqual(findFiscalYear.startDate, item.startDate);
        // return null if the date is not changed and there is no error
        if (isSameStartDate)
            return null;
        if (!isValid) {
            startDateErrorMsg = this.translateService.instant(INVALID_GRID_FORMAT_MSG, {
                field: this.translateService.instant('bmpp.edit.fiscal.years.begin.date'),
                format: this.format,
            });
            return startDateErrorMsg;
        }
        // Selects the message if the start date is invalid
        if (item.startDate > item.endDate) {
            startDateErrorMsg = this.translateService.instant(INVALID_DATES_ORDER_MSG);
            return startDateErrorMsg;
        }
        // if all the above test pass then only try to validate further
        return this.validateFiscalYears(item, fiscalYears, isGridUpdated);
    }
    /**
     * Validating endDate.
     * @param item - any
     * @param fiscalYears - FiscalYearGridData array
     * @param isGridUpdated - boolean
     */
    // eslint-disable-next-line @rushstack/no-new-null
    validateEndDate(item, fiscalYears, isGridUpdated) {
        let endDateErrorMsg;
        const isValid = this.dateValidationService.validateDate(this.dateHelperService.dateToNgbDateStruct(item.endDate));
        const findFiscalYear = this.originalFiscalYears.find(fiscalYear => fiscalYear.sequenceNumber === item.sequenceNumber);
        // checking if date is changed or not
        const isSameEndDate = isEqual(findFiscalYear.endDate, item.endDate);
        // if the end date is not changed and no error message return null
        if (isSameEndDate)
            return null;
        if (!isValid) {
            endDateErrorMsg = this.translateService.instant(INVALID_GRID_FORMAT_MSG, {
                field: this.translateService.instant('bmpp.edit.fiscal.years.end.date'),
                format: this.format,
            });
            return endDateErrorMsg;
        }
        // Selects the message if the end date is invalid
        if (item.startDate > item.endDate) {
            endDateErrorMsg = this.translateService.instant(INVALID_DATES_ORDER_MSG);
            return endDateErrorMsg;
        }
        // if all the above test pass then only try to validate further
        return this.validateFiscalYears(item, fiscalYears, isGridUpdated);
    }
    /**
     * Validating fiscalYears and returns error message accordingly.
     * @param item - any - fiscalYear that needs to be validated
     * @param fiscalYears - FiscalYearGridData array - all the fiscalyears
     * @param isGridUpdated - boolean
     * @returns - string
     */
    validateFiscalYears(item, fiscalYears, isGridUpdated) {
        const startDate = item.startDate;
        const endDate = item.endDate;
        const sequenceNumber = item.sequenceNumber;
        const length = fiscalYears.length;
        if (length > 0 && isGridUpdated) {
            // Checking if startdate falls in any other fiscal years interval or
            // if startdate equals any other fiscalyears start or end date, or
            // if enddate falls in any other fiscal years interval or
            // if enddate equals any other fiscalyears start or end date
            const overlappedFiscalYear = fiscalYears.find(fiscalYear => 
            // we should not check fiscalyear with itself
            fiscalYear.sequenceNumber !== sequenceNumber &&
                ((startDate > fiscalYear.startDate && startDate < fiscalYear.endDate) ||
                    isEqual(startDate, fiscalYear.startDate) ||
                    isEqual(startDate, fiscalYear.endDate) ||
                    isEqual(endDate, fiscalYear.startDate) ||
                    isEqual(endDate, fiscalYear.endDate) ||
                    (endDate > fiscalYear.startDate && endDate < fiscalYear.endDate)));
            // checking if startdate or endate falls out of range of all fiscalyears
            if (overlappedFiscalYear !== undefined ||
                startDate < fiscalYears[0].startDate ||
                endDate > fiscalYears[length - 1].endDate) {
                return this.translateService.instant(FISCAL_YEAR_DATES_OVERLAP_MSG);
            }
            // Checking if the current fiscalYear creates any gap with adjacent fiscalYears
            if (sequenceNumber !== 1) {
                const previousYearEndDate = fiscalYears[sequenceNumber - 2].endDate;
                const diff = differenceInCalendarDays(startDate, previousYearEndDate);
                if (diff > 1) {
                    return this.translateService.instant(FISCAL_YEAR_DATES_HAVE_GAPS_MSG);
                }
            }
            if (sequenceNumber !== fiscalYears.length) {
                const nextYearStartDate = fiscalYears[sequenceNumber].startDate;
                const diff = differenceInCalendarDays(nextYearStartDate, endDate);
                if (diff > 1) {
                    return this.translateService.instant(FISCAL_YEAR_DATES_HAVE_GAPS_MSG);
                }
            }
        }
        return null;
    }
    /**
     * We are updating the endDate of the previous year and the startDate of the next year.
     *
     * We are also updating the endDate and startDate of all the subsequent years.
     *
     * We are also checking if the year is a leap year and the date we are changing is 2/28. If this is
     * true then we are not updating the endDate of the subsequent year to 2/29.
     *
     * We are also checking if the year is a leap year and the date we are changing is 2/29. If this is
     * true then we are updating the endDate of the subsequent year to 2/29.
     * @param rowData -  FiscalYearGridData - this is the row data that is being
     * @param fiscalYears - FiscalYearGridData array - all the fiscalyears in the grid edited
     * @returns FiscalYearGridData[] - updated fiscalYears array
     */
    updateSubsequentFiscalYears(rowData, fiscalYears) {
        const index = rowData.sequenceNumber - 1;
        const updatedFiscalYears = fiscalYears;
        const newEndDate = rowData.endDate;
        const newStartDate = addDays(newEndDate, 1);
        // first we update the endDate of current year and start Date of the next year
        updatedFiscalYears[index].endDate = newEndDate;
        updatedFiscalYears[index + 1].startDate = newStartDate;
        updatedFiscalYears[index] = this.getAllUpdatedTaxYears(updatedFiscalYears[index]);
        // we need a flag for the skipLeapYear, when we are changing a date in fiscal year and the date  changed is 2/28 then we
        // do not need to make the subsequent year to be 2/29
        const skipLeapYear = isLeapYear(newEndDate) && isEqual(newEndDate, new Date(newEndDate.getFullYear(), 1, 28));
        // update all the subsequent years.  we will start  from the year we are changing and end of fiscal years
        updatedFiscalYears.map((fiscalYear, i) => {
            if (i > index) {
                const newEndDate = addYears(updatedFiscalYears[i - 1].endDate, 1);
                // this will check if the year is leapYear, the date we compare is for leap year and the flag is false
                // this will be only true if the date changed is 2/29
                const leapYearDate = isLeapYear(newEndDate) && isEqual(newEndDate, new Date(newEndDate.getFullYear(), 1, 28)) && !skipLeapYear;
                // if this is a leap year and the skipLeapYear flag is not true then lets make the date to 2/29/yy
                fiscalYear.endDate = leapYearDate ? new Date(newEndDate.getFullYear(), 1, 29) : newEndDate;
                fiscalYear.startDate = addDays(updatedFiscalYears[i - 1].endDate, 1);
                fiscalYear = this.getAllUpdatedTaxYears(fiscalYear);
            }
            // On date change the current and subsequent row will update, but if the previous rows have the same taxyear in the drop down,
            // that will cause an issue. Hence removing from previous rows taxyears list if it available.
            if (i < index && fiscalYear.taxYears.includes(updatedFiscalYears[index].taxYear))
                fiscalYear.taxYears.splice(fiscalYear.taxYears.indexOf(updatedFiscalYears[index].taxYear), 1);
            return fiscalYear;
        });
        return updatedFiscalYears;
    }
    /**
     * It updates the tax years drop down based on the selected start and end date.
     * @param rowData -  FiscalYearGridData - it is the row data that is being called.
     * @returns FiscalYearGridData - updated fiscalYears array item.
     */
    getAllUpdatedTaxYears(rowData) {
        let preTaxYear;
        const index = rowData.sequenceNumber - 1;
        const startDateYear = rowData.startDate.getFullYear();
        const endDateYear = rowData.endDate.getFullYear();
        // getting all possible tax years.
        const taxYears = getAllTaxYears(startDateYear, endDateYear);
        const currentTaxYearList = this.taxYearModel;
        // Splicing the array untill where the user action was done from zero index..
        currentTaxYearList.splice(index, this.taxYearModel.length - index);
        taxYears.forEach(function (texYear, i) {
            // Removing the tax year, if it's alredy the selected in previous rows from the availbe taxyears list.
            if (currentTaxYearList.includes(texYear)) {
                taxYears.splice(i, 1);
            }
            // if alredy some taxYear is selected and that was within the range of availabe taxYears list, then keeping same as selected.
            if (!currentTaxYearList.includes(texYear) && rowData.taxYear === texYear) {
                preTaxYear = texYear;
            }
        });
        rowData.taxYears = taxYears;
        rowData.taxYear = preTaxYear ? preTaxYear : taxYears[0] ? taxYears[0] : 0;
        this.taxYearModel[index] = rowData.taxYear;
        return rowData;
    }
    /**
     * It updates the tax years drop down based on the selected tax year.
     * @param currentIndex - number - it is the index of edited tax year in the grid.
     * @param slectedYear - number - it is the selected tax year by the user from the tax year dropdown.
     * @param data -  FiscalYearGridData[] - it is the grid data.
     * @returns FiscalYearGridData[] - updated fiscalYears array.
     */
    onTaxYearChanged(currentIndex, selectedYear, data) {
        let currentYear = data[currentIndex];
        let prevYear = data[currentIndex - 1];
        let nextYear = data[currentIndex + 1];
        // Update the selected year for the current tax year        i
        if (currentYear && selectedYear !== undefined) {
            currentYear.taxYear = selectedYear;
        }
        // Update the tax years for the next year
        if (nextYear) {
            [currentYear, nextYear] = this.updateSpecificItems(nextYear, selectedYear, currentYear);
        }
        // Update the tax years for the previous year
        if (prevYear) {
            [currentYear, prevYear] = this.updateSpecificItems(prevYear, selectedYear, currentYear);
        }
        // Return a new array of fiscal year objects with updated tax year model
        return data.map((fiscalYear, i) => {
            switch (i) {
                case currentIndex:
                    fiscalYear = currentYear;
                    break;
                case currentIndex + 1:
                    fiscalYear = nextYear;
                    break;
                case currentIndex - 1:
                    fiscalYear = prevYear;
                    break;
                default:
                    break;
            }
            this.taxYearModel[i] = fiscalYear.taxYear;
            return fiscalYear;
        });
    }
    /**
     * It updates the tax years drop down based on the selected tax year.
     * @param impactedYear - FiscalYearGridData - it is the item, which impacted by change in the currentIndexedYear.
     * @param slectedYear - number - it is the selected tax year by the user from the tax year dropdown.
     * @param currentIndexedYear -  FiscalYearGridData - it is the item of modified index.
     * @returns FiscalYearGridData[] - updated fiscalYears array.
     */
    updateSpecificItems(impactedYear, selectedYear, currentIndexedYear) {
        currentIndexedYear.taxYears.forEach(taxYear => {
            const isSlectedYearMatched = selectedYear === taxYear;
            const impactedYearHasSelectedYear = impactedYear.taxYears.includes(taxYear);
            // if the user selected year availabe in the adjacentTaxYears then removing to stop user to select same year in other rows.
            if (isSlectedYearMatched && impactedYear.taxYear !== taxYear && impactedYearHasSelectedYear) {
                impactedYear.taxYears.splice(impactedYear.taxYears.indexOf(taxYear), 1);
                impactedYear.taxYear = impactedYear.taxYears.length === 0 ? 0 : impactedYear.taxYear;
            }
            // if the user selected year not availabe in the adjacentTaxYears then pushing same year to adjacentTaxYears.
            if (!isSlectedYearMatched &&
                (taxYear === impactedYear.endDate.getFullYear() || taxYear === impactedYear.startDate.getFullYear()) &&
                !impactedYearHasSelectedYear) {
                if (impactedYear.taxYears.length === 0)
                    currentIndexedYear.taxYears.splice(currentIndexedYear.taxYears.indexOf(taxYear), 1);
                impactedYear.taxYears.push(taxYear);
                impactedYear.taxYears.sort((a, b) => b - a);
                impactedYear.taxYear = impactedYear.taxYear === 0 ? impactedYear.taxYears[0] : impactedYear.taxYear;
            }
        });
        return [currentIndexedYear, impactedYear];
    }
}
EditMultipleFiscalYearsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditMultipleFiscalYearsService, deps: [{ token: i1$1.TranslateService }, { token: BmppDateValidatorService }, { token: BmppDateHelperService }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable });
EditMultipleFiscalYearsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditMultipleFiscalYearsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditMultipleFiscalYearsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: i1$1.TranslateService }, { type: BmppDateValidatorService }, { type: BmppDateHelperService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }];
    } });

class EditFiscalYearGridDatepickerComponent {
    constructor(bentoPositioning, dateHelperService, renderer, locale, document) {
        this.bentoPositioning = bentoPositioning;
        this.dateHelperService = dateHelperService;
        this.renderer = renderer;
        this.locale = locale;
        this.document = document;
        this.valueChange = new EventEmitter();
    }
    get value() {
        return this.currentDate ? this.dateHelperService.ngbDateStructToDate(this.currentDate) : null;
    }
    set value(date) {
        this.currentDate = date instanceof Date ? this.dateHelperService.dateToNgbDateStruct(date) : date;
    }
    ngOnInit() {
        this.placeholder = this.dateHelperService.getFormatPlaceHolder(this.locale.toLowerCase());
        this.datepickerConfig = { type: 'recent', format: this.placeholder };
    }
    /**
     * Open Datepicker and set position
     * @param datePickerInput - datepicker input
     */
    openDatepicker(datepickerInput) {
        if (!datepickerInput.isOpen()) {
            datepickerInput.open();
            const inputRef = '_elRef';
            const pickerRef = '_cRef';
            const input = datepickerInput[inputRef].nativeElement;
            const datepicker = datepickerInput[pickerRef].location.nativeElement;
            const offsetHeight = datepicker.offsetHeight;
            const inputRect = input.getBoundingClientRect();
            const side = inputRect.height + inputRect.y + offsetHeight > this.document.documentElement.offsetHeight - 100 ? 'top' : 'bottom';
            this.bentoPositioning.positionElement(this.renderer, input, datepicker, this.gridWrapper, side, 'left');
            setTimeout(() => {
                input.focus();
            }, 100);
        }
    }
    /**
     * Emit value change event
     * @param changedDate - NgbDateStruct
     */
    onChangeDate(changedDate) {
        this.valueChange.emit(changedDate);
    }
    /**
     * close date picker input
     * @param datePickerInput - NgbInputDatepicker
     */
    onInputClick(datePickerInput) {
        if (datePickerInput.isOpen())
            datePickerInput.close();
    }
    /**
     * Sets value if defined date is selected.
     */
    onBlur() {
        if (this.currentDate) {
            this.valueChange.emit(this.dateHelperService.dateToNgbDateStruct(this.value));
        }
    }
}
EditFiscalYearGridDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFiscalYearGridDatepickerComponent, deps: [{ token: i5.BentoPositioning }, { token: BmppDateHelperService }, { token: i0.Renderer2 }, { token: LOCALE_ID }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
EditFiscalYearGridDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EditFiscalYearGridDatepickerComponent, selector: "bmpp-edit-fiscal-year-grid-datepicker", inputs: { gridWrapper: "gridWrapper", dataQeId: "dataQeId", value: "value" }, outputs: { valueChange: "valueChange" }, providers: [{ provide: NgbDateAdapter, useClass: BmppNgbDateStructAdapter }], ngImport: i0, template: "<input\n\tclass=\"wj-grid-editor abento-dtepicker bmpp-input-control\"\n\t[attr.data-qe-id]=\"dataQeId+'-input'\"\n\t[(ngModel)]=\"currentDate\"\n\t(blur)=\"onBlur()\"\n\t(ngModelChange)=\"onChangeDate($event)\"\n\t[bentoDatepickerConfig]=\"datepickerConfig\"\n\tname=\"editFiscalYear\"\n\t(click)=\"onInputClick(datePickerInput)\"\n\tngbDatepicker\n\t#datePickerInput=\"ngbDatepicker\"\n\tbentoFlexGridControl\n\tplaceholder=\"{{placeholder}}\"\n\tautocomplete=\"off\"\n\t[firstDayOfWeek]=\"7\"\n/>\n\n<button\n\tclass=\"bento-icon-calendar bmpp-calendar-button\"\n\t[attr.data-qe-id]=\"dataQeId+'-btn'\"\n\t(click)=\"openDatepicker(datePickerInput)\"\n\ttype=\"button\"\n></button>\n", styles: [".bmpp-calendar-button{background:transparent!important;border:none!important;cursor:pointer!important;left:90px!important;outline:none!important;padding:0;position:absolute!important;top:9px!important;width:10%}.bmpp-input-control{padding:5px!important;width:100%!important}\n"], directives: [{ type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5$2.BentoDatepickerFlexGridControlDirective, selector: "[ngbDatepicker][bentoFlexGridControl]" }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.BentoDatepickerConfigDirective, selector: "[bentoDatepickerConfig]", inputs: ["bentoDatepickerConfig"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFiscalYearGridDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-edit-fiscal-year-grid-datepicker', providers: [{ provide: NgbDateAdapter, useClass: BmppNgbDateStructAdapter }], encapsulation: ViewEncapsulation.None, template: "<input\n\tclass=\"wj-grid-editor abento-dtepicker bmpp-input-control\"\n\t[attr.data-qe-id]=\"dataQeId+'-input'\"\n\t[(ngModel)]=\"currentDate\"\n\t(blur)=\"onBlur()\"\n\t(ngModelChange)=\"onChangeDate($event)\"\n\t[bentoDatepickerConfig]=\"datepickerConfig\"\n\tname=\"editFiscalYear\"\n\t(click)=\"onInputClick(datePickerInput)\"\n\tngbDatepicker\n\t#datePickerInput=\"ngbDatepicker\"\n\tbentoFlexGridControl\n\tplaceholder=\"{{placeholder}}\"\n\tautocomplete=\"off\"\n\t[firstDayOfWeek]=\"7\"\n/>\n\n<button\n\tclass=\"bento-icon-calendar bmpp-calendar-button\"\n\t[attr.data-qe-id]=\"dataQeId+'-btn'\"\n\t(click)=\"openDatepicker(datePickerInput)\"\n\ttype=\"button\"\n></button>\n", styles: [".bmpp-calendar-button{background:transparent!important;border:none!important;cursor:pointer!important;left:90px!important;outline:none!important;padding:0;position:absolute!important;top:9px!important;width:10%}.bmpp-input-control{padding:5px!important;width:100%!important}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i5.BentoPositioning }, { type: BmppDateHelperService }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    }, propDecorators: { gridWrapper: [{
                type: Input
            }], dataQeId: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class EditFiscalYearsComponent {
    constructor(store, activeModal, dateHelperService, editMultipleFiscalYearsService, translateService, frpService, ownerService) {
        this.store = store;
        this.activeModal = activeModal;
        this.dateHelperService = dateHelperService;
        this.editMultipleFiscalYearsService = editMultipleFiscalYearsService;
        this.translateService = translateService;
        this.frpService = frpService;
        this.ownerService = ownerService;
        this.storeSubscription$ = new Subscription();
        this.fiscalYearsGridData = new wjcCore.CollectionView();
        this.fiscalYearsHasError = [];
        this.originalFiscalYears = [];
        /**
         * Wijmo itemFormatter used for updating how grid information is rendered
         * @param panel - gridPanel
         * @param r - number representing the row
         * @param c - column representing the column
         * @param cell - cell information
         * if grid cell type is columnheader applying css class
         * if grid cell type is cell, making first row begin date and last row end date
         * and tax years column's must be enable and rest of the cells disabled
         */
        this.itemFormatter = (panel, r, c, cell) => {
            switch (panel.cellType) {
                case wjcGrid.CellType.ColumnHeader:
                    cell.classList.add('bmpp-grid-column-header');
                    break;
                case wjcGrid.CellType.Cell:
                    this.editFiscalYearGrid.errorTip.cssClass = 'wj-error-tip bmpp-validation-error';
                    if (this.accountActivity) {
                        const isStartDate = panel.grid.columns[c].binding.includes(EditFiscalYearGridColumnType.StartDate);
                        const isEndtDate = panel.grid.columns[c].binding.includes(EditFiscalYearGridColumnType.EndDate);
                        const isTaxYear = panel.grid.columns[c].binding.includes(EditFiscalYearGridColumnType.TaxYears);
                        if ((r === 0 && isStartDate) || (r === panel.rows.length - 1 && isEndtDate) || isTaxYear) {
                            cell.classList.remove('bmpp-grid-cell-disabled-color');
                        }
                        else {
                            cell.classList.add('bmpp-grid-cell-disabled-color');
                        }
                    }
                    break;
                default:
                    break;
            }
            this.isDataLoading = false;
        };
    }
    /**
     * Direct styling from inside Wijmo doesn't allow css styling, so set it from TypeScript
     */
    onGridInitialized() {
        this.setFocusOnCell(0, 0);
    }
    // set the focus on passed row and column
    setFocusOnCell(row, column) {
        setTimeout(() => {
            this.editFiscalYearGrid.hostElement.focus();
            this.editFiscalYearGrid.select(new wjcGrid.CellRange(row, column), true);
        });
    }
    // set focus on cancel or save and remove selection from last cell
    onLostFocus() {
        // remove wj-state-selected from last cell
        this.editFiscalYearGrid.cells.hostElement.lastElementChild.lastElementChild.classList.remove('wj-state-selected');
        if (this.saveButton.nativeElement.disabled) {
            setTimeout(() => this.cancelButton.nativeElement.focus());
        }
        else {
            setTimeout(() => this.saveButton.nativeElement.focus());
        }
    }
    ngOnInit() {
        this.isDataLoading = true;
        this.loadGridData();
        this.showTaxYearField = this.frpService.hasFixedAssets || this.frpService.hasAccounting;
        this.ownerId = this.ownerService.getOwnerId();
        this.editFiscalYearGrid.hostElement.tabIndex = 1;
    }
    /**
     * Loading grid data
     */
    loadGridData() {
        let originalFiscalYears;
        // I had to add this code here at the last minute since originalFiscalYears is created from grid data
        // and they are manipulating that down the road leaving it not original
        // orignal fiscalyears should be from store and not touched and updated in this grid
        this.store
            .pipe(select(getFiscalYears), first(fiscalYears => fiscalYears !== undefined))
            .subscribe(fiscalYears => {
            this.fiscalYearsFromStore = fiscalYears;
        });
        this.storeSubscription$.add(this.store
            .pipe(select(getEditFiscalYearsGridData), first(gridData => gridData !== undefined))
            .subscribe(gridData => {
            originalFiscalYears = [...gridData];
            this.editMultipleFiscalYearsService.taxYearModel = gridData.map(data => {
                return data.taxYear;
            });
            this.fiscalYearsGridData = new wjcCore.CollectionView(originalFiscalYears.map(gridData => {
                return Object.assign({}, gridData);
            }), {
                getError: this.validateGridCell.bind(this),
            });
        }));
        this.originalFiscalYears = originalFiscalYears;
        this.editMultipleFiscalYearsService.setOriginalFiscalYears(originalFiscalYears);
    }
    /**
     * Validating every cell of the grid.
     * @param item - FiscalYearGridData
     * @param colBinding - string
     */
    validateGridCell(item, colBinding) {
        if (colBinding !== EditFiscalYearGridColumnType.TaxYears) {
            const errorMessage = this.editMultipleFiscalYearsService.isCellValid(item, colBinding, this.fiscalYearsGridData.sourceCollection, this.validateGaps);
            // creating unique string to identify the fiscal year and column on which user edited and adding to array
            const errorItem = item.sequenceNumber.toString() + colBinding;
            if (errorMessage) {
                if (!this.fiscalYearsHasError.includes(errorItem)) {
                    this.fiscalYearsHasError.push(errorItem);
                }
            }
            else {
                // removing if there is no error on the user edited fiscalyear column
                this.fiscalYearsHasError = this.fiscalYearsHasError.filter(item => item !== errorItem);
            }
            return errorMessage;
        }
        // if a taxYear has selected more than one time, the validation massage will be displayed.
        if (colBinding === EditFiscalYearGridColumnType.TaxYears && item.taxYear === 0) {
            return this.translateService.instant(INVALID_TAXYEAR_SELECTION_MSG);
        }
        return null;
    }
    /**
     * Restricting input for disabled cells
     * @param event - CellRangeEventArgs
     */
    onBeginEdit(event) {
        const cell = this.editFiscalYearGrid.cells.getCellElement(event.row, event.col);
        event.cancel = wjcCore.hasClass(cell, 'bmpp-grid-cell-disabled-color');
        if (!event.cancel && this.fiscalYearsHasError.length === 0) {
            this.validateGaps = false;
        }
    }
    /**
     * Save the grid data
     */
    save() {
        // if any fiscal year has tax year selected which is not in tax year's drop down, we are setting tax year to first tax year in drop down
        this.fiscalYearsGridData.sourceCollection.map(fiscalYear => {
            if (fiscalYear.taxYears.find(taxYear => fiscalYear.taxYear === taxYear) === undefined) {
                fiscalYear.taxYear = fiscalYear.taxYears[0];
            }
            return fiscalYear;
        });
        const payload = {
            ownerId: this.ownerId,
            accountActivity: this.accountActivity,
            fiscalYearsGridData: JSON.parse(JSON.stringify(this.fiscalYearsGridData.items)),
        };
        const action = new UpdateMultipleFiscalYear(payload);
        this.store.dispatch(action);
        this.cancel();
    }
    /**
     * Returns dataQeIds
     * @param element - cell/button name string
     * @param rowIndex - grid row index
     */
    getDataQeId(element, rowIndex) {
        return (this.dataQeIdNamespace +
            '.editFiscalYearModal.' +
            element +
            (rowIndex === undefined ? '' : '-' + (rowIndex + 1).toString()));
    }
    /**
     * Dismiss the modal
     */
    cancel() {
        this.activeModal.dismiss();
    }
    /**
     * Validates and updates the end date.
     * @param selectedDate - selectedDate from the event.
     * @param cell - grid cell value.(considering as 'any' beacause, it will hold cell data as object).
     */
    updateEndDate(selectedDate, cell) {
        if (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.year) {
            cell.value = this.dateHelperService.getUTCDateFormatFromStruct(selectedDate);
            // checking if startdate is changed or not
            const originalFiscalYear = this.originalFiscalYears.find(fiscalYear => fiscalYear.id === cell.item.id);
            const noChange = isEqual(new Date(originalFiscalYear.endDate), new Date(cell.value));
            // if there are changes, setting validateGaps to false, as we not validate for gaps and overlaps now
            if (!noChange) {
                this.validateGaps = false;
            }
        }
    }
    /**
     * Validates and updates the start date.
     * @param selectedDate - selectedDate from the event.
     * @param cell - grid cell value.(considering as 'any' beacause, it will hold cell data as object)
     */
    updateStartDate(selectedDate, cell) {
        if (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.year) {
            cell.value = this.dateHelperService.getUTCDateFormatFromStruct(selectedDate);
            // checking if startdate is changed or not
            const originalFiscalYear = this.originalFiscalYears.find(fiscalYear => fiscalYear.id === cell.item.id);
            const noChange = isEqual(new Date(originalFiscalYear.startDate), new Date(cell.value));
            // if there are changes, setting validateGaps to false, as we not validate for gaps and overlaps now
            if (!noChange) {
                this.validateGaps = false;
            }
        }
    }
    /**
     * Updates the tax year.
     * @param selctedTaxYear - selected tax year from the user.
     * @param cell - grid cell value.
     */
    onChangeTaxYear(event, cell) {
        let data = [...this.fiscalYearsGridData.sourceCollection];
        data = this.editMultipleFiscalYearsService.onTaxYearChanged(cell.row.index, event, data);
        if (event) {
            cell.value = event;
        }
        this.fiscalYearsGridData.sourceCollection = data;
        // refresh the datasource
        this.editFiscalYearGrid.refresh();
    }
    /**
     * Calls the method on cell edit ended
     * @param event - wjcGrid.CellEditEndingEventArgs.
     */
    onCellEditEnded(event) {
        if (event.cancel) {
            return;
        }
        const column = this.editFiscalYearGrid.getColumn(event.col);
        const rowData = this.fiscalYearsGridData.sourceCollection[event.row];
        const originalFiscalYear = this.originalFiscalYears.find(fiscalYear => fiscalYear.id === rowData.id);
        const noChange = (column.binding === EditFiscalYearGridColumnType.StartDate &&
            isEqual(new Date(originalFiscalYear.startDate), new Date(rowData.startDate))) ||
            (column.binding === EditFiscalYearGridColumnType.EndDate &&
                isEqual(new Date(originalFiscalYear.endDate), new Date(rowData.endDate)));
        // if there are no changes, don't update anything
        if (noChange) {
            return;
        }
        // update the previous year if grid has no errors and column is startdate
        if (column.binding === EditFiscalYearGridColumnType.StartDate) {
            const currentErrorItem = rowData.sequenceNumber + EditFiscalYearGridColumnType.StartDate;
            const preceedingErrorItem = (rowData.sequenceNumber - 1).toString() + EditFiscalYearGridColumnType.EndDate;
            // update the dates if we edited date has no error and preceeding year endate has no error
            if (!this.fiscalYearsHasError.includes(currentErrorItem) &&
                !this.fiscalYearsHasError.includes(preceedingErrorItem)) {
                this.updatePreviousEndDate(rowData);
            }
        }
        // update the future fiscal years if grid has no errors and column is enddate
        if (column.binding === EditFiscalYearGridColumnType.EndDate) {
            const currentErrorItem = rowData.sequenceNumber + EditFiscalYearGridColumnType.EndDate;
            // update the dates if we change the end year, and it has no errors
            if (!this.fiscalYearsHasError.includes(currentErrorItem)) {
                this.updateSubsequentDates(rowData);
            }
        }
        // we should set originalFiscalYears to updated fiscalyears. If user changes the dates without saving more than once,
        // the fiscal years need to be compared with the updated fiscalyears.
        // if the originalFiscalYears are not updated, then dates will always be returned as changed, if user edits more than once without saving
        this.originalFiscalYears = [
            ...this.fiscalYearsGridData.sourceCollection.map(fiscalYear => {
                return Object.assign({}, fiscalYear);
            }),
        ];
        this.validateGaps = true;
        // set taxyears after updating fiscalyears and selected taxyear for each fiscalyear if there is no error in grid
        if (this.fiscalYearsHasError.length === 0)
            this.setTaxYears();
        // refresh the datasource
        this.editFiscalYearGrid.itemsSource.refresh();
        // set focus on cell edited
        this.setFocusOnCell(event.row, event.col);
    }
    /**
     * Updates previous fiscal year's end date
     * @param event - wjcGrid.CellEditEndingEventArgs.
     */
    updatePreviousEndDate(rowData) {
        const updatedEndDate = subDays(rowData.startDate, 1);
        this.fiscalYearsGridData.sourceCollection = this.fiscalYearsGridData.sourceCollection.map(fiscalYear => {
            if (rowData.sequenceNumber !== 1 && fiscalYear.sequenceNumber === rowData.sequenceNumber - 1) {
                fiscalYear.endDate = updatedEndDate;
            }
            return fiscalYear;
        });
    }
    /*
     * sets taxyears to the grid
     */
    setTaxYears() {
        this.fiscalYearsGridData.sourceCollection = this.fiscalYearsGridData.sourceCollection.map(fiscalYear => {
            const usedTaxYears = this.fiscalYearsGridData.sourceCollection
                .map(fiscalYear => fiscalYear.taxYear)
                .filter(taxYear => Boolean(taxYear) && (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.taxYear) !== taxYear);
            const taxYears = getTaxYearsForGrid(this.fiscalYearsGridData.sourceCollection, fiscalYear, usedTaxYears);
            fiscalYear.taxYear = taxYears.length === 0 ? 0 : fiscalYear.taxYear === 0 ? taxYears[0] : fiscalYear.taxYear;
            fiscalYear.taxYears = taxYears;
            return fiscalYear;
        });
    }
    /**
     * We are updating the fiscalYears by calling updateFiscalYears from editMultipleFiscalYearsService.
     * @param rowData -  FiscalYearGridData - this is the row data that is being edited
     */
    updateSubsequentDates(rowData) {
        const updatedFiscalYears = [...this.fiscalYearsGridData.sourceCollection];
        // updating the source collection with updated fiscal years
        if (rowData.sequenceNumber !== this.fiscalYearsGridData.items.length) {
            this.fiscalYearsGridData.sourceCollection = this.editMultipleFiscalYearsService.updateSubsequentFiscalYears(rowData, updatedFiscalYears);
        }
    }
    /**
     * Return true if fiscalYearGridData is modified
     */
    isFiscalYearEdited() {
        const isDirty = this.fiscalYearsGridData.sourceCollection.some((updatedItem, index) => {
            const originalData = this.fiscalYearsFromStore[index];
            // checking if dates are valid
            if (isDate(updatedItem.startDate) && isDate(updatedItem.endDate)) {
                // when user clicks on calendar, Dates will be converted into NgbDate format
                // so here we check if date is in NgbDate format, we convert into Date format
                if (updatedItem.startDate.day) {
                    updatedItem.startDate = new Date(updatedItem.startDate.year, updatedItem.startDate.month - 1, updatedItem.startDate.day);
                }
                if (updatedItem.endDate.day) {
                    updatedItem.endDate = new Date(updatedItem.endDate.year, updatedItem.endDate.month - 1, updatedItem.endDate.day);
                }
                return (!isEqual(updatedItem.endDate, originalData.endDate) ||
                    updatedItem.taxYear !== originalData.taxCodeYear ||
                    !isEqual(updatedItem.startDate, originalData.startDate));
            }
            return false;
        });
        // if we have any changes
        if (isDirty)
            return true;
        // if we have none
        return false;
    }
    /**
     * Return true if fiscalYearsHasError's length is greater than 0
     */
    isSaveDisabled() {
        const data = [...this.fiscalYearsGridData.sourceCollection];
        return (this.fiscalYearsHasError.length > 0 ||
            !this.isFiscalYearEdited() ||
            data.find(item => item.taxYear === 0) !== undefined);
    }
    /**
     * Unsubscribe from all store subscriptions
     */
    ngOnDestroy() {
        this.storeSubscription$.unsubscribe();
    }
}
EditFiscalYearsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFiscalYearsComponent, deps: [{ token: i2.Store }, { token: i1$2.NgbActiveModal }, { token: BmppDateHelperService }, { token: EditMultipleFiscalYearsService }, { token: i1$1.TranslateService }, { token: BmppFeatureResourcePermissionService }, { token: BmppOwnerService }], target: i0.ɵɵFactoryTarget.Component });
EditFiscalYearsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EditFiscalYearsComponent, selector: "bmpp-edit-fiscal-years", inputs: { dataQeIdNamespace: "dataQeIdNamespace", accountActivity: "accountActivity" }, viewQueries: [{ propertyName: "editFiscalYearGrid", first: true, predicate: ["editFiscalYearGrid"], descendants: true, static: true }, { propertyName: "editFiscalYearWrapper", first: true, predicate: ["editFiscalYearWrapper"], descendants: true }, { propertyName: "saveButton", first: true, predicate: ["saveButton"], descendants: true }, { propertyName: "cancelButton", first: true, predicate: ["cancelButton"], descendants: true }], ngImport: i0, template: "<div class=\"modal-header\">\n\t<h2 id=\"modal-title\">{{ 'bmpp.ng.common.editFiscalYear' | translate }}</h2>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\ttabindex=\"0\"\n\t\t(keydown.Tab)=\"setFocusOnCell(0,0)\"\n\t\t[attr.data-qe-id]=\"getDataQeId('cancelCrossButton')\"\n\t\t(click)=\"cancel()\"\n\t>\n\t\t<!-- this is to show x button -->\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n</div>\n<div [bentoBusyLoader]=\"isDataLoading\">\n\t<div class=\"modal-body\">\n\t\t<div>{{'bmpp.edit.fiscal.years.info.text' | translate}}</div>\n\t\t<br />\n\t\t<div *ngIf=\"accountActivity\">\n\t\t\t<b>{{'bmpp.edit.fiscal.years.note' | translate}}&nbsp;</b>\n\t\t\t{{'bmpp.edit.fiscal.years.note.text'| translate}}\n\t\t</div>\n\t\t<br />\n\t\t<div #editFiscalYearWrapper>\n\t\t\t<wj-flex-grid\n\t\t\t\t#editFiscalYearGrid\n\t\t\t\t[ngClass]=\"'bmpp bento-flex-grid has-row-hover'\"\n\t\t\t\t[itemsSource]=\"fiscalYearsGridData\"\n\t\t\t\t[stickyHeaders]=\"true\"\n\t\t\t\t[showSort]=\"false\"\n\t\t\t\t[showMarquee]=\"false\"\n\t\t\t\t[allowSorting]=\"false\"\n\t\t\t\t[headersVisibility]=\"'Column'\"\n\t\t\t\t[itemFormatter]=\"itemFormatter\"\n\t\t\t\t[validateEdits]=\"false\"\n\t\t\t\t(beginningEdit)=\"onBeginEdit($event)\"\n\t\t\t\t(cellEditEnded)=\"onCellEditEnded($event)\"\n\t\t\t\t(initialized)=\"onGridInitialized()\"\n\t\t\t\t(lostFocus)=\"onLostFocus()\"\n\t\t\t\t[keyActionTab]=\"'CycleOut'\"\n\t\t\t>\n\t\t\t\t<!-- This is to show startDate column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.common.yearBeginDate' | translate\"\n\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t[align]=\"'left'\"\n\t\t\t\t\t[binding]=\"'startDate'\"\n\t\t\t\t\t[format]=\"'d'\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-cell=\"cell\">\n\t\t\t\t\t\t<bmpp-edit-fiscal-year-grid-datepicker\n\t\t\t\t\t\t\t[dataQeId]=\"getDataQeId('startDate',cell.row.index)\"\n\t\t\t\t\t\t\t[gridWrapper]=\"editFiscalYearWrapper\"\n\t\t\t\t\t\t\t[(value)]=\"item.startDate\"\n\t\t\t\t\t\t\t(valueChange)=\"updateStartDate($event,cell)\"\n\t\t\t\t\t\t></bmpp-edit-fiscal-year-grid-datepicker>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t<!-- This is to show endDate column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.common.yearEndDate' | translate\"\n\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t[align]=\"'left'\"\n\t\t\t\t\t[binding]=\"'endDate'\"\n\t\t\t\t\t[format]=\"'d'\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-cell=\"cell\">\n\t\t\t\t\t\t<bmpp-edit-fiscal-year-grid-datepicker\n\t\t\t\t\t\t\t[dataQeId]=\"getDataQeId('endDate',cell.row.index)\"\n\t\t\t\t\t\t\t[gridWrapper]=\"editFiscalYearWrapper\"\n\t\t\t\t\t\t\t[(value)]=\"item.endDate\"\n\t\t\t\t\t\t\t(valueChange)=\"updateEndDate($event,cell)\"\n\t\t\t\t\t\t></bmpp-edit-fiscal-year-grid-datepicker>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t<!-- This is to show TaxYear column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.client.taxYear' | translate \"\n\t\t\t\t\tformat=\"d\"\n\t\t\t\t\t[binding]=\"'taxYear'\"\n\t\t\t\t\twidth=\"*\"\n\t\t\t\t\t[allowResizing]=\"false\"\n\t\t\t\t\talign=\"left\"\n\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t*ngIf=\"showTaxYearField\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'ColumnHeader'\">\n\t\t\t\t\t\t{{ 'bmpp.ng.client.taxYear' | translate }}\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\tclass=\"bento-icon-info-filled taxYear-info-icon\"\n\t\t\t\t\t\t\trole=\"img\"\n\t\t\t\t\t\t\tcontainer=\"body\"\n\t\t\t\t\t\t\t[ngbTooltip]=\"'bmpp.edit.fiscal.years.tooltip' | translate\"\n\t\t\t\t\t\t\tplacement=\"top\"\n\t\t\t\t\t\t></i>\n\t\t\t\t\t</ng-template>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\" let-item=\"item\">\n\t\t\t\t\t\t<select\n\t\t\t\t\t\t\tclass=\"form-control bmpp-select\"\n\t\t\t\t\t\t\tbentoSelect\n\t\t\t\t\t\t\taria-label=\"Tax Year\"\n\t\t\t\t\t\t\t[(ngModel)]=\"item.taxYear\"\n\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('taxYear', cell.row.index)\"\n\t\t\t\t\t\t\t(ngModelChange)=\"onChangeTaxYear($event,cell)\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<option\n\t\t\t\t\t\t\t\t*ngFor=\"let taxYear of item.taxYears\"\n\t\t\t\t\t\t\t\t[ngValue]=\"taxYear\"\n\t\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('taxYearDropdown', cell.row.index)\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{ taxYear }}\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\t\t\t</wj-flex-grid>\n\t\t</div>\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\t#saveButton\n\t\t\ttabindex=\"2\"\n\t\t\ttype=\"button\"\n\t\t\t(click)=\"save()\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('saveButton')\"\n\t\t\t[disabled]=\"isSaveDisabled()\"\n\t\t>\n\t\t\t{{'bmpp.ng.common.save' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\t#cancelButton\n\t\t\ttabindex=\"3\"\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t(click)=\"cancel()\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('cancelButton')\"\n\t\t>\n\t\t\t{{'bmpp.ng.common.cancel' | translate }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".bmpp.bento-flex-grid{font-size:15px;max-height:223px;width:410px}.bento-icon-info-filled.taxYear-info-icon{font-size:15px;left:35px}.form-control.bmpp-select{height:inherit!important}.bmpp-grid-cell-disabled-color{background-color:#e3e3e3!important}.bmpp-grid-column-header{background-color:#e6e6e6!important;text-transform:none!important;z-index:3!important}.bmpp.bento-flex-grid div[wj-part=root]{overflow-x:hidden!important}.wj-error-tip.bmpp-validation-error{background:#fff;color:#000;font-weight:400}.wj-error-tip.bmpp-validation-error:before{border:none;color:#dc0a0a;content:\"\\e721\";display:inline-block;font-family:bento-icons,sans-serif;font-size:17px;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;height:14px;line-height:0;position:relative;speak:none;top:2px;width:1.3em}#bentoNGModalContainer .bmpp-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}\n"], components: [{ type: i8.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "tabOrder", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "columnGroupCollapsedChanging", "columnGroupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i8.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "cssClassAll", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor"], outputs: ["initialized", "isSelectedChange"] }, { type: EditFiscalYearGridDatepickerComponent, selector: "bmpp-edit-fiscal-year-grid-datepicker", inputs: ["gridWrapper", "dataQeId", "value"], outputs: ["valueChange"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i8.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellType", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i5.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFiscalYearsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-edit-fiscal-years', encapsulation: ViewEncapsulation.None, template: "<div class=\"modal-header\">\n\t<h2 id=\"modal-title\">{{ 'bmpp.ng.common.editFiscalYear' | translate }}</h2>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\ttabindex=\"0\"\n\t\t(keydown.Tab)=\"setFocusOnCell(0,0)\"\n\t\t[attr.data-qe-id]=\"getDataQeId('cancelCrossButton')\"\n\t\t(click)=\"cancel()\"\n\t>\n\t\t<!-- this is to show x button -->\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</button>\n</div>\n<div [bentoBusyLoader]=\"isDataLoading\">\n\t<div class=\"modal-body\">\n\t\t<div>{{'bmpp.edit.fiscal.years.info.text' | translate}}</div>\n\t\t<br />\n\t\t<div *ngIf=\"accountActivity\">\n\t\t\t<b>{{'bmpp.edit.fiscal.years.note' | translate}}&nbsp;</b>\n\t\t\t{{'bmpp.edit.fiscal.years.note.text'| translate}}\n\t\t</div>\n\t\t<br />\n\t\t<div #editFiscalYearWrapper>\n\t\t\t<wj-flex-grid\n\t\t\t\t#editFiscalYearGrid\n\t\t\t\t[ngClass]=\"'bmpp bento-flex-grid has-row-hover'\"\n\t\t\t\t[itemsSource]=\"fiscalYearsGridData\"\n\t\t\t\t[stickyHeaders]=\"true\"\n\t\t\t\t[showSort]=\"false\"\n\t\t\t\t[showMarquee]=\"false\"\n\t\t\t\t[allowSorting]=\"false\"\n\t\t\t\t[headersVisibility]=\"'Column'\"\n\t\t\t\t[itemFormatter]=\"itemFormatter\"\n\t\t\t\t[validateEdits]=\"false\"\n\t\t\t\t(beginningEdit)=\"onBeginEdit($event)\"\n\t\t\t\t(cellEditEnded)=\"onCellEditEnded($event)\"\n\t\t\t\t(initialized)=\"onGridInitialized()\"\n\t\t\t\t(lostFocus)=\"onLostFocus()\"\n\t\t\t\t[keyActionTab]=\"'CycleOut'\"\n\t\t\t>\n\t\t\t\t<!-- This is to show startDate column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.common.yearBeginDate' | translate\"\n\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t[align]=\"'left'\"\n\t\t\t\t\t[binding]=\"'startDate'\"\n\t\t\t\t\t[format]=\"'d'\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-cell=\"cell\">\n\t\t\t\t\t\t<bmpp-edit-fiscal-year-grid-datepicker\n\t\t\t\t\t\t\t[dataQeId]=\"getDataQeId('startDate',cell.row.index)\"\n\t\t\t\t\t\t\t[gridWrapper]=\"editFiscalYearWrapper\"\n\t\t\t\t\t\t\t[(value)]=\"item.startDate\"\n\t\t\t\t\t\t\t(valueChange)=\"updateStartDate($event,cell)\"\n\t\t\t\t\t\t></bmpp-edit-fiscal-year-grid-datepicker>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t<!-- This is to show endDate column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.common.yearEndDate' | translate\"\n\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t[align]=\"'left'\"\n\t\t\t\t\t[binding]=\"'endDate'\"\n\t\t\t\t\t[format]=\"'d'\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-cell=\"cell\">\n\t\t\t\t\t\t<bmpp-edit-fiscal-year-grid-datepicker\n\t\t\t\t\t\t\t[dataQeId]=\"getDataQeId('endDate',cell.row.index)\"\n\t\t\t\t\t\t\t[gridWrapper]=\"editFiscalYearWrapper\"\n\t\t\t\t\t\t\t[(value)]=\"item.endDate\"\n\t\t\t\t\t\t\t(valueChange)=\"updateEndDate($event,cell)\"\n\t\t\t\t\t\t></bmpp-edit-fiscal-year-grid-datepicker>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t<!-- This is to show TaxYear column in the grid -->\n\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t[header]=\"'bmpp.ng.client.taxYear' | translate \"\n\t\t\t\t\tformat=\"d\"\n\t\t\t\t\t[binding]=\"'taxYear'\"\n\t\t\t\t\twidth=\"*\"\n\t\t\t\t\t[allowResizing]=\"false\"\n\t\t\t\t\talign=\"left\"\n\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t*ngIf=\"showTaxYearField\"\n\t\t\t\t>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'ColumnHeader'\">\n\t\t\t\t\t\t{{ 'bmpp.ng.client.taxYear' | translate }}\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\tclass=\"bento-icon-info-filled taxYear-info-icon\"\n\t\t\t\t\t\t\trole=\"img\"\n\t\t\t\t\t\t\tcontainer=\"body\"\n\t\t\t\t\t\t\t[ngbTooltip]=\"'bmpp.edit.fiscal.years.tooltip' | translate\"\n\t\t\t\t\t\t\tplacement=\"top\"\n\t\t\t\t\t\t></i>\n\t\t\t\t\t</ng-template>\n\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\" let-item=\"item\">\n\t\t\t\t\t\t<select\n\t\t\t\t\t\t\tclass=\"form-control bmpp-select\"\n\t\t\t\t\t\t\tbentoSelect\n\t\t\t\t\t\t\taria-label=\"Tax Year\"\n\t\t\t\t\t\t\t[(ngModel)]=\"item.taxYear\"\n\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('taxYear', cell.row.index)\"\n\t\t\t\t\t\t\t(ngModelChange)=\"onChangeTaxYear($event,cell)\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<option\n\t\t\t\t\t\t\t\t*ngFor=\"let taxYear of item.taxYears\"\n\t\t\t\t\t\t\t\t[ngValue]=\"taxYear\"\n\t\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('taxYearDropdown', cell.row.index)\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{ taxYear }}\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</wj-flex-grid-column>\n\t\t\t</wj-flex-grid>\n\t\t</div>\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\t#saveButton\n\t\t\ttabindex=\"2\"\n\t\t\ttype=\"button\"\n\t\t\t(click)=\"save()\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('saveButton')\"\n\t\t\t[disabled]=\"isSaveDisabled()\"\n\t\t>\n\t\t\t{{'bmpp.ng.common.save' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\t#cancelButton\n\t\t\ttabindex=\"3\"\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t(click)=\"cancel()\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('cancelButton')\"\n\t\t>\n\t\t\t{{'bmpp.ng.common.cancel' | translate }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".bmpp.bento-flex-grid{font-size:15px;max-height:223px;width:410px}.bento-icon-info-filled.taxYear-info-icon{font-size:15px;left:35px}.form-control.bmpp-select{height:inherit!important}.bmpp-grid-cell-disabled-color{background-color:#e3e3e3!important}.bmpp-grid-column-header{background-color:#e6e6e6!important;text-transform:none!important;z-index:3!important}.bmpp.bento-flex-grid div[wj-part=root]{overflow-x:hidden!important}.wj-error-tip.bmpp-validation-error{background:#fff;color:#000;font-weight:400}.wj-error-tip.bmpp-validation-error:before{border:none;color:#dc0a0a;content:\"\\e721\";display:inline-block;font-family:bento-icons,sans-serif;font-size:17px;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;height:14px;line-height:0;position:relative;speak:none;top:2px;width:1.3em}#bentoNGModalContainer .bmpp-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.Store }, { type: i1$2.NgbActiveModal }, { type: BmppDateHelperService }, { type: EditMultipleFiscalYearsService }, { type: i1$1.TranslateService }, { type: BmppFeatureResourcePermissionService }, { type: BmppOwnerService }]; }, propDecorators: { editFiscalYearGrid: [{
                type: ViewChild,
                args: ['editFiscalYearGrid', { static: true }]
            }], editFiscalYearWrapper: [{
                type: ViewChild,
                args: ['editFiscalYearWrapper']
            }], saveButton: [{
                type: ViewChild,
                args: ['saveButton']
            }], cancelButton: [{
                type: ViewChild,
                args: ['cancelButton']
            }], dataQeIdNamespace: [{
                type: Input
            }], accountActivity: [{
                type: Input
            }] } });

/**
 * Returns transaction state
 */
const getTransactionState = createSelector(getPeriodsState, (state) => state.transactionState);
/**
 * Returns the count of transactions for contact
 */
const getTransactionCount = createSelector(getTransactionState, (state) => state.transactionCount);

/**
 * Returns the IAC state
 */
const getIacState = createSelector(getPeriodsState, (state) => state.iacState);
/**
 * Returns the IAC.
 */
const getIac = createSelector(getIacState, (state) => state.iac);
/**
 * Returns the IAC Loading status from the state
 */
const getIacLoading = createSelector(getIacState, (state) => state.iacIsLoading);
/**
 * Returns the IAC Loaded status from the state
 */
const getIacLoaded = createSelector(getIacState, (state) => state.iacIsLoaded);
/**
 * Returns the IAC Loading Failed status from the state
 */
const getIacLoadingFailed = createSelector(getIacState, (state) => state.iacLoadingFailed);
/**
 * Returns true if it has EditMultipleFiscalYearIAC
 */
const hasMultipleFiscalYearIAC = createSelector(getIacState, (state) => {
    if (state.iacIsLoaded) {
        return state.iac.hasMultipleFiscalYearIAC;
    }
});

/**
 * Render fiscal year begin and end dates
 */
class FiscalYearDateComponent {
    constructor(dateHelperService, store, openModalService, frpService) {
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.openModalService = openModalService;
        this.frpService = frpService;
    }
    ngOnInit() {
        this.fiscalYear$ = this.store.pipe(select(getSelectedFiscalYear), filter(year => year !== undefined));
        this.accountActivity();
        this.setMultipleFiacalYearIAC();
        this.isCurrentDevelopment = this.frpService.isCurrentDevelopment;
    }
    /**
     * get's the flag if account has any activity
     */
    accountActivity() {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionCount = yield this.store
                .pipe(select(getTransactionCount), first(count => count !== undefined))
                .toPromise();
            this.hasAccountActivity = transactionCount > 0;
        });
    }
    setMultipleFiacalYearIAC() {
        return __awaiter(this, void 0, void 0, function* () {
            const hasIac = yield this.store.pipe(select(hasMultipleFiscalYearIAC), first()).toPromise();
            this.hasMultipleFiscalYearIAC = hasIac;
        });
    }
    /**
     * Presents date in current region format
     * @param date - date of fiscal year to be fromated depends on region
     */
    formatDate(date) {
        return this.dateHelperService.getFormattedDate(date);
    }
    /**
     * Open Edit Fiscal Year modal dialog
     */
    onEditFiscalYear(fiscalYear) {
        let componentConfig;
        let options;
        let component;
        if (this.hasMultipleFiscalYearIAC) {
            componentConfig = {
                dataQeIdNamespace: this.dataQeIdNamespace,
                accountActivity: this.hasAccountActivity,
            };
            options = {
                windowClass: 'bmpp-edit-fiscal-year-modal',
            };
            component = EditFiscalYearsComponent;
        }
        else {
            componentConfig = {
                fiscalYear: fiscalYear,
                dataQeIdNamespace: this.dataQeIdNamespace,
            };
            options = {
                windowClass: 'bmpp-add-edit-fiscal-year-modal',
            };
            component = AddEditFiscalYearComponent;
        }
        this.openModalService.openModal(component, options, componentConfig);
    }
}
FiscalYearDateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearDateComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }, { token: OpenModalHelperService }, { token: BmppFeatureResourcePermissionService }], target: i0.ɵɵFactoryTarget.Component });
FiscalYearDateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FiscalYearDateComponent, selector: "bmpp-fiscal-year-date", inputs: { dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<ng-container *ngIf=\"fiscalYear$ | async as fiscalYear\">\n\t<label>{{ 'bmpp.ng.fiscal.year.dates.header' | translate }}</label>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<p class=\"pl-2 pt-1 font-weight-bold\">\n\t\t\t\t{{ formatDate(fiscalYear.startDate) }} - {{ formatDate(fiscalYear.endDate) }}\n\t\t\t</p>\n\t\t</div>\n\t\t<div class=\"col-sm-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"dataQeIdNamespace + '.editFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.editFiscalYear'\"\n\t\t\t\t(linkClick)=\"onEditFiscalYear(fiscalYear)\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n</ng-container>\n", components: [{ type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i3.AsyncPipe, "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-fiscal-year-date', template: "<ng-container *ngIf=\"fiscalYear$ | async as fiscalYear\">\n\t<label>{{ 'bmpp.ng.fiscal.year.dates.header' | translate }}</label>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<p class=\"pl-2 pt-1 font-weight-bold\">\n\t\t\t\t{{ formatDate(fiscalYear.startDate) }} - {{ formatDate(fiscalYear.endDate) }}\n\t\t\t</p>\n\t\t</div>\n\t\t<div class=\"col-sm-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"dataQeIdNamespace + '.editFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.editFiscalYear'\"\n\t\t\t\t(linkClick)=\"onEditFiscalYear(fiscalYear)\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }, { type: OpenModalHelperService }, { type: BmppFeatureResourcePermissionService }]; }, propDecorators: { dataQeIdNamespace: [{
                type: Input
            }] } });

/**
 * Render currnet period frequency type of fiscal year
 */
class PeriodFrequencyComponent {
    constructor(store) {
        this.store = store;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        // starts watching selected fiscal year to get its period frequency
        this.subscription$.add(this.store.pipe(select(getSelectedFiscalYear)).subscribe(fiscalYear => this.onSelectedFiscalYearChange(fiscalYear)));
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    /**
     * Returns true if the fiscal year has custom period frequency.
     */
    get isCustomPeriodFrequency() {
        return this.frequencyType === FrequencyType.Custom;
    }
    /**
     * Handler when selected fiscal year is changed in combo box
     * @param fiscalYear - passed on slected year change event triggered
     */
    onSelectedFiscalYearChange(fiscalYear) {
        var _a;
        if (fiscalYear) {
            // gets the periods number for the application/period type
            const periodsCountOfPeriodType = fiscalYear.periods.filter(p => p.periodType === this.periodType).length;
            // set default frequency type if there is no periods for period type
            if (periodsCountOfPeriodType === 0) {
                this.frequencyType = FrequencyType.Annual;
                return;
            }
            // returns the frequency type depended on periods number
            this.frequencyType = (_a = periodFrequencies.find(frequency => frequency.value === periodsCountOfPeriodType)) === null || _a === void 0 ? void 0 : _a.frequencyType;
            // if period frequencies have no predefined periods number
            // set custom frequency type
            if (this.frequencyType === undefined) {
                this.frequencyType = FrequencyType.Custom;
            }
            // set periods number if custom frequency type
            if (this.frequencyType === FrequencyType.Custom) {
                this.numberOfPeriods = periodsCountOfPeriodType;
            }
        }
    }
    /**
     * Gets period frequency display name depends on frequency type
     * @param type - passed frequency type from fiscal year
     */
    getPeriodFrequencyDisplay(frequencyType) {
        var _a;
        return (_a = periodFrequencies.find(frequency => frequency.frequencyType === frequencyType)) === null || _a === void 0 ? void 0 : _a.display;
    }
}
PeriodFrequencyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencyComponent, deps: [{ token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
PeriodFrequencyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: PeriodFrequencyComponent, selector: "bmpp-period-frequency", inputs: { periodType: "periodType" }, ngImport: i0, template: "<p class=\"pl-2 pt-1 font-weight-bold\">\n\t{{ getPeriodFrequencyDisplay(frequencyType) | translate }}\n\t<span *ngIf=\"isCustomPeriodFrequency\">\n\t\t({{ numberOfPeriods }} {{ 'bmpp.ng.fiscal.year.periodFrequency.periods' | translate}})</span\n\t>\n</p>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodFrequencyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-period-frequency', template: "<p class=\"pl-2 pt-1 font-weight-bold\">\n\t{{ getPeriodFrequencyDisplay(frequencyType) | translate }}\n\t<span *ngIf=\"isCustomPeriodFrequency\">\n\t\t({{ numberOfPeriods }} {{ 'bmpp.ng.fiscal.year.periodFrequency.periods' | translate}})</span\n\t>\n</p>\n" }]
        }], ctorParameters: function () { return [{ type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }] } });

var WarningMessageTypes;
(function (WarningMessageTypes) {
    WarningMessageTypes["unbalanced"] = "UnbalancedAmount";
    WarningMessageTypes["ungrouped"] = "UngroupedAccount";
    WarningMessageTypes["unbalancedUngrouped"] = "UnbalancedAndUngrouped";
})(WarningMessageTypes || (WarningMessageTypes = {}));

var CurrencyTypeEnum;
(function (CurrencyTypeEnum) {
    CurrencyTypeEnum["ARS"] = "ARS";
    CurrencyTypeEnum["CAD"] = "CAD";
    CurrencyTypeEnum["GBP"] = "GBP";
    CurrencyTypeEnum["USD"] = "USD";
    CurrencyTypeEnum["AUD"] = "AUD";
})(CurrencyTypeEnum || (CurrencyTypeEnum = {}));

class AmountFormattingService {
    /** Returns the formatted amount according to the locales
     * @param language -
     * @param amount -
     * @returns Intl.NumberFormat
     */
    formatAmount(language, amount) {
        const options = {
            style: 'currency',
            minimumFractionDigits: 2,
        };
        // currency code from: https://www.currency-iso.org/en/home/tables/table-a1.html
        switch (language) {
            case 'es-ar':
                options.currency = CurrencyTypeEnum.ARS;
                break;
            case 'en-ca':
                options.currency = CurrencyTypeEnum.CAD;
                break;
            case 'fr-ca':
                options.currency = CurrencyTypeEnum.CAD;
                options.currencyDisplay = 'narrowSymbol';
                break;
            case 'en-gb':
                options.currency = CurrencyTypeEnum.GBP;
                break;
            case 'en-au':
                options.currency = CurrencyTypeEnum.AUD;
                break;
            default:
                options.currency = CurrencyTypeEnum.USD;
        }
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
        return new Intl.NumberFormat(language, options).format(amount);
    }
    /** Format the amount
     * put the negative numbers without the '-' and adding parenthesis according to the locales
     * @param localeId -
     * @param amount -
     * @returns formattedAmount
     */
    getFormattedAmount(localeId, amount) {
        const formattedAmount = this.formatAmount(localeId, amount);
        if (localeId === 'en-gb' || localeId === 'es-ar' || localeId === 'en-au') {
            return formattedAmount;
        }
        return amount < 0 ? `(${formattedAmount.replace('-', '')})` : formattedAmount;
    }
}
AmountFormattingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AmountFormattingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AmountFormattingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AmountFormattingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AmountFormattingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AccountWarningComponent {
    // Emit events provided by parent component
    constructor(activeModal, translate, elementRef, sanitized, renderer, amountFormattingService, locale) {
        this.activeModal = activeModal;
        this.translate = translate;
        this.elementRef = elementRef;
        this.sanitized = sanitized;
        this.renderer = renderer;
        this.amountFormattingService = amountFormattingService;
        this.locale = locale.toLowerCase();
    }
    ngOnInit() {
        const trialBalanceLabel = this.translate.instant('bmpp.trialBalance');
        const adjustmentLabel = this.translate.instant('bmpp.adjustments');
        const groupingsLabel = this.translate.instant('bmpp.groupings');
        this.messageForModal(trialBalanceLabel, adjustmentLabel, groupingsLabel);
    }
    /**
     * The message for the modal is created depending on whether redirection is required
     */
    messageForModal(trialBalanceLabel, adjustmentLabel, groupingsLabel) {
        const trialBalanceLink = `<button data-qe-id="bmpp.tbLinkYecWarningModal" id="tbLinkYecWarningModal" class="btn-link" style="padding: 0 !important;">${trialBalanceLabel}</button>`;
        const adjustmentsLink = `<button data-qe-id="bmpp.adjLinkYecWarningModal" id="adjLinkYecWarningModal" class="btn-link" style="padding: 0 !important;">${adjustmentLabel}</button>`;
        const groupingsLink = `<button data-qe-id="bmpp.grLinkYecWarningModal" id="grLinkYecWarningModal" class="btn-link" style="padding: 0 !important;">${groupingsLabel}</button>`;
        const pathName = this.getWindowUrl().pathname.replace(new RegExp(/\//, 'g'), '').toLowerCase();
        this.needsRedirect = pathName === 'workpapers' || pathName === 'trialbalance' || pathName === 'accounts';
        const messageUnbalanced = this.translate.instant('bmpp.modal.yec.message.content', {
            unbalancedAmount: this.amountFormattingService.getFormattedAmount(this.locale, this.unbalancedAmount),
        });
        const messageUngrouped = this.translate.instant('bmwps.modal.yec.message.content.ungrouped');
        if (this.needsRedirect) {
            this.messageUnbalanced = this.sanitized.bypassSecurityTrustHtml(messageUnbalanced.replace('adjustmentsLink', adjustmentsLink).replace('trialBalanceLink', trialBalanceLink));
            this.messageUngrouped = this.sanitized.bypassSecurityTrustHtml(messageUngrouped.replace('groupingsLink', groupingsLink));
        }
        else {
            this.messageUnbalanced = messageUnbalanced
                .replace('adjustmentsLink', adjustmentLabel)
                .replace('trialBalanceLink', trialBalanceLabel);
            this.messageUngrouped = messageUngrouped.replace('groupingsLink', groupingsLabel);
        }
    }
    /**
     * open a new tab with the indicated path
     * @param route -
     */
    redirect(route) {
        const urlToGo = window.location.href.replace('settings', route);
        window.open(urlToGo, '_blank');
    }
    /**
     * Assign the redirect function in the click event to the html elements indicated by their id
     */
    ngAfterViewInit() {
        const trialBalanceLink = this.elementRef.nativeElement.querySelector('#tbLinkYecWarningModal');
        const adjustmentLink = this.elementRef.nativeElement.querySelector('#adjLinkYecWarningModal');
        const groupingsLink = this.elementRef.nativeElement.querySelector('#grLinkYecWarningModal');
        if (trialBalanceLink) {
            this.renderer.listen(trialBalanceLink, 'click', () => {
                this.redirect('trial-balance');
            });
        }
        if (adjustmentLink) {
            this.renderer.listen(adjustmentLink, 'click', () => {
                this.redirect('adjustments');
            });
        }
        if (groupingsLink) {
            this.renderer.listen(groupingsLink, 'click', () => {
                this.redirect('groupings');
            });
        }
    }
    /**
     * Handles modal close
     */
    onClose() {
        this.activeModal.close();
    }
    /**
     * Get the url of the current window
     */
    getWindowUrl() {
        return new URL(window.location.href);
    }
    /**
     * Get the enumerator for warning message types
     */
    get warningMessageTypes() {
        return WarningMessageTypes;
    }
}
AccountWarningComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountWarningComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: i1$1.TranslateService }, { token: i0.ElementRef }, { token: i3$1.DomSanitizer }, { token: i0.Renderer2 }, { token: AmountFormattingService }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Component });
AccountWarningComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: AccountWarningComponent, selector: "bmpp-account-warning", inputs: { startDateLabel: "startDateLabel", unbalancedAmount: "unbalancedAmount", messageType: "messageType" }, ngImport: i0, template: "<button type=\"button\" class=\"close\" aria-hidden=\"true\" (click)=\"onClose()\" data-qe-id=\"bmpp.closeYecWarningModal\">\n\t<i class=\"bento-icon-close-x\"></i>\n</button>\n<div class=\"modal-header\">\n\t<span>{{ 'bmpp.modal.yec.title' | translate }} {{ startDateLabel }} </span>\n</div>\n<div class=\"modal-body modal-confirm-body\">\n\t<i class=\"bento-icon-warning-filled text-danger modal-confirm-icon bmpp-yec-modal-warning-icon\"></i>\n\t<p class=\"strong bmpp-yec-modal-warning\">\n\t\t<span class=\"modal-confirm-message\">{{ 'bmpp.modal.yec.message.header' | translate }} {{ startDateLabel }}</span>\n\t</p>\n\t<p *ngIf=\"messageType==warningMessageTypes.unbalanced\">\n\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUnbalanced\"></span>\n\t</p>\n\t<p *ngIf=\"messageType==warningMessageTypes.ungrouped\">\n\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUngrouped\"></span>\n\t</p>\n\t<ul *ngIf=\"messageType==warningMessageTypes.unbalancedUngrouped\">\n\t\t<li>\n\t\t\t<p>\n\t\t\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUnbalanced\"></span>\n\t\t\t</p>\n\t\t</li>\n\t\t<li>\n\t\t\t<p>\n\t\t\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUngrouped\"></span>\n\t\t\t</p>\n\t\t</li>\n\t</ul>\n</div>\n<div class=\"modal-footer\">\n\t<button class=\"btn btn-primary btn-min-width\" (click)=\"onClose()\" data-qe-id=\"bmpp.aceptYecWarningModal\">\n\t\t{{ 'bmpp.common.ng.ok' | translate }}\n\t</button>\n</div>\n", styles: [".bmpp-yec-modal-warning{padding-top:.4em}.bmpp-yec-modal-warning-icon:before{color:#dc0a0a!important}\n"], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountWarningComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-account-warning', template: "<button type=\"button\" class=\"close\" aria-hidden=\"true\" (click)=\"onClose()\" data-qe-id=\"bmpp.closeYecWarningModal\">\n\t<i class=\"bento-icon-close-x\"></i>\n</button>\n<div class=\"modal-header\">\n\t<span>{{ 'bmpp.modal.yec.title' | translate }} {{ startDateLabel }} </span>\n</div>\n<div class=\"modal-body modal-confirm-body\">\n\t<i class=\"bento-icon-warning-filled text-danger modal-confirm-icon bmpp-yec-modal-warning-icon\"></i>\n\t<p class=\"strong bmpp-yec-modal-warning\">\n\t\t<span class=\"modal-confirm-message\">{{ 'bmpp.modal.yec.message.header' | translate }} {{ startDateLabel }}</span>\n\t</p>\n\t<p *ngIf=\"messageType==warningMessageTypes.unbalanced\">\n\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUnbalanced\"></span>\n\t</p>\n\t<p *ngIf=\"messageType==warningMessageTypes.ungrouped\">\n\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUngrouped\"></span>\n\t</p>\n\t<ul *ngIf=\"messageType==warningMessageTypes.unbalancedUngrouped\">\n\t\t<li>\n\t\t\t<p>\n\t\t\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUnbalanced\"></span>\n\t\t\t</p>\n\t\t</li>\n\t\t<li>\n\t\t\t<p>\n\t\t\t\t<span class=\"modal-confirm-message\" [innerHTML]=\"messageUngrouped\"></span>\n\t\t\t</p>\n\t\t</li>\n\t</ul>\n</div>\n<div class=\"modal-footer\">\n\t<button class=\"btn btn-primary btn-min-width\" (click)=\"onClose()\" data-qe-id=\"bmpp.aceptYecWarningModal\">\n\t\t{{ 'bmpp.common.ng.ok' | translate }}\n\t</button>\n</div>\n", styles: [".bmpp-yec-modal-warning{padding-top:.4em}.bmpp-yec-modal-warning-icon:before{color:#dc0a0a!important}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$2.NgbActiveModal }, { type: i1$1.TranslateService }, { type: i0.ElementRef }, { type: i3$1.DomSanitizer }, { type: i0.Renderer2 }, { type: AmountFormattingService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }];
    }, propDecorators: { startDateLabel: [{
                type: Input
            }], unbalancedAmount: [{
                type: Input
            }], messageType: [{
                type: Input
            }] } });

const periodTypeNames = new Map([
    [PeriodType.Accounting, 'bmpp.ng.tabs.accounting.header'],
    [PeriodType.FixedAssets, 'bmpp.ng.tabs.fixedAssets.header'],
    [PeriodType.Practice, 'bmpp.ng.tabs.firm.header'],
]);
class SetCurrentPeriodModalComponent {
    constructor(activeModal, dateHelperService, store, openModalService, localeService) {
        this.activeModal = activeModal;
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.openModalService = openModalService;
        this.localeService = localeService;
        this.isUnbalancedAmount = false;
        this.subscriptions$ = new Subscription();
        this.displayModal = true;
    }
    ngOnInit() {
        this.periodTypeName = periodTypeNames.get(this.periodType);
        this.isCanadaOrUS = this.localeService.isCountryCanadaOrUS();
        this.isCountryUK = this.localeService.isCountryUK();
        this.loadFiscalYears();
        this.setDefaultValues();
        this.subscriptions$.add(this.store.pipe(select(isUnbalancedAmount)).subscribe(response => (this.isUnbalancedAmount = response)));
        this.subscriptions$.add(this.store.pipe(select(getUnbalancedAmount)).subscribe(response => (this.unbalancedAmount = response)));
        this.subscriptions$.add(this.store.pipe(select(hasUngroupedAccounts)).subscribe(response => (this.hasUngroupedAccounts = response)));
        this.subscriptions$.add(this.store
            .pipe(select(getUngroupedAccountsLoadingFailed))
            .subscribe(response => (this.getUngroupedAccountsLoadingFailed = response)));
        this.subscriptions$.add(this.store.pipe(select(getTotalsAccountFailed)).subscribe(response => (this.getTotalsAccountFailed = response)));
        this.subscriptions$.add(this.store
            .pipe(select(getSelectedFiscalYear))
            .subscribe(selectedFiscalYear => (this.currentFiscalYear = selectedFiscalYear)));
    }
    /**
     * Saves result after successful modal close
     */
    onSave() {
        return __awaiter(this, void 0, void 0, function* () {
            const isAccountingTab = this.periodType === PeriodType.Accounting;
            if (this.movingToNextYear()) {
                if (this.isCanadaOrUS) {
                    if ((this.getUngroupedAccountsLoadingFailed || this.getTotalsAccountFailed) && isAccountingTab) {
                        return;
                    }
                    if (this.isUnbalancedAmount && this.hasUngroupedAccounts && isAccountingTab) {
                        this.openWarningModal('UnbalancedAndUngrouped');
                    }
                    else if (this.isUnbalancedAmount && isAccountingTab) {
                        this.openWarningModal('UnbalancedAmount');
                    }
                    else if (this.hasUngroupedAccounts && isAccountingTab) {
                        this.openWarningModal('UngroupedAccount');
                    }
                    else {
                        this.setNewCurrentPeriod();
                    }
                }
                else {
                    this.setNewCurrentPeriod();
                }
            }
            else {
                this.setNewCurrentPeriod();
            }
        });
    }
    /**
     * Sets the new current period. If it is within the next fiscal year, period type is Accounting,
     * has transactions and is US or CA shows YearEndClose screen. Otherwise, won't show YearEndClose screen.
     */
    setNewCurrentPeriod() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isCanadaOrUS &&
                this.periodType === PeriodType.Accounting &&
                this.movingToNextYear() &&
                this.selectedFiscalYear.periods.includes(this.selectedCurrentPeriod) &&
                (yield this.hasTransactions())) {
                this.fiscalYearForClosing = this.defaultFiscalYear.endDate.getFullYear();
                this.contactDisplayName = yield this.store
                    .pipe(select(getContactDisplayName), first(name => name !== undefined))
                    .toPromise();
                this.isYearEndCloseVisible = true;
            }
            else {
                this.updateCurrentPeriod();
                // close the set current period modal if the new current period is updated successfully
                this.store.pipe(select(getFiscalYearPeriodsUpdated)).subscribe(() => {
                    this.onClose();
                });
            }
        });
    }
    /**
     * Return true if the newCurrentPeriod is in the next fiscal year from the oldFiscalYear
     */
    movingToNextYear() {
        return this.defaultFiscalYear.sequenceNumber + 1 === this.selectedFiscalYear.sequenceNumber;
    }
    /**
     * Saves result after successful year end close modal close
     */
    onSaveYearEndClose(yearEndCloseSettings) {
        this.updateCurrentPeriod(yearEndCloseSettings);
        // close year end close workspace mode if the year end close is successful
        this.store.pipe(select(getFiscalYearPeriodsUpdated)).subscribe(() => {
            this.onClose();
        });
    }
    /**
     * Handles modal close without saving changes
     */
    onCancel() {
        this.activeModal.dismiss();
    }
    /**
     * Handles year end close modal close without saving changes
     */
    onYearEndCloseCancel() {
        this.isYearEndCloseVisible = false;
    }
    /**
     * Handles modal close without saving changes
     */
    onClose() {
        this.activeModal.close();
    }
    /**
     * Check if the contact has transactions
     */
    hasTransactions() {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionCount = yield this.store.pipe(select(getTransactionCount), first()).toPromise();
            return transactionCount > 0;
        });
    }
    /**
     * Loades fiscal years to dropdown list
     */
    loadFiscalYears() {
        return __awaiter(this, void 0, void 0, function* () {
            this.fiscalYears = yield this.store
                .pipe(select(getFiscalYearsInDescendingOrder), first(fiscalYears => fiscalYears !== undefined))
                .toPromise();
        });
    }
    /**
     * Validate the form of the modal window
     */
    validateForm() {
        this.isSaveButtonDisabled = false;
        this.isCurrentPeriodDropdownDisabled = false;
        // Disable the Save button until the user has made a new selection
        if (this.selectedCurrentPeriod.id === this.existingCurrentPeriod.id) {
            this.isSaveButtonDisabled = true;
        }
        // Disable the CurrentPeriod dropdown and Save button if the user tries to advance the current period
        // two or more years ahead of current year for Accounting type periods
        if (this.periodType === PeriodType.Accounting &&
            this.defaultFiscalYear.sequenceNumber + 1 < this.selectedFiscalYear.sequenceNumber) {
            this.isCurrentPeriodDropdownDisabled = true;
            this.isSaveButtonDisabled = true;
        }
    }
    /**
     * Set default values that the currently selected current period belongs to
     */
    setDefaultValues() {
        return __awaiter(this, void 0, void 0, function* () {
            // retrieves current fiscal year once and set it as selected in dropdown
            this.defaultFiscalYear = yield this.store
                .pipe(select(getCurrentFiscalYear(this.periodType)), first(fiscalYear => fiscalYear !== undefined))
                .toPromise();
            this.selectedFiscalYear = this.defaultFiscalYear;
            this.existingCurrentPeriod = this.defaultFiscalYear.periods.find(p => p.isCurrentPeriod && p.periodType === this.periodType);
            this.selectedCurrentPeriod = this.existingCurrentPeriod;
            this.onSelectedFiscalYearChange();
        });
    }
    /**
     * Handler when selected fiscal year is changed in combobox
     */
    onSelectedFiscalYearChange() {
        var _a, _b;
        this.selectedCurrentPeriod = this.existingCurrentPeriod;
        if (((_b = (_a = this.selectedFiscalYear) === null || _a === void 0 ? void 0 : _a.periods) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            // searches for periods depended on the tab app
            this.periods = this.selectedFiscalYear.periods.filter(p => p.periodType === this.periodType);
            // sorts periods by sequenceNumber
            this.periods.sort((p1, p2) => p1.sequenceNumber - p2.sequenceNumber);
        }
        this.validateForm();
    }
    /**
     * Handler when selected current period is changed in combobox
     */
    onSelectedCurrentPeriodChange() {
        this.validateForm();
    }
    /**
     * Updates isCurrentPeriod flag of the fiscal year periods
     */
    updateCurrentPeriod(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const action = new UpdateFiscalYearPeriods({
                ownerId: this.selectedFiscalYear.ownerId,
                fiscalYear: this.selectedFiscalYear,
                selectedPeriod: this.selectedCurrentPeriod,
                yearEndCloseSetting: settings,
            });
            this.store.dispatch(action);
            this.setDefaultValues();
        });
    }
    /**
     * Presents date in current region format
     * @param date - date of period end or fiscal year end to be formated depends on region
     */
    formatDate(date) {
        return this.dateHelperService.getFormattedDate(date);
    }
    /**
     * Unsubscribe from all store subscriptions
     */
    ngOnDestroy() {
        this.subscriptions$.unsubscribe();
    }
    /**
     * Open Set Current Periods modal dialog
     */
    openWarningModal(messageType) {
        this.displayModal = false;
        this.messageType = messageType;
        const options = {
            backdrop: 'static',
        };
        const componentConfig = {
            unbalancedAmount: this.unbalancedAmount,
            startDateLabel: this.formatDate(this.currentFiscalYear.endDate),
            messageType: this.messageType,
        };
        this.openModalService
            .openModal(AccountWarningComponent, options, componentConfig)
            .then(() => (this.displayModal = true));
    }
}
SetCurrentPeriodModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SetCurrentPeriodModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: BmppDateHelperService }, { token: i2.Store }, { token: OpenModalHelperService }, { token: LocaleService }], target: i0.ɵɵFactoryTarget.Component });
SetCurrentPeriodModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: SetCurrentPeriodModalComponent, selector: "bmpp-set-current-period-modal", inputs: { periodType: "periodType", dataQeIdNamespace: "dataQeIdNamespace" }, ngImport: i0, template: "<div *ngIf=\"displayModal\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-basic-title\">\n\t\t\t{{ 'bmpp.ng.common.setCurrentPeriod' | translate }} - {{ periodTypeName | translate }}\n\t\t</h3>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"close\"\n\t\t\taria-label=\"Close\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.cancelCrossButton'\"\n\t\t\t(click)=\"onClose()\"\n\t\t>\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<p *ngIf=\"!isCountryUK\">{{ 'bmpp.ng.currentPeriod.text' | translate }}</p>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-5 mb-3\">\n\t\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\"> {{ 'bmpp.ng.common.fiscalYearEnd' | translate }} </label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"fiscalYearSelect\"\n\t\t\t\t\t*ngIf=\"fiscalYears\"\n\t\t\t\t\t[(ngModel)]=\"selectedFiscalYear\"\n\t\t\t\t\t(ngModelChange)=\"onSelectedFiscalYearChange()\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.FiscalYearEndSelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option *ngFor=\"let fiscalYear of fiscalYears\" [ngValue]=\"fiscalYear\">{{ formatDate(fiscalYear.endDate) }}</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-5 mb-3\">\n\t\t\t\t<label class=\"d-block\" for=\"currentPeriodSelect\">\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.currentPeriod.header' | translate }}\n\t\t\t\t</label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"currentPeriodSelect\"\n\t\t\t\t\t[disabled]=\"isCurrentPeriodDropdownDisabled\"\n\t\t\t\t\t*ngIf=\"periods\"\n\t\t\t\t\t[(ngModel)]=\"selectedCurrentPeriod\"\n\t\t\t\t\t(ngModelChange)=\"onSelectedCurrentPeriodChange()\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.CurrentPeriodSelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option selected=\"existingCurrentPeriod\" [value]=\"existingCurrentPeriod\" hidden>\n\t\t\t\t\t\t{{ formatDate(existingCurrentPeriod?.endDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\texistingCurrentPeriod?.sequenceNumber }})\n\t\t\t\t\t</option>\n\t\t\t\t\t<option *ngFor=\"let period of periods\" [ngValue]=\"period\">\n\t\t\t\t\t\t{{ formatDate(period.endDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber\n\t\t\t\t\t\t}})\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t(click)=\"onSave()\"\n\t\t\t[disabled]=\"isSaveButtonDisabled\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.saveButton'\"\n\t\t>\n\t\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-dark btn-outline-primary\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.cancelButton'\"\n\t\t\t(click)=\"onCancel()\"\n\t\t>\n\t\t\t{{ 'bmpp.ng.common.cancel' | translate }}\n\t\t</button>\n\t</div>\n</div>\n<bmyec-year-end-close-main\n\t*ngIf=\"isYearEndCloseVisible\"\n\t(modalClose)=\"onSaveYearEndClose($event)\"\n\t(modalCancel)=\"onYearEndCloseCancel()\"\n\t[ownerId]=\"defaultFiscalYear.ownerId\"\n\t[fiscalYearId]=\"defaultFiscalYear.id\"\n\t[fiscalYear]=\"fiscalYearForClosing\"\n\t[contactDisplayName]=\"contactDisplayName\"\n>\n</bmyec-year-end-close-main>\n", components: [{ type: i6.BmyecYearEndCloseMainComponent, selector: "bmyec-year-end-close-main", inputs: ["ownerId", "fiscalYearId", "fiscalYear", "contactDisplayName"], outputs: ["modalClose", "modalCancel"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SetCurrentPeriodModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-set-current-period-modal', template: "<div *ngIf=\"displayModal\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" id=\"modal-basic-title\">\n\t\t\t{{ 'bmpp.ng.common.setCurrentPeriod' | translate }} - {{ periodTypeName | translate }}\n\t\t</h3>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"close\"\n\t\t\taria-label=\"Close\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.cancelCrossButton'\"\n\t\t\t(click)=\"onClose()\"\n\t\t>\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<p *ngIf=\"!isCountryUK\">{{ 'bmpp.ng.currentPeriod.text' | translate }}</p>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-5 mb-3\">\n\t\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\"> {{ 'bmpp.ng.common.fiscalYearEnd' | translate }} </label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"fiscalYearSelect\"\n\t\t\t\t\t*ngIf=\"fiscalYears\"\n\t\t\t\t\t[(ngModel)]=\"selectedFiscalYear\"\n\t\t\t\t\t(ngModelChange)=\"onSelectedFiscalYearChange()\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.FiscalYearEndSelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option *ngFor=\"let fiscalYear of fiscalYears\" [ngValue]=\"fiscalYear\">{{ formatDate(fiscalYear.endDate) }}</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-5 mb-3\">\n\t\t\t\t<label class=\"d-block\" for=\"currentPeriodSelect\">\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.currentPeriod.header' | translate }}\n\t\t\t\t</label>\n\t\t\t\t<select\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\tbentoSelect\n\t\t\t\t\tid=\"currentPeriodSelect\"\n\t\t\t\t\t[disabled]=\"isCurrentPeriodDropdownDisabled\"\n\t\t\t\t\t*ngIf=\"periods\"\n\t\t\t\t\t[(ngModel)]=\"selectedCurrentPeriod\"\n\t\t\t\t\t(ngModelChange)=\"onSelectedCurrentPeriodChange()\"\n\t\t\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.CurrentPeriodSelect'\"\n\t\t\t\t>\n\t\t\t\t\t<option selected=\"existingCurrentPeriod\" [value]=\"existingCurrentPeriod\" hidden>\n\t\t\t\t\t\t{{ formatDate(existingCurrentPeriod?.endDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{\n\t\t\t\t\t\texistingCurrentPeriod?.sequenceNumber }})\n\t\t\t\t\t</option>\n\t\t\t\t\t<option *ngFor=\"let period of periods\" [ngValue]=\"period\">\n\t\t\t\t\t\t{{ formatDate(period.endDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber\n\t\t\t\t\t\t}})\n\t\t\t\t\t</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t(click)=\"onSave()\"\n\t\t\t[disabled]=\"isSaveButtonDisabled\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.saveButton'\"\n\t\t>\n\t\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-dark btn-outline-primary\"\n\t\t\t[attr.data-qe-id]=\"dataQeIdNamespace + '.setCurrentPeriodModal.cancelButton'\"\n\t\t\t(click)=\"onCancel()\"\n\t\t>\n\t\t\t{{ 'bmpp.ng.common.cancel' | translate }}\n\t\t</button>\n\t</div>\n</div>\n<bmyec-year-end-close-main\n\t*ngIf=\"isYearEndCloseVisible\"\n\t(modalClose)=\"onSaveYearEndClose($event)\"\n\t(modalCancel)=\"onYearEndCloseCancel()\"\n\t[ownerId]=\"defaultFiscalYear.ownerId\"\n\t[fiscalYearId]=\"defaultFiscalYear.id\"\n\t[fiscalYear]=\"fiscalYearForClosing\"\n\t[contactDisplayName]=\"contactDisplayName\"\n>\n</bmyec-year-end-close-main>\n" }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: BmppDateHelperService }, { type: i2.Store }, { type: OpenModalHelperService }, { type: LocaleService }]; }, propDecorators: { periodType: [{
                type: Input
            }], dataQeIdNamespace: [{
                type: Input
            }] } });

/**
 * Render current period frequency type of fiscal year
 */
class CurrentPeriodComponent {
    constructor(dateHelperService, store, openModalService, localeService, ownerService) {
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.openModalService = openModalService;
        this.localeService = localeService;
        this.ownerService = ownerService;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        this.ownerId = this.ownerService.getOwnerId();
        // gets current period once fiscal year gets loaded
        this.subscription$.add(this.store
            .pipe(select(getCurrentPeriod(this.periodType)))
            .subscribe(currentPeriod => this.onCurrentPeriodLoad(currentPeriod)));
        // subscribe to Selected Fiscal Year
        this.subscription$.add(this.store
            .pipe(select(getSelectedFiscalYear), filter(selectedFiscalYear => selectedFiscalYear !== undefined))
            .subscribe(() => __awaiter(this, void 0, void 0, function* () { return this.getAccountsAndGrupingsData(); })));
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    /**
     * calls the necessary functions to get ungrouped accounts and totals account if the country is Canada o US
     */
    getAccountsAndGrupingsData() {
        return __awaiter(this, void 0, void 0, function* () {
            const isAccountingTab = this.periodType === PeriodType.Accounting;
            if (this.localeService.isCountryCanadaOrUS() && isAccountingTab) {
                yield Promise.all([this.getTotalsAccountLoaded(), this.getUngroupedAccountsLoaded()]);
            }
        });
    }
    /**
     * Presents date in current region format
     * @param currentPeriodDate - current period date to be formated depends on region
     */
    formatCurrentPeriodDate(currentPeriodDate) {
        return this.dateHelperService.getFormattedDate(currentPeriodDate);
    }
    /**
     * Handler when current period is loaded
     * @param period - passed on current period load event triggered
     */
    onCurrentPeriodLoad(period) {
        if (period) {
            this.currentPeriodDate = period.endDate;
            this.currentPeriodSequenceNumber = period.sequenceNumber;
            this.hasCurrentPeriod = true;
        }
        else {
            this.hasCurrentPeriod = false;
        }
    }
    /**
     * Open Set Current Periods modal dialog
     */
    onEdit() {
        const options = {
            backdrop: 'static',
            windowClass: 'bmpp-set-current-period-modal',
        };
        const componentConfig = {
            periodType: this.periodType,
            dataQeIdNamespace: this.dataQeIdNamespace,
        };
        this.openModalService.openModal(SetCurrentPeriodModalComponent, options, componentConfig);
    }
    /**
     * Load the totals account from ownerId
     */
    getTotalsAccountLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.dispatch(new LoadAccountBalanceTypeService({ ownerId: this.ownerId }));
            return this.store
                .pipe(select(getTotalsAccountLoaded), first(loaded => loaded !== undefined))
                .toPromise();
        });
    }
    /**
     *  Get ungrouped accounts loaded
     */
    getUngroupedAccountsLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.dispatch(new LoadAccountGroupService({ ownerId: this.ownerId }));
            return this.store
                .pipe(select(getUngroupedAccountsLoaded), first(loaded => loaded !== undefined))
                .toPromise();
        });
    }
}
CurrentPeriodComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CurrentPeriodComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }, { token: OpenModalHelperService }, { token: LocaleService }, { token: BmppOwnerService }], target: i0.ɵɵFactoryTarget.Component });
CurrentPeriodComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: CurrentPeriodComponent, selector: "bmpp-current-period", inputs: { dataQeIdNamespace: "dataQeIdNamespace", periodType: "periodType" }, ngImport: i0, template: "<label for=\"currentPeriod\" data-qe-id=\"bmpp.currentPeriod.header\"\n\t>{{ 'bmpp.ng.fiscal.year.currentPeriod.header' | translate }}</label\n>\n<div class=\"row\">\n\t<div class=\"col-sm-6 col-md-3 col-lg-2 pt-1\">\n\t\t<p class=\"pl-2\" *ngIf=\"hasCurrentPeriod\">\n\t\t\t<strong>\n\t\t\t\t{{ formatCurrentPeriodDate(currentPeriodDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate}} {{\n\t\t\t\tcurrentPeriodSequenceNumber }})\n\t\t\t</strong>\n\t\t</p>\n\t\t<p class=\"pl-2\" *ngIf=\"!hasCurrentPeriod\"><strong>-</strong></p>\n\t</div>\n\t<div class=\"col-sm-6 col-lg-6\">\n\t\t<bmpp-open-modal-link\n\t\t\t[dataQeId]=\"dataQeIdNamespace + '.setCurrentPeriodButton'\"\n\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t[linkTextResource]=\"'bmpp.ng.common.setCurrentPeriod'\"\n\t\t\t(linkClick)=\"onEdit()\"\n\t\t>\n\t\t</bmpp-open-modal-link>\n\t</div>\n</div>\n", components: [{ type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CurrentPeriodComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-current-period', template: "<label for=\"currentPeriod\" data-qe-id=\"bmpp.currentPeriod.header\"\n\t>{{ 'bmpp.ng.fiscal.year.currentPeriod.header' | translate }}</label\n>\n<div class=\"row\">\n\t<div class=\"col-sm-6 col-md-3 col-lg-2 pt-1\">\n\t\t<p class=\"pl-2\" *ngIf=\"hasCurrentPeriod\">\n\t\t\t<strong>\n\t\t\t\t{{ formatCurrentPeriodDate(currentPeriodDate) }} ({{ 'bmpp.ng.fiscal.year.common.period' | translate}} {{\n\t\t\t\tcurrentPeriodSequenceNumber }})\n\t\t\t</strong>\n\t\t</p>\n\t\t<p class=\"pl-2\" *ngIf=\"!hasCurrentPeriod\"><strong>-</strong></p>\n\t</div>\n\t<div class=\"col-sm-6 col-lg-6\">\n\t\t<bmpp-open-modal-link\n\t\t\t[dataQeId]=\"dataQeIdNamespace + '.setCurrentPeriodButton'\"\n\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t[linkTextResource]=\"'bmpp.ng.common.setCurrentPeriod'\"\n\t\t\t(linkClick)=\"onEdit()\"\n\t\t>\n\t\t</bmpp-open-modal-link>\n\t</div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }, { type: OpenModalHelperService }, { type: LocaleService }, { type: BmppOwnerService }]; }, propDecorators: { dataQeIdNamespace: [{
                type: Input
            }], periodType: [{
                type: Input
            }] } });

/**
 * Render the period list of the fiscal year
 */
class PeriodListComponent {
    constructor(dateHelperService, store) {
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        // starts watching selected fiscal year to get its period list
        this.subscription$.add(this.store.pipe(select(getSelectedFiscalYear)).subscribe(fiscalYear => this.onSelectedFiscalYearChange(fiscalYear)));
        // gets current period once fiscal year gets loaded
        this.subscription$.add(this.store
            .pipe(select(getCurrentPeriod(this.periodType)), filter(period => period !== undefined))
            .subscribe(currentPeriod => this.onCurrentPeriodLoad(currentPeriod)));
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    get hasAnyPeriod() {
        return Boolean(this.periods) && this.periods.length > 0;
    }
    /**
     * Handler when selected fiscal year is changed in combo box
     * @param fiscalYear - passed on slected year change event triggered
     */
    onSelectedFiscalYearChange(fiscalYear) {
        var _a;
        if (((_a = fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            // searches for periods depended on the tab app
            this.periods = fiscalYear.periods.filter(p => p.periodType === this.periodType);
            // sorts periods by sequenceNumber
            this.periods.sort((p1, p2) => p1.sequenceNumber - p2.sequenceNumber);
        }
    }
    /**
     * Compares current period id and period id in parameter
     * @param periodId - guid of period id
     */
    isCurrentPeriod(periodId) {
        return this.currentPeriodId === periodId;
    }
    /**
     * Handler when current period is loaded
     * Sets current period id
     * @param period - passed on current period load event
     */
    onCurrentPeriodLoad(currentPeriod) {
        this.currentPeriodId = currentPeriod.id;
    }
    /**
     * Presents date in current region format
     * @param periodEndDate - date of period end to be formated depends on region
     */
    formatPeriodEndDate(periodEndDate) {
        return this.dateHelperService.getFormattedDate(periodEndDate);
    }
}
PeriodListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodListComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
PeriodListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: PeriodListComponent, selector: "bmpp-period-list", inputs: { periodType: "periodType" }, ngImport: i0, template: "<div *ngIf=\"hasAnyPeriod\" class=\"mb-5\">\n\t<table class=\"table table-bordered\" role=\"presentation\" aria-label=\"Period List\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th class=\"w-50\" scope=\"col\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.common.period' | translate}}</th>\n\t\t\t\t<th class=\"w-50\" scope=\"col\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.periodList.endDate' | translate}}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr *ngFor=\"let period of periods\">\n\t\t\t\t<td class=\"w-50\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber }}</td>\n\t\t\t\t<td class=\"w-50\" tabindex=\"0\">\n\t\t\t\t\t{{ formatPeriodEndDate(period.endDate )}}\n\t\t\t\t\t<span *ngIf=\"isCurrentPeriod(period.id)\">({{ 'bmpp.ng.fiscal.year.periodList.current' | translate }})</span>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n", directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-period-list', template: "<div *ngIf=\"hasAnyPeriod\" class=\"mb-5\">\n\t<table class=\"table table-bordered\" role=\"presentation\" aria-label=\"Period List\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th class=\"w-50\" scope=\"col\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.common.period' | translate}}</th>\n\t\t\t\t<th class=\"w-50\" scope=\"col\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.periodList.endDate' | translate}}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr *ngFor=\"let period of periods\">\n\t\t\t\t<td class=\"w-50\" tabindex=\"0\">{{ 'bmpp.ng.fiscal.year.common.period' | translate }} {{ period.sequenceNumber }}</td>\n\t\t\t\t<td class=\"w-50\" tabindex=\"0\">\n\t\t\t\t\t{{ formatPeriodEndDate(period.endDate )}}\n\t\t\t\t\t<span *ngIf=\"isCurrentPeriod(period.id)\">({{ 'bmpp.ng.fiscal.year.periodList.current' | translate }})</span>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }] } });

class AccountingTabComponent {
    constructor(openModalService) {
        this.openModalService = openModalService;
        this.periodTypes = PeriodType;
    }
    /**
     * Open Edit Accounting Periods modal dialog
     */
    onEdit() {
        const options = {
            backdrop: 'static',
            windowClass: 'bmpp-edit-accounting-periods-modal',
        };
        const componentConfig = {
            periodType: this.periodTypes.Accounting,
        };
        this.openModalService.openModal(EditAccountingPeriodsModalComponent, options, componentConfig);
    }
    /**
     * Open Add Fiscal Year modal dialog
     */
    onAddFiscalYear() {
        const options = {
            windowClass: 'bmpp-add-edit-fiscal-year-modal',
        };
        const componentConfig = {
            periodType: this.periodTypes.Accounting,
            dataQeIdNamespace: 'bmpp.AccountingTab',
        };
        this.openModalService.openModal(AddEditFiscalYearComponent, options, componentConfig);
    }
}
AccountingTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountingTabComponent, deps: [{ token: OpenModalHelperService }], target: i0.ɵɵFactoryTarget.Component });
AccountingTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: AccountingTabComponent, selector: "bmpp-accounting-tab", ngImport: i0, template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.Accounting\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.AccountingTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.AccountingTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\"><bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.AccountingTab'\"></bmpp-fiscal-year-date></div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.Accounting\"></bmpp-period-frequency>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.editAccountingPeriodsButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.fiscal.year.periods.editAccountingPeriods'\"\n\t\t\t\t(linkClick)=\"onEdit()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period\n\t\t\t\t[periodType]=\"periodTypes.Accounting\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.AccountingTab'\"\n\t\t\t></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.Accounting\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n", components: [{ type: FiscalYearDropdownComponent, selector: "bmpp-fiscal-year-dropdown", inputs: ["periodType", "dataQeIdNamespace"] }, { type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }, { type: FiscalYearDateComponent, selector: "bmpp-fiscal-year-date", inputs: ["dataQeIdNamespace"] }, { type: PeriodFrequencyComponent, selector: "bmpp-period-frequency", inputs: ["periodType"] }, { type: CurrentPeriodComponent, selector: "bmpp-current-period", inputs: ["dataQeIdNamespace", "periodType"] }, { type: PeriodListComponent, selector: "bmpp-period-list", inputs: ["periodType"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountingTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-accounting-tab', template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.Accounting\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.AccountingTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.AccountingTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\"><bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.AccountingTab'\"></bmpp-fiscal-year-date></div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.Accounting\"></bmpp-period-frequency>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.editAccountingPeriodsButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.fiscal.year.periods.editAccountingPeriods'\"\n\t\t\t\t(linkClick)=\"onEdit()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period\n\t\t\t\t[periodType]=\"periodTypes.Accounting\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.AccountingTab'\"\n\t\t\t></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.Accounting\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: OpenModalHelperService }]; } });

class FixedAssetsTabComponent {
    constructor(openModalService) {
        this.openModalService = openModalService;
        this.periodTypes = PeriodType;
    }
    /**
     * Open Add Fiscal Year modal dialog
     */
    onAddFiscalYear() {
        const options = {
            windowClass: 'bmpp-add-edit-fiscal-year-modal',
        };
        const componentConfig = {
            dataQeIdNamespace: 'bmpp.FixedAssetsTab',
            periodType: PeriodType.FixedAssets,
        };
        this.openModalService.openModal(AddEditFiscalYearComponent, options, componentConfig);
    }
}
FixedAssetsTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FixedAssetsTabComponent, deps: [{ token: OpenModalHelperService }], target: i0.ɵɵFactoryTarget.Component });
FixedAssetsTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FixedAssetsTabComponent, selector: "bmpp-fixed-assets-tab", ngImport: i0, template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.FixedAssets\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.FixedAssetsTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"></bmpp-fiscal-year-date>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label class=\"d-block\" for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.FixedAssets\"></bmpp-period-frequency>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period\n\t\t\t\t[periodType]=\"periodTypes.FixedAssets\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"\n\t\t\t></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.FixedAssets\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n", components: [{ type: FiscalYearDropdownComponent, selector: "bmpp-fiscal-year-dropdown", inputs: ["periodType", "dataQeIdNamespace"] }, { type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }, { type: FiscalYearDateComponent, selector: "bmpp-fiscal-year-date", inputs: ["dataQeIdNamespace"] }, { type: PeriodFrequencyComponent, selector: "bmpp-period-frequency", inputs: ["periodType"] }, { type: CurrentPeriodComponent, selector: "bmpp-current-period", inputs: ["dataQeIdNamespace", "periodType"] }, { type: PeriodListComponent, selector: "bmpp-period-list", inputs: ["periodType"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FixedAssetsTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-fixed-assets-tab', template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.FixedAssets\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.FixedAssetsTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"></bmpp-fiscal-year-date>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label class=\"d-block\" for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.FixedAssets\"></bmpp-period-frequency>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period\n\t\t\t\t[periodType]=\"periodTypes.FixedAssets\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FixedAssetsTab'\"\n\t\t\t></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.FixedAssets\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: OpenModalHelperService }]; } });

class EditFirmPeriodsModalComponent {
    constructor(activeModal, modalService, store) {
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.store = store;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        // keep track of validation errors
        this.isValidationFailed$ = this.store.select(getIsValid);
        // keep track if changes are performed
        this.subscription$.add(this.store.select(getIsEdited).subscribe(isEdited => (this.isPeriodListEdited = isEdited)));
    }
    ngOnDestroy() {
        this.store.dispatch(new ResetEditPeriodState());
        this.subscription$.unsubscribe();
    }
    /**
     * Cancel button click handler
     */
    onCancel() {
        const modalOptions = {
            backdrop: 'static',
            size: 'sm',
            windowClass: 'bmpp-confirmation-dialog',
            container: '#bentoNGModalContainer',
        };
        if (this.isPeriodListEdited) {
            this.modalService.open(this.cancelConfirmation, modalOptions).result.then(() => this.activeModal.dismiss(), 
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => { });
        }
        else {
            this.activeModal.dismiss();
        }
    }
    /**
     * Save button click handler
     */
    onSave() {
        this.store.dispatch(new UpdateFiscalYearFrequencyType());
        this.activeModal.close();
    }
}
EditFirmPeriodsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFirmPeriodsModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: i1$2.NgbModal }, { token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
EditFirmPeriodsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EditFirmPeriodsModalComponent, selector: "bmpp-edit-firm-periods-modal", inputs: { periodType: "periodType" }, viewQueries: [{ propertyName: "cancelConfirmation", first: true, predicate: ["cancelConfirmation"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"modal-header\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row py-2\">\n\t\t\t<div class=\"col-md-4 col-sm-4 hidden-xs text-left\">\n\t\t\t\t<h3 id=\"modal-basic-title\">{{ 'bmpp.ng.fiscal.year.periods.editFirmPeriods' | translate | titlecase }}</h3>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-outline-primary mt-1\"\n\t\t\t\t\taria-label=\"Cancel\"\n\t\t\t\t\tdata-qe-id=\"bmpp.editFirmPeriodsModal.cancelButton\"\n\t\t\t\t\t(click)=\"onCancel()\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.periods.edit.cancel' | translate | titlecase }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"demo-scroll-container\">\n\t<div class=\"modal-body\">\n\t\t<bmpp-edit-periods-frequency-information\n\t\t\t[periodType]=\"periodType\"\n\t\t\t[dataQeIdNamespace]=\"'bmpp.editFirmPeriodsModal'\"\n\t\t></bmpp-edit-periods-frequency-information>\n\t\t<bento-sticky-footer>\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-primary mb-1 mt-2\"\n\t\t\t\t[disabled]=\"!isPeriodListEdited || (isValidationFailed$ | async) === false\"\n\t\t\t\tdata-qe-id=\"bmpp.editFirmPeriodsModal.saveButton\"\n\t\t\t\t(click)=\"onSave()\"\n\t\t\t>\n\t\t\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t\t\t</button>\n\t\t</bento-sticky-footer>\n\t</div>\n</div>\n\n<ng-template #cancelConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-cancel-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"'discardChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-cancel-text-area\">\n\t\t\t<h2 [innerHTML]=\"'bmpp.ng.confirmationDialog.firm.headingText' | translate\"></h2>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n", styles: [".bmpp-cancel-confirmation .bmpp-cancel-text-area{display:inline-block;vertical-align:top;width:90%}.bmpp-cancel-text-area h2{margin:0 0 1rem 1rem}.ng-bento ngb-modal-window.bmpp-edit-firm-periods-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}\n"], components: [{ type: EditPeriodsFrequencyInformationComponent, selector: "bmpp-edit-periods-frequency-information", inputs: ["periodType", "dataQeIdNamespace"] }, { type: i5.BentoStickyFooterComponent, selector: "bento-sticky-footer" }, { type: ConfirmationDialogComponent, selector: "bmpp-confirmation-dialog", inputs: ["confirmButtonText", "cancelButtonText", "activeModal", "dataQeIdNamespace"] }], directives: [{ type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "titlecase": i3.TitleCasePipe, "translate": i1$1.TranslatePipe, "async": i3.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditFirmPeriodsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-edit-firm-periods-modal', encapsulation: ViewEncapsulation.None, template: "<div class=\"modal-header\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"row py-2\">\n\t\t\t<div class=\"col-md-4 col-sm-4 hidden-xs text-left\">\n\t\t\t\t<h3 id=\"modal-basic-title\">{{ 'bmpp.ng.fiscal.year.periods.editFirmPeriods' | translate | titlecase }}</h3>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tclass=\"btn btn-outline-primary mt-1\"\n\t\t\t\t\taria-label=\"Cancel\"\n\t\t\t\t\tdata-qe-id=\"bmpp.editFirmPeriodsModal.cancelButton\"\n\t\t\t\t\t(click)=\"onCancel()\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'bmpp.ng.fiscal.year.periods.edit.cancel' | translate | titlecase }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"demo-scroll-container\">\n\t<div class=\"modal-body\">\n\t\t<bmpp-edit-periods-frequency-information\n\t\t\t[periodType]=\"periodType\"\n\t\t\t[dataQeIdNamespace]=\"'bmpp.editFirmPeriodsModal'\"\n\t\t></bmpp-edit-periods-frequency-information>\n\t\t<bento-sticky-footer>\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-primary mb-1 mt-2\"\n\t\t\t\t[disabled]=\"!isPeriodListEdited || (isValidationFailed$ | async) === false\"\n\t\t\t\tdata-qe-id=\"bmpp.editFirmPeriodsModal.saveButton\"\n\t\t\t\t(click)=\"onSave()\"\n\t\t\t>\n\t\t\t\t{{ 'bmpp.ng.common.save' | translate }}\n\t\t\t</button>\n\t\t</bento-sticky-footer>\n\t</div>\n</div>\n\n<ng-template #cancelConfirmation let-modal>\n\t<bmpp-confirmation-dialog\n\t\tclass=\"bmpp-cancel-confirmation\"\n\t\t[activeModal]=\"modal\"\n\t\t[confirmButtonText]=\"'bmpp.ng.common.continue'\"\n\t\t[cancelButtonText]=\"'bmpp.ng.common.cancel'\"\n\t\t[dataQeIdNamespace]=\"'discardChanges'\"\n\t>\n\t\t<i class=\"bento-icon-warning-filled modal-confirmation-icon text-danger\"></i>\n\t\t<div class=\"bmpp-cancel-text-area\">\n\t\t\t<h2 [innerHTML]=\"'bmpp.ng.confirmationDialog.firm.headingText' | translate\"></h2>\n\t\t</div>\n\t</bmpp-confirmation-dialog>\n</ng-template>\n", styles: [".bmpp-cancel-confirmation .bmpp-cancel-text-area{display:inline-block;vertical-align:top;width:90%}.bmpp-cancel-text-area h2{margin:0 0 1rem 1rem}.ng-bento ngb-modal-window.bmpp-edit-firm-periods-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: i1$2.NgbModal }, { type: i2.Store }]; }, propDecorators: { periodType: [{
                type: Input
            }], cancelConfirmation: [{
                type: ViewChild,
                args: ['cancelConfirmation', { static: true }]
            }] } });

class FirmTabComponent {
    constructor(localeService, openModalService) {
        this.localeService = localeService;
        this.openModalService = openModalService;
        this.periodTypes = PeriodType;
    }
    ngOnInit() {
        // Argentina does not have edit firm periods frequency flow
        this.isEditable = !this.localeService.isArgentina();
    }
    /**
     * Open Edit Firm Periods modal dialog
     */
    onEdit() {
        const options = {
            backdrop: 'static',
            windowClass: 'bmpp-edit-firm-periods-modal',
        };
        const componentConfig = {
            periodType: this.periodTypes.Practice,
        };
        this.openModalService.openModal(EditFirmPeriodsModalComponent, options, componentConfig);
    }
    /**
     * Open Add Fiscal Year modal dialog
     */
    onAddFiscalYear() {
        const options = {
            windowClass: 'bmpp-add-edit-fiscal-year-modal',
        };
        const componentConfig = {
            periodType: this.periodTypes.Practice,
            dataQeIdNamespace: 'bmpp.FirmTab',
        };
        this.openModalService.openModal(AddEditFiscalYearComponent, options, componentConfig);
    }
}
FirmTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FirmTabComponent, deps: [{ token: LocaleService }, { token: OpenModalHelperService }], target: i0.ɵɵFactoryTarget.Component });
FirmTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FirmTabComponent, selector: "bmpp-firm-tab", ngImport: i0, template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.Practice\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FirmTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.FirmTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\"><bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.FirmTab'\"></bmpp-fiscal-year-date></div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.Practice\"></bmpp-period-frequency>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t*ngIf=\"isEditable\"\n\t\t\t\t[dataQeId]=\"'bmpp.editFirmPeriodsButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.fiscal.year.periods.editFirmPeriods'\"\n\t\t\t\t(linkClick)=\"onEdit()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period [periodType]=\"periodTypes.Practice\" [dataQeIdNamespace]=\"'bmpp.FirmTab'\"></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.Practice\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n", components: [{ type: FiscalYearDropdownComponent, selector: "bmpp-fiscal-year-dropdown", inputs: ["periodType", "dataQeIdNamespace"] }, { type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }, { type: FiscalYearDateComponent, selector: "bmpp-fiscal-year-date", inputs: ["dataQeIdNamespace"] }, { type: PeriodFrequencyComponent, selector: "bmpp-period-frequency", inputs: ["periodType"] }, { type: CurrentPeriodComponent, selector: "bmpp-current-period", inputs: ["dataQeIdNamespace", "periodType"] }, { type: PeriodListComponent, selector: "bmpp-period-list", inputs: ["periodType"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FirmTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-firm-tab', template: "<div class=\"container-fluid p-0 pt-3\">\n\t<p>{{ 'bmpp.ng.tabs.text.tooltip' | translate }}</p>\n\t<div class=\"row\">\n\t\t<div class=\"col\">\n\t\t\t<label class=\"d-block\" for=\"fiscalYearSelect\">{{ 'bmpp.ng.fiscal.year.dropdown.header' | translate }}</label>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2 ml-1\">\n\t\t\t<bmpp-fiscal-year-dropdown\n\t\t\t\t[periodType]=\"periodTypes.Practice\"\n\t\t\t\t[dataQeIdNamespace]=\"'bmpp.FirmTab'\"\n\t\t\t></bmpp-fiscal-year-dropdown>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t[dataQeId]=\"'bmpp.FirmTab.addFiscalYearButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t\t(linkClick)=\"onAddFiscalYear()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\"><bmpp-fiscal-year-date [dataQeIdNamespace]=\"'bmpp.FirmTab'\"></bmpp-fiscal-year-date></div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<label for=\"periodFrequency\" data-qe-id=\"bmpp.periodFrequency.header\"\n\t\t\t\t>{{ 'bmpp.ng.fiscal.year.periodFrequency.header' | translate }}</label\n\t\t\t>\n\t\t</div>\n\t\t<div class=\"w-100\"></div>\n\t\t<div class=\"col-sm-6 col-md-3 col-lg-2\">\n\t\t\t<bmpp-period-frequency [periodType]=\"periodTypes.Practice\"></bmpp-period-frequency>\n\t\t</div>\n\t\t<div class=\"col-sm-6 col-lg-6\">\n\t\t\t<bmpp-open-modal-link\n\t\t\t\t*ngIf=\"isEditable\"\n\t\t\t\t[dataQeId]=\"'bmpp.editFirmPeriodsButton'\"\n\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t[linkTextResource]=\"'bmpp.ng.fiscal.year.periods.editFirmPeriods'\"\n\t\t\t\t(linkClick)=\"onEdit()\"\n\t\t\t>\n\t\t\t</bmpp-open-modal-link>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col pt-3\">\n\t\t\t<bmpp-current-period [periodType]=\"periodTypes.Practice\" [dataQeIdNamespace]=\"'bmpp.FirmTab'\"></bmpp-current-period>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6 col-lg-4 pt-3\">\n\t\t\t<bmpp-period-list [periodType]=\"periodTypes.Practice\"></bmpp-period-list>\n\t\t</div>\n\t</div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: LocaleService }, { type: OpenModalHelperService }]; } });

/*
 * This component is responsible for handling and rendering tabs, pills, selected tab
 */
class FinancialPeriodTabsComponent {
    constructor(store) {
        this.store = store;
        this.firmTabId = TabSetIds.firmTabId;
        this.accountingTabId = TabSetIds.accountingTabId;
        this.fixedAssetsTabId = TabSetIds.fixedAssetsTabId;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        this.subscribeToFiscalYearsLoading();
        this.subscribeToAccountDataLoading();
        this.subscribeToUngroupedAccountsLoading();
    }
    /**
     * Add subscription to fiscal years loading
     */
    subscribeToFiscalYearsLoading() {
        this.subscription$.add(this.store.select(getFiscalYearsLoading).subscribe(fiscalYearsLoading => (this.isDataLoading = fiscalYearsLoading)));
    }
    /**
     * Add subscription to Account data loading
     */
    subscribeToAccountDataLoading() {
        this.subscription$.add(this.store.select(getTotalsAccountLoading).subscribe(loading => (this.isAccountingLoading = loading)));
    }
    /**
     * Add subscription to Ungrouped Account data loading
     */
    subscribeToUngroupedAccountsLoading() {
        this.subscription$.add(this.store.select(getUngroupedAccountsLoading).subscribe(loading => (this.isUngroupedLoading = loading)));
    }
    isLoading() {
        return this.isDataLoading || this.isAccountingLoading || this.isUngroupedLoading;
    }
    /*
     * Returns id of the tab that should be selected from tab set on the first hit
     */
    getSelectedTab() {
        if (this.financialPeriodTabsModel.hasFirm) {
            return this.firmTabId;
        }
        if (this.financialPeriodTabsModel.hasAccounting) {
            return this.accountingTabId;
        }
        if (this.financialPeriodTabsModel.hasFixedAssets) {
            return this.fixedAssetsTabId;
        }
    }
    /**
     * Unsubscribe from getFiscalYearsLoading changes
     */
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
}
FinancialPeriodTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FinancialPeriodTabsComponent, deps: [{ token: i2.Store }], target: i0.ɵɵFactoryTarget.Component });
FinancialPeriodTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FinancialPeriodTabsComponent, selector: "bmpp-financial-period-tabs", inputs: { financialPeriodTabsModel: "financialPeriodTabsModel" }, ngImport: i0, template: "<div class=\"bento-tabset tabs-top w-100\" *ngIf=\"financialPeriodTabsModel\">\n\t<ul\n\t\tngbNav\n\t\t#nav=\"ngbNav\"\n\t\t[activeId]=\"getSelectedTab()\"\n\t\tclass=\"nav\"\n\t\t[ngClass]=\"{'nav-tabs': financialPeriodTabsModel.tabsetType ==='tabs', 'nav-pills': financialPeriodTabsModel.tabsetType === 'pills'}\"\n\t\tngPreserveWhitespaces\n\t>\n\t\t<li\n\t\t\t[ngbNavItem]=\"accountingTabId\"\n\t\t\t*ngIf=\"financialPeriodTabsModel.hasAccounting\"\n\t\t\trole=\"presentation\"\n\t\t\tdata-qe-id=\"bmpp-bmppApplicationTabs-accounting-tab\"\n\t\t>\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.accounting.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [ngClass]=\"{'bmpp-financial-period-tabs-centered-busy-loader': isLoading()}\">\n\t\t\t\t\t<bmpp-accounting-tab [bentoBusyLoader]=\"isLoading()\"></bmpp-accounting-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t\t<li\n\t\t\t[ngbNavItem]=\"fixedAssetsTabId\"\n\t\t\t*ngIf=\"financialPeriodTabsModel.hasFixedAssets\"\n\t\t\tdata-qe-id=\"bmpp-bmppApplicationTabs-fixedAssets-tab\"\n\t\t>\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.fixedAssets.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [bentoBusyLoader]=\"isLoading()\">\n\t\t\t\t\t<bmpp-fixed-assets-tab></bmpp-fixed-assets-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t\t<li [ngbNavItem]=\"firmTabId\" *ngIf=\"financialPeriodTabsModel.hasFirm\" data-qe-id=\"bmpp-bmppApplicationTabs-firm-tab\">\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.firm.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [ngClass]=\"{'bmpp-financial-period-tabs-centered-busy-loader': isLoading()}\">\n\t\t\t\t\t<bmpp-firm-tab [bentoBusyLoader]=\"isLoading()\"></bmpp-firm-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t</ul>\n\t<div [ngbNavOutlet]=\"nav\"></div>\n</div>\n", styles: [".bmpp-financial-period-tabs-centered-busy-loader{display:flex}.bmpp-financial-period-tabs-centered-busy-loader .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,.bmpp-financial-period-tabs-centered-busy-loader .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner{left:50%;position:fixed;top:50%}\n"], components: [{ type: AccountingTabComponent, selector: "bmpp-accounting-tab" }, { type: FixedAssetsTabComponent, selector: "bmpp-fixed-assets-tab" }, { type: FirmTabComponent, selector: "bmpp-firm-tab" }, { type: i1$2.NgbNavOutlet, selector: "[ngbNavOutlet]", inputs: ["paneRole", "ngbNavOutlet"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbNav, selector: "[ngbNav]", inputs: ["activeId", "animation", "destroyOnHide", "orientation", "roles", "keyboard"], outputs: ["activeIdChange", "shown", "hidden", "navChange"], exportAs: ["ngbNav"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$2.NgbNavItem, selector: "[ngbNavItem]", inputs: ["destroyOnHide", "disabled", "domId", "ngbNavItem"], outputs: ["shown", "hidden"], exportAs: ["ngbNavItem"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbNavLink, selector: "a[ngbNavLink]" }, { type: i1$2.NgbNavContent, selector: "ng-template[ngbNavContent]" }, { type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }], pipes: { "translate": i1$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FinancialPeriodTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-financial-period-tabs', encapsulation: ViewEncapsulation.None, template: "<div class=\"bento-tabset tabs-top w-100\" *ngIf=\"financialPeriodTabsModel\">\n\t<ul\n\t\tngbNav\n\t\t#nav=\"ngbNav\"\n\t\t[activeId]=\"getSelectedTab()\"\n\t\tclass=\"nav\"\n\t\t[ngClass]=\"{'nav-tabs': financialPeriodTabsModel.tabsetType ==='tabs', 'nav-pills': financialPeriodTabsModel.tabsetType === 'pills'}\"\n\t\tngPreserveWhitespaces\n\t>\n\t\t<li\n\t\t\t[ngbNavItem]=\"accountingTabId\"\n\t\t\t*ngIf=\"financialPeriodTabsModel.hasAccounting\"\n\t\t\trole=\"presentation\"\n\t\t\tdata-qe-id=\"bmpp-bmppApplicationTabs-accounting-tab\"\n\t\t>\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.accounting.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [ngClass]=\"{'bmpp-financial-period-tabs-centered-busy-loader': isLoading()}\">\n\t\t\t\t\t<bmpp-accounting-tab [bentoBusyLoader]=\"isLoading()\"></bmpp-accounting-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t\t<li\n\t\t\t[ngbNavItem]=\"fixedAssetsTabId\"\n\t\t\t*ngIf=\"financialPeriodTabsModel.hasFixedAssets\"\n\t\t\tdata-qe-id=\"bmpp-bmppApplicationTabs-fixedAssets-tab\"\n\t\t>\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.fixedAssets.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [bentoBusyLoader]=\"isLoading()\">\n\t\t\t\t\t<bmpp-fixed-assets-tab></bmpp-fixed-assets-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t\t<li [ngbNavItem]=\"firmTabId\" *ngIf=\"financialPeriodTabsModel.hasFirm\" data-qe-id=\"bmpp-bmppApplicationTabs-firm-tab\">\n\t\t\t<a ngbNavLink>{{'bmpp.ng.tabs.firm.header' | translate}}</a>\n\t\t\t<ng-template ngbNavContent>\n\t\t\t\t<div [ngClass]=\"{'bmpp-financial-period-tabs-centered-busy-loader': isLoading()}\">\n\t\t\t\t\t<bmpp-firm-tab [bentoBusyLoader]=\"isLoading()\"></bmpp-firm-tab>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</li>\n\t</ul>\n\t<div [ngbNavOutlet]=\"nav\"></div>\n</div>\n", styles: [".bmpp-financial-period-tabs-centered-busy-loader{display:flex}.bmpp-financial-period-tabs-centered-busy-loader .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,.bmpp-financial-period-tabs-centered-busy-loader .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner{left:50%;position:fixed;top:50%}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.Store }]; }, propDecorators: { financialPeriodTabsModel: [{
                type: Input
            }] } });

class FiscalYearListComponent {
    constructor(dateHelperService, store, openModalService) {
        this.dateHelperService = dateHelperService;
        this.store = store;
        this.openModalService = openModalService;
        this.subscription$ = new Subscription();
    }
    ngOnInit() {
        // subscribe on fiscal years changes
        this.subscription$.add(this.store.pipe(select(getFiscalYears)).subscribe(fiscalYears => {
            this.fiscalYears = fiscalYears;
        }));
        this.subscribeToFiscalYearsLoading();
        this.setMultipleFiacalYearIAC();
    }
    /** Add subscription to fiscal years loading */
    subscribeToFiscalYearsLoading() {
        this.subscription$.add(this.store.select(getFiscalYearsLoading).subscribe(fiscalYearsLoading => {
            this.isDataLoading = fiscalYearsLoading;
        }));
    }
    /** Checks if the year can be changed */
    canEditFiscalYear(fiscalYear) {
        return (fiscalYear.sequenceNumber === 1 ||
            fiscalYear.sequenceNumber === this.fiscalYears.length ||
            this.hasMultipleFiscalYearIAC);
    }
    ngOnDestroy() {
        this.subscription$.unsubscribe();
    }
    formatFiscalYearDate(fiscalYearDate) {
        return this.dateHelperService.getFormattedDate(fiscalYearDate);
    }
    /**
     * Open Add/Edit Fiscal Year modal dialog
     * @param fiscalYear - fiscal year value
     */
    onAddEditFiscalYear(fiscalYear) {
        let options;
        let componentConfig;
        let fiscalYearComponent;
        if (this.hasMultipleFiscalYearIAC) {
            componentConfig = {
                dataQeIdNamespace: 'bmpp.',
                accountActivity: false,
            };
            options = {
                windowClass: 'bmpp-edit-fiscal-year-modal',
            };
            fiscalYearComponent = EditFiscalYearsComponent;
        }
        else {
            options = {
                windowClass: 'bmpp-add-edit-fiscal-year-modal',
            };
            componentConfig = Object.assign({ dataQeIdNamespace: 'bmpp.', periodType: PeriodType.Practice }, (fiscalYear && { fiscalYear }));
            fiscalYearComponent = AddEditFiscalYearComponent;
        }
        this.openModalService.openModal(fiscalYearComponent, options, componentConfig);
    }
    /**
     * Set hasMultipleFiscalYearIAC
     */
    setMultipleFiacalYearIAC() {
        return __awaiter(this, void 0, void 0, function* () {
            const hasIac = yield this.store.pipe(select(hasMultipleFiscalYearIAC), first()).toPromise();
            this.hasMultipleFiscalYearIAC = hasIac;
        });
    }
}
FiscalYearListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearListComponent, deps: [{ token: BmppDateHelperService }, { token: i2.Store }, { token: OpenModalHelperService }], target: i0.ɵɵFactoryTarget.Component });
FiscalYearListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FiscalYearListComponent, selector: "bmpp-fiscal-year-list", ngImport: i0, template: "<div [bentoBusyLoader]=\"isDataLoading\">\n\t<div class=\"bmpp-float-right\">\n\t\t<bmpp-open-modal-link\n\t\t\t[dataQeId]=\"'bmpp.addFiscalYearButton'\"\n\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t(linkClick)=\"onAddEditFiscalYear()\"\n\t\t>\n\t\t</bmpp-open-modal-link>\n\t</div>\n\t<table class=\"table table-bordered\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.common.yearBeginDate' | translate }}</th>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.common.yearEndDate' | translate }}</th>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.fiscal.year.list.header.actions' | translate }}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr *ngFor=\"let fiscalYear of fiscalYears\">\n\t\t\t\t<td class=\"w-25\">{{ formatFiscalYearDate(fiscalYear.startDate) }}</td>\n\t\t\t\t<td class=\"w-25\">{{ formatFiscalYearDate(fiscalYear.endDate) }}</td>\n\t\t\t\t<td class=\"w-25\">\n\t\t\t\t\t<bmpp-open-modal-link\n\t\t\t\t\t\t*ngIf=\"canEditFiscalYear(fiscalYear)\"\n\t\t\t\t\t\t[dataQeId]=\"'bmpp.editFiscalYearButton'\"\n\t\t\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.editFiscalYear'\"\n\t\t\t\t\t\t(linkClick)=\"onAddEditFiscalYear(fiscalYear)\"\n\t\t\t\t\t>\n\t\t\t\t\t</bmpp-open-modal-link>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n", styles: [".bmpp-float-right{float:right}\n"], components: [{ type: OpenModalLinkComponent, selector: "bmpp-open-modal-link", inputs: ["dataQeId", "linkIconClass", "linkTextResource"], outputs: ["linkClick"] }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-fiscal-year-list', template: "<div [bentoBusyLoader]=\"isDataLoading\">\n\t<div class=\"bmpp-float-right\">\n\t\t<bmpp-open-modal-link\n\t\t\t[dataQeId]=\"'bmpp.addFiscalYearButton'\"\n\t\t\t[linkIconClass]=\"'bento-icon-add-filled'\"\n\t\t\t[linkTextResource]=\"'bmpp.ng.common.addFiscalYear'\"\n\t\t\t(linkClick)=\"onAddEditFiscalYear()\"\n\t\t>\n\t\t</bmpp-open-modal-link>\n\t</div>\n\t<table class=\"table table-bordered\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.common.yearBeginDate' | translate }}</th>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.common.yearEndDate' | translate }}</th>\n\t\t\t\t<th class=\"w-25\" scope=\"col\">{{ 'bmpp.ng.fiscal.year.list.header.actions' | translate }}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr *ngFor=\"let fiscalYear of fiscalYears\">\n\t\t\t\t<td class=\"w-25\">{{ formatFiscalYearDate(fiscalYear.startDate) }}</td>\n\t\t\t\t<td class=\"w-25\">{{ formatFiscalYearDate(fiscalYear.endDate) }}</td>\n\t\t\t\t<td class=\"w-25\">\n\t\t\t\t\t<bmpp-open-modal-link\n\t\t\t\t\t\t*ngIf=\"canEditFiscalYear(fiscalYear)\"\n\t\t\t\t\t\t[dataQeId]=\"'bmpp.editFiscalYearButton'\"\n\t\t\t\t\t\t[linkIconClass]=\"'bento-icon-edit'\"\n\t\t\t\t\t\t[linkTextResource]=\"'bmpp.ng.common.editFiscalYear'\"\n\t\t\t\t\t\t(linkClick)=\"onAddEditFiscalYear(fiscalYear)\"\n\t\t\t\t\t>\n\t\t\t\t\t</bmpp-open-modal-link>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n", styles: [".bmpp-float-right{float:right}\n"] }]
        }], ctorParameters: function () { return [{ type: BmppDateHelperService }, { type: i2.Store }, { type: OpenModalHelperService }]; } });

class PeriodsComponent {
    constructor(ownerService, store, localeService, frpService, bentoTranslate, newFiscalYearPeriodsService) {
        this.ownerService = ownerService;
        this.store = store;
        this.localeService = localeService;
        this.frpService = frpService;
        this.bentoTranslate = bentoTranslate;
        this.newFiscalYearPeriodsService = newFiscalYearPeriodsService;
        this.isFirmClient = false;
        this.alerts = [];
        this.financialPeriodsTabId = TabSetIds.financialPeriodsTabId;
        this.subscriptions = new Subscription();
        this.cookie = cookie;
        this.isInitilized = false;
    }
    ngOnInit() {
        this.store.dispatch(new LoadIac());
        this.store.dispatch(new SetPeriodsSettings({ isFirmClient: this.isFirmClient, showRelatedContacts: this.showRelatedContacts }));
        // subscribe to alerts state ahead, following async actions can eventualy push alert
        this.subscriptions.add(this.store
            .pipe(select(getAddedAlert), filter(alert => alert !== undefined))
            .subscribe(alert => this.alerts.push(alert)));
        // subscribes to removed alert and delete it from alerts
        this.subscriptions.add(this.store
            .pipe(select(getRemovedAlert), filter(removedAlert => removedAlert !== undefined))
            .subscribe(removedAlert => (this.alerts = this.alerts.filter(alert => removedAlert.msg !== alert.msg))));
        // subscribe to selected contact from contact dropdown and get id
        this.subscriptions.add(this.store
            .pipe(select(getSelectedContact), filter(contact => contact !== undefined))
            .subscribe(contact => {
            const reloadOptions = this.selectedOwnerId && this.selectedOwnerId !== contact.id;
            this.selectedOwnerId = contact.id;
            if (reloadOptions) {
                this.store.dispatch(new LoadAccountGroupService({ ownerId: this.selectedOwnerId }));
                this.store.dispatch(new LoadAccountBalanceTypeService({ ownerId: this.selectedOwnerId }));
                this.getPeriodsViewModelPermissions();
            }
        }));
        // subscribe to Add New Fiscal Year
        this.subscriptions.add(this.store.select(getNewFiscalYearAdding).subscribe(loading => (this.isAddNewFiscalYearLoading = loading)));
        // subscribe to Update Fiscal Year
        this.subscriptions.add(this.store.select(getFiscalYearUpdating).subscribe(loading => (this.isUpdateFiscalYearLoading = loading)));
        this.ownerService.setOwnerId(this.ownerId);
        this.initBentoTranslations();
        this.loadInitialData();
    }
    // load permissions and build financial periods view model
    getPeriodsViewModelPermissions() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.frpService.loadFrps((_a = this.selectedOwnerId) !== null && _a !== void 0 ? _a : this.ownerId);
            this.setupFinancialPeriodsViewModel(this.frpService.hasAccounting, this.frpService.hasFixedAssets, this.frpService.isUkVat, this.frpService.isUkTax, this.isFirmClient);
        });
    }
    // initialize services and build financial periods view model
    loadInitialData() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.localeService.loadCountryCodeAsync(),
                this.getPeriodsViewModelPermissions(),
                this.loadInitialFiscalYears(this.showRelatedContacts),
            ]);
            this.isInitilized = true;
        });
    }
    /**
     * Trigger loading of contactas and fiscal year or fiscal years only
     * and wait for loading completion
     */
    loadInitialFiscalYears(loadContacts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFirmClient) {
                this.store.dispatch(new LoadFiscalYears({ ownerId: this.ownerId }));
                this.store.dispatch(new LoadCompanyClient());
            }
            else if (loadContacts) {
                this.store.dispatch(new LoadContacts({ contactId: this.ownerId }));
            }
            else {
                this.store.dispatch(new LoadContact({ contactId: this.ownerId }));
            }
            // wait until store will be initilized with first set of fiscal years
            return this.store
                .pipe(select(getFiscalYearsLoaded), first(loaded => loaded))
                .toPromise();
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.store.dispatch(new ResetStore());
    }
    /**
     * Setup the internal data of the component.
     * Also builds the FinancialPeriodTabsModel to pass it to child component.
     */
    setupFinancialPeriodsViewModel(hasAccounting, hasFixedAssets, hasUkVat, hasUkTax, isFirm) {
        this.hasUkVat = hasUkVat;
        this.hasUkTax = hasUkTax;
        this.showFinancialPeriods = hasAccounting || hasFixedAssets || isFirm;
        // In case when the user has the Applications.UKVAT permission internal tabset should have the pills theming.
        // Default theming should be used in the opposite case.
        const tabsetType = hasUkVat ? TabsetTypes.Pills : TabsetTypes.Tabs;
        this.financialPeriodTabsModel = new FinancialPeriodTabsModel(tabsetType, hasAccounting, hasFixedAssets, isFirm);
    }
    /**
     * Initialize translations for bento-ng components (i.e. Wizard)
     */
    initBentoTranslations() {
        // we need to get the language from the cookie and call the translate service
        const language = this.cookie('BMLanguageCode');
        if (!/^(en|xx)-/.test(language)) {
            this.bentoTranslate.load(`assets/periods/bento-i18n/${language}.json`);
        }
    }
    /**
     * Sets isLoading value to true or false.
     * Its value determines wheter to show or hide the busy loader after fiscal year is added or updated.
     * @returns boolean
     */
    isLoading() {
        return this.isAddNewFiscalYearLoading || this.isUpdateFiscalYearLoading;
    }
    /**
     * set isVatTaxTab
     */
    setVatTax(bool) {
        this.newFiscalYearPeriodsService.setVatTax(bool);
    }
}
PeriodsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsComponent, deps: [{ token: BmppOwnerService }, { token: i2.Store }, { token: LocaleService }, { token: BmppFeatureResourcePermissionService }, { token: i5.BentoTranslate }, { token: NewFiscalYearPeriodsService }], target: i0.ɵɵFactoryTarget.Component });
PeriodsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: PeriodsComponent, selector: "bmpp-periods", inputs: { ownerId: "ownerId", showRelatedContacts: "showRelatedContacts", isFirmClient: "isFirmClient" }, ngImport: i0, template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"container-fluid\" [bentoBusyLoader]=\"!isInitilized || isLoading()\">\n\t<div class=\"row\" *ngIf=\"showRelatedContacts\">\n\t\t<div class=\"col-md-4 col-lg-2 pl-0 ml-1\">\n\t\t\t<bmpp-contact-dropdown></bmpp-contact-dropdown>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"isInitilized\">\n\t\t<div class=\"bento-tabset tabs-top w-100\" *ngIf=\"hasUkVat || hasUkTax\">\n\t\t\t<!-- If has UKVat || has UkTax -->\n\t\t\t<ul ngbNav #nav=\"ngbNav\" [activeId]=\"financialPeriodsTabId\" class=\"nav-tabs\">\n\t\t\t\t<li [ngbNavItem]=\"financialPeriodsTabId\" data-qe-id=\"bmpp-bmppApplicationTabs-financialPeriod-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(false)\" ngbNavLink>{{'bmpp.ng.tabs.financialPeriod.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<ng-container *ngIf=\"showFinancialPeriods; else fiscalYearsOnly\"\n\t\t\t\t\t\t\t><!-- If user has extended license -->\n\t\t\t\t\t\t\t<bmpp-financial-period-tabs [financialPeriodTabsModel]=\"financialPeriodTabsModel\"></bmpp-financial-period-tabs>\n\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t\t<li *ngIf=\"hasUkTax\" ngbNavItem data-qe-id=\"bmpp-bmppApplicationTabs-tax-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(true)\" ngbNavLink>{{'bmpp.ng.tabs.tax.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<div class=\"bmpp-tax-tab\">\n\t\t\t\t\t\t\t<uk-tax-periods [contactId]=\"selectedOwnerId || ownerId\"></uk-tax-periods>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t\t<li *ngIf=\"hasUkVat\" ngbNavItem data-qe-id=\"bmpp-bmppApplicationTabs-vat-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(true)\" ngbNavLink>{{'bmpp.ng.tabs.vat.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<div class=\"bmpp-vat-tab\">\n\t\t\t\t\t\t\t<uk-vat-periods-ng [contactId]=\"selectedOwnerId || ownerId\"></uk-vat-periods-ng>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<div [ngbNavOutlet]=\"nav\"></div>\n\t\t</div>\n\n\t\t<ng-container *ngIf=\"!hasUkVat && !hasUkTax\"\n\t\t\t><!-- If no UKVat && no UkTax -->\n\t\t\t<ng-container *ngIf=\"showFinancialPeriods; else fiscalYearsOnly\">\n\t\t\t\t<bmpp-financial-period-tabs [financialPeriodTabsModel]=\"financialPeriodTabsModel\"></bmpp-financial-period-tabs>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\n\t\t<ng-template #fiscalYearsOnly\n\t\t\t><!-- If user does not have any license -->\n\t\t\t<div class=\"col-md-6 col-sm-6 col-lg-4 pl-0 pt-2\">\n\t\t\t\t<bmpp-fiscal-year-list></bmpp-fiscal-year-list>\n\t\t\t</div>\n\t\t</ng-template>\n\t</div>\n</div>\n", styles: ["bmpp-financial-period-tabs{display:block;width:100%}bmpp-periods.ng-bento .bento-tabset ul.nav-tabs>li>a{text-transform:none!important}bmpp-periods.ng-bento ngb-tabset>div.tab-content{padding-left:0!important;padding-top:0!important}bmpp-periods.ng-bento .bento-tabset>.nav-pills{border-bottom:1px solid #afafaf!important;margin:0!important}bmpp-periods.ng-bento .bento-tabset.tabs-top>.nav-tabs{padding-top:1em!important}.bmpp-tax-tab th{font-size:12px!important}bmpp-periods.ng-bento .table thead>tr>th,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .table thead>tr>th{text-transform:none!important}bmpp-periods.ng-bento .bento-tabset>ul.nav-pills>li:before{content:none!important}bmpp-periods .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner{left:50%;position:fixed;top:50%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bento-sticky-footer{background:none;border-top:none;box-shadow:none;padding:0;position:relative;z-index:inherit}#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bento-sticky-footer{background:none;border-top:1px solid #f4f5f7;box-shadow:none;padding-top:20px;position:relative;z-index:inherit}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bento-sticky-bar bento-sticky-footer,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bento-sticky-bar bento-sticky-footer{background:#f4f5f7;border-top-color:#666;border-top-style:solid;border-top-width:1px;padding:10px 15px;pointer-events:all}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .tooltip.show,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .tooltip.show,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .tooltip.show{border:none;box-shadow:none}.bmpp-tax-tab,.bmpp-vat-tab{margin-top:15px}#bentoNGModalContainer.ng-bento .bmpp-add-edit-fiscal-year-modal .modal-content .modal-footer .btn,#bentoNGModalContainer.ng-bento .bmpp-set-current-period-modal .modal-content .modal-footer .btn,#bentoNGModalContainer.ng-bento .bmpp-confirmation-dialog .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .bmpp-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-edit-firm-periods-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog{height:100%;margin:0;padding:0;width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content{height:100%;margin:0;overflow:auto;padding:0;width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content .modal-header,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content .modal-header{background-color:#212121;color:#e9e9ec;display:block;padding:0}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bmpp-validation-message,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message i,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bmpp-validation-message i,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bmpp-validation-message i{float:left;font-size:15px;margin-right:6px}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content .modal-body,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content .modal-body{padding-left:22px;padding-right:22px}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-wizard .bento-wizard .bento-wizard-contents{padding-left:0}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding-left:0}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-sticky-footer .bento-wizard-sticky-footer-content{width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-sticky-footer .bento-wizard-sticky-footer-content .bento-wizard-cancel-button{float:right}bmpp-periods uk-tax-periods .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods uk-tax-periods .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods uk-vat-periods-ng .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner{position:inherit}#bentoNGModalContainer.ng-bento .bmpp-edit-fiscal-year-modal .modal-dialog .modal-content{width:550px!important}\n"], components: [{ type: i5.BentoAlertComponent, selector: "bento-alert", inputs: ["items", "inline", "grabFocus"], outputs: ["close"] }, { type: ContactDropdownComponent, selector: "bmpp-contact-dropdown" }, { type: FinancialPeriodTabsComponent, selector: "bmpp-financial-period-tabs", inputs: ["financialPeriodTabsModel"] }, { type: i9.UkTaxPeriodsComponent, selector: "uk-tax-periods", inputs: ["contactId"] }, { type: i1.UkVatPeriodsComponent, selector: "uk-vat-periods-ng", inputs: ["contactId", "noSync"] }, { type: i1$2.NgbNavOutlet, selector: "[ngbNavOutlet]", inputs: ["paneRole", "ngbNavOutlet"] }, { type: FiscalYearListComponent, selector: "bmpp-fiscal-year-list" }], directives: [{ type: i5.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbNav, selector: "[ngbNav]", inputs: ["activeId", "animation", "destroyOnHide", "orientation", "roles", "keyboard"], outputs: ["activeIdChange", "shown", "hidden", "navChange"], exportAs: ["ngbNav"] }, { type: i1$2.NgbNavItem, selector: "[ngbNavItem]", inputs: ["destroyOnHide", "disabled", "domId", "ngbNavItem"], outputs: ["shown", "hidden"], exportAs: ["ngbNavItem"] }, { type: i5.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbNavLink, selector: "a[ngbNavLink]" }, { type: i1$2.NgbNavContent, selector: "ng-template[ngbNavContent]" }], pipes: { "translate": i1$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-periods', encapsulation: ViewEncapsulation.None, template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"container-fluid\" [bentoBusyLoader]=\"!isInitilized || isLoading()\">\n\t<div class=\"row\" *ngIf=\"showRelatedContacts\">\n\t\t<div class=\"col-md-4 col-lg-2 pl-0 ml-1\">\n\t\t\t<bmpp-contact-dropdown></bmpp-contact-dropdown>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" *ngIf=\"isInitilized\">\n\t\t<div class=\"bento-tabset tabs-top w-100\" *ngIf=\"hasUkVat || hasUkTax\">\n\t\t\t<!-- If has UKVat || has UkTax -->\n\t\t\t<ul ngbNav #nav=\"ngbNav\" [activeId]=\"financialPeriodsTabId\" class=\"nav-tabs\">\n\t\t\t\t<li [ngbNavItem]=\"financialPeriodsTabId\" data-qe-id=\"bmpp-bmppApplicationTabs-financialPeriod-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(false)\" ngbNavLink>{{'bmpp.ng.tabs.financialPeriod.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<ng-container *ngIf=\"showFinancialPeriods; else fiscalYearsOnly\"\n\t\t\t\t\t\t\t><!-- If user has extended license -->\n\t\t\t\t\t\t\t<bmpp-financial-period-tabs [financialPeriodTabsModel]=\"financialPeriodTabsModel\"></bmpp-financial-period-tabs>\n\t\t\t\t\t\t</ng-container>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t\t<li *ngIf=\"hasUkTax\" ngbNavItem data-qe-id=\"bmpp-bmppApplicationTabs-tax-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(true)\" ngbNavLink>{{'bmpp.ng.tabs.tax.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<div class=\"bmpp-tax-tab\">\n\t\t\t\t\t\t\t<uk-tax-periods [contactId]=\"selectedOwnerId || ownerId\"></uk-tax-periods>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t\t<li *ngIf=\"hasUkVat\" ngbNavItem data-qe-id=\"bmpp-bmppApplicationTabs-vat-tab\">\n\t\t\t\t\t<a (click)=\"setVatTax(true)\" ngbNavLink>{{'bmpp.ng.tabs.vat.header' | translate}}</a>\n\t\t\t\t\t<ng-template ngbNavContent>\n\t\t\t\t\t\t<div class=\"bmpp-vat-tab\">\n\t\t\t\t\t\t\t<uk-vat-periods-ng [contactId]=\"selectedOwnerId || ownerId\"></uk-vat-periods-ng>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</ng-template>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<div [ngbNavOutlet]=\"nav\"></div>\n\t\t</div>\n\n\t\t<ng-container *ngIf=\"!hasUkVat && !hasUkTax\"\n\t\t\t><!-- If no UKVat && no UkTax -->\n\t\t\t<ng-container *ngIf=\"showFinancialPeriods; else fiscalYearsOnly\">\n\t\t\t\t<bmpp-financial-period-tabs [financialPeriodTabsModel]=\"financialPeriodTabsModel\"></bmpp-financial-period-tabs>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\n\t\t<ng-template #fiscalYearsOnly\n\t\t\t><!-- If user does not have any license -->\n\t\t\t<div class=\"col-md-6 col-sm-6 col-lg-4 pl-0 pt-2\">\n\t\t\t\t<bmpp-fiscal-year-list></bmpp-fiscal-year-list>\n\t\t\t</div>\n\t\t</ng-template>\n\t</div>\n</div>\n", styles: ["bmpp-financial-period-tabs{display:block;width:100%}bmpp-periods.ng-bento .bento-tabset ul.nav-tabs>li>a{text-transform:none!important}bmpp-periods.ng-bento ngb-tabset>div.tab-content{padding-left:0!important;padding-top:0!important}bmpp-periods.ng-bento .bento-tabset>.nav-pills{border-bottom:1px solid #afafaf!important;margin:0!important}bmpp-periods.ng-bento .bento-tabset.tabs-top>.nav-tabs{padding-top:1em!important}.bmpp-tax-tab th{font-size:12px!important}bmpp-periods.ng-bento .table thead>tr>th,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .table thead>tr>th{text-transform:none!important}bmpp-periods.ng-bento .bento-tabset>ul.nav-pills>li:before{content:none!important}bmpp-periods .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner{left:50%;position:fixed;top:50%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bento-sticky-footer{background:none;border-top:none;box-shadow:none;padding:0;position:relative;z-index:inherit}#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bento-sticky-footer{background:none;border-top:1px solid #f4f5f7;box-shadow:none;padding-top:20px;position:relative;z-index:inherit}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bento-sticky-bar bento-sticky-footer,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bento-sticky-bar bento-sticky-footer{background:#f4f5f7;border-top-color:#666;border-top-style:solid;border-top-width:1px;padding:10px 15px;pointer-events:all}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .tooltip.show,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .tooltip.show,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .tooltip.show{border:none;box-shadow:none}.bmpp-tax-tab,.bmpp-vat-tab{margin-top:15px}#bentoNGModalContainer.ng-bento .bmpp-add-edit-fiscal-year-modal .modal-content .modal-footer .btn,#bentoNGModalContainer.ng-bento .bmpp-set-current-period-modal .modal-content .modal-footer .btn,#bentoNGModalContainer.ng-bento .bmpp-confirmation-dialog .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .bmpp-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal ngb-datepicker .ngb-dp-day.hidden,#bentoNGModalContainer .bmpp-edit-firm-periods-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog{height:100%;margin:0;padding:0;width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content{height:100%;margin:0;overflow:auto;padding:0;width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content .modal-header,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content .modal-header{background-color:#212121;color:#e9e9ec;display:block;padding:0}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bmpp-validation-message,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message i,#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .bmpp-validation-message i,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .bmpp-validation-message i{float:left;font-size:15px;margin-right:6px}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal .modal-dialog .modal-content .modal-body,#bentoNGModalContainer .bmpp-edit-firm-periods-modal .modal-dialog .modal-content .modal-body{padding-left:22px;padding-right:22px}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-wizard .bento-wizard .bento-wizard-contents{padding-left:0}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding-left:0}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-sticky-footer .bento-wizard-sticky-footer-content{width:100%}#bentoNGModalContainer .bmpp-edit-accounting-periods-modal bento-sticky-footer .bento-wizard-sticky-footer-content .bento-wizard-cancel-button{float:right}bmpp-periods uk-tax-periods .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods uk-tax-periods .bento-busyloader-front-blocker .bento-busyloader-wrapper .bento-busyloader-inner,bmpp-periods uk-vat-periods-ng .bento-busyloader-blocker .bento-busyloader-wrapper .bento-busyloader-inner{position:inherit}#bentoNGModalContainer.ng-bento .bmpp-edit-fiscal-year-modal .modal-dialog .modal-content{width:550px!important}\n"] }]
        }], ctorParameters: function () { return [{ type: BmppOwnerService }, { type: i2.Store }, { type: LocaleService }, { type: BmppFeatureResourcePermissionService }, { type: i5.BentoTranslate }, { type: NewFiscalYearPeriodsService }]; }, propDecorators: { ownerId: [{
                type: Input
            }], showRelatedContacts: [{
                type: Input
            }], isFirmClient: [{
                type: Input
            }] } });

class BmppFiscalYearModalComponent {
    constructor(modalService, ownerService, store, localeService, bentoTranslate, frpService) {
        this.modalService = modalService;
        this.ownerService = ownerService;
        this.store = store;
        this.localeService = localeService;
        this.bentoTranslate = bentoTranslate;
        this.frpService = frpService;
        this.modalClose = new EventEmitter();
        this.modalCancel = new EventEmitter();
        this.newFiscalYearAdded = new EventEmitter();
        this.subscriptions = new Subscription();
        this.cookie = cookie;
        this.isInitilized = false;
    }
    ngOnInit() {
        this.ownerService.setOwnerId(this.ownerId);
        this.initBentoTranslations();
        this.loadInitialData();
    }
    // load permissions for the Add Fiscal Year Modal
    getAddFiscalYearFrpPermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.frpService.loadFrps(this.ownerId);
        });
    }
    // initialize services and build financial periods view model
    loadInitialData() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.localeService.loadCountryCodeAsync(),
                this.getAddFiscalYearFrpPermissions(),
                this.loadInitialFiscalYears(),
            ]);
            this.isInitilized = true;
            this.openFiscalYearModal();
        });
    }
    /**
     * Trigger loading of contacts and fiscal year or fiscal years only
     * and wait for loading completion
     */
    loadInitialFiscalYears() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.dispatch(new LoadContact({ contactId: this.ownerId }));
            return this.store
                .pipe(select(getFiscalYearsLoaded), first(loaded => loaded))
                .toPromise();
        });
    }
    /**
     * Initialize translations for bento-ng components (i.e. Wizard)
     */
    initBentoTranslations() {
        // we need to get the language from the cookie and call the translate service
        const language = this.cookie('BMLanguageCode');
        if (!/^(en|xx)-/.test(language)) {
            this.bentoTranslate.load(`assets/periods/bento-i18n/${language}.json`);
        }
    }
    // /** Open the Add Fiscal year modal */
    openFiscalYearModal() {
        const modalOptions = {
            container: '#bentoNGModalContainer',
            windowClass: 'bmpp-add-edit-fiscal-year-modal',
            ariaLabelledBy: 'modal-basic-title',
            keyboard: false,
            backdrop: 'static',
        };
        const modalRef = this.modalService.open(AddEditFiscalYearComponent, modalOptions);
        modalRef.componentInstance.dataQeIdNamespace = this.qeIdPrefix;
        // this will be always PeriodType Accounting for this modal
        modalRef.componentInstance.periodType = PeriodType.Accounting;
        modalRef.componentInstance.fiscalYearAdded.subscribe(fiscalYear => {
            this.newFiscalYearAdded.emit(fiscalYear);
        });
        modalRef.result.then(
        // Add handler for close click
        () => {
            this.modalClose.emit();
        }, 
        // Add handler for onCancelClick
        () => {
            this.modalCancel.emit();
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.store.dispatch(new ResetStore());
    }
}
BmppFiscalYearModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppFiscalYearModalComponent, deps: [{ token: i1$2.NgbModal }, { token: BmppOwnerService }, { token: i2.Store }, { token: LocaleService }, { token: i5.BentoTranslate }, { token: BmppFeatureResourcePermissionService }], target: i0.ɵɵFactoryTarget.Component });
BmppFiscalYearModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: BmppFiscalYearModalComponent, selector: "bmpp-fiscal-year-modal", inputs: { qeIdPrefix: "qeIdPrefix", ownerId: "ownerId" }, outputs: { modalClose: "modalClose", modalCancel: "modalCancel", newFiscalYearAdded: "newFiscalYearAdded" }, ngImport: i0, template: "<div class=\"container-fluid\" *ngIf=\"!isInitilized\"></div>\n", styles: ["#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .tooltip.show{border:none;box-shadow:none}#bentoNGModalContainer.ng-bento .bmpp-add-edit-fiscal-year-modal .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message i{float:left;font-size:15px;margin-right:6px}\n"], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BmppFiscalYearModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bmpp-fiscal-year-modal', encapsulation: ViewEncapsulation.None, template: "<div class=\"container-fluid\" *ngIf=\"!isInitilized\"></div>\n", styles: ["#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .tooltip.show{border:none;box-shadow:none}#bentoNGModalContainer.ng-bento .bmpp-add-edit-fiscal-year-modal .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .bmpp-add-edit-fiscal-year-modal .bmpp-validation-message i{float:left;font-size:15px;margin-right:6px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: BmppOwnerService }, { type: i2.Store }, { type: LocaleService }, { type: i5.BentoTranslate }, { type: BmppFeatureResourcePermissionService }]; }, propDecorators: { qeIdPrefix: [{
                type: Input
            }], ownerId: [{
                type: Input
            }], modalClose: [{
                type: Output
            }], modalCancel: [{
                type: Output
            }], newFiscalYearAdded: [{
                type: Output
            }] } });

class ContactsEffects {
    constructor(actions$, contactsService, ownerService) {
        this.actions$ = actions$;
        this.contactsService = contactsService;
        this.ownerService = ownerService;
        this.session = session;
        this.loadRelatedContacts$ = createEffect(() => this.actions$.pipe(ofType(ContactsActionTypes.LoadContacts), switchMap(action => {
            const companyId$ = from(this.session.getCompanyId());
            return companyId$.pipe(map(companyId => ({ action, companyId })));
        }), concatMap(({ action, companyId }) => this.contactsService.getRelatedContacts(companyId, action.payload.contactId).pipe(switchMap(data => {
            const ownerId = this.ownerService.getOwnerId();
            const contact = data.find((item) => item.id === ownerId);
            return [new LoadContactsSuccess({ data }), new SetSelectedContact({ contact })];
        }), catchError(error => of(new LoadContactsFailure({ error })))))));
        this.loadContact$ = createEffect(() => this.actions$.pipe(ofType(ContactsActionTypes.LoadContact), switchMap(action => {
            const companyId$ = from(this.session.getCompanyId());
            return companyId$.pipe(map(companyId => ({ action, companyId })));
        }), concatMap(({ action, companyId }) => this.contactsService.getContact(companyId, action.payload.contactId).pipe(switchMap(data => {
            return [new LoadContactSuccess({ data }), new SetSelectedContact({ contact: data })];
        }), catchError(error => of(new LoadContactFailure({ error })))))));
        this.setSelectedContact$ = createEffect(() => this.actions$.pipe(ofType(ContactsActionTypes.SetSelectedContact), concatMap(action => of(new LoadFiscalYears({ ownerId: action.payload.contact.id })))));
    }
}
ContactsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ContactsEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.ContactsService }, { token: BmppOwnerService }], target: i0.ɵɵFactoryTarget.Injectable });
ContactsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ContactsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ContactsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.ContactsService }, { type: BmppOwnerService }]; } });

class FiscalYearEffects {
    constructor(actions$, fiscalYearService, dateHelperService, fiscalYearStore, periodFrequencyService, translateService, accountService) {
        this.actions$ = actions$;
        this.fiscalYearService = fiscalYearService;
        this.dateHelperService = dateHelperService;
        this.fiscalYearStore = fiscalYearStore;
        this.periodFrequencyService = periodFrequencyService;
        this.translateService = translateService;
        this.accountService = accountService;
        this.loadFiscalYears$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.LoadFiscalYears), concatMap(action => this.fiscalYearService.get(action.payload.ownerId, true).pipe(
        /**
         * The next `map` section was added as a fix for model and real `fiscalYearService.get` ouput inconsistency
         * fiscalYearService.get declares that it returns \{FiscalYear\} with \{Date\} .startDate and \{Date\} .endDate
         * in fact fiscalYearService.get returs \{FiscalYear\} with \{string\} .startDate and \{string\} .endDate
         * the same thing with \{FiscalYear\} .periods
         */
        map(data => {
            /**
             * Transforms `startDate` and `endDate` fields in object to \{Date\}
             * @param obj - FiscalYear or Period item
             */
            const transformDates = (obj) => (Object.assign(Object.assign({}, obj), { startDate: obj.startDate && new Date(obj.startDate), endDate: obj.endDate && new Date(obj.endDate) }));
            return data.map(fiscalYear => (Object.assign(Object.assign({}, transformDates(fiscalYear)), { periods: (fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) && fiscalYear.periods.map(transformDates) })));
        }), switchMap((data) => {
            // calculate fiscal years start date
            const yearsWithStartDate = data.map(y => (Object.assign(Object.assign({}, y), { startDate: y.periods.reduce((prev, cur) => (prev.sequenceNumber < cur.sequenceNumber ? prev : cur)).startDate })));
            // sort fiscal years by sequence number
            const sortedYears = yearsWithStartDate.sort((y1, y2) => y1.sequenceNumber - y2.sequenceNumber);
            return [
                new LoadFiscalYearsSuccess({ data: sortedYears }),
                new GetTransactionCount({ ownerId: action.payload.ownerId }),
            ];
        }), catchError(error => of(new LoadFiscalYearsFailure({ error })))))));
        this.fetchFiscalYears$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearSuccess, FiscalYearActionTypes.AddNewFiscalYearSuccess, FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeSuccess, FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess), concatMap(action => this.fiscalYearService.get(action.payload.fiscalYear.ownerId, true).pipe(map((data) => data.map(fiscalYear => this.convertFiscalYearStringDates(fiscalYear))), map((data) => {
            // calculate fiscal years start date
            const yearsWithStartDate = data.map(fiscalYear => this.addFiscalYearStartDate(fiscalYear));
            // sort fiscal years by sequence number
            const sortedYears = yearsWithStartDate.sort((y1, y2) => y1.sequenceNumber - y2.sequenceNumber);
            return sortedYears;
        }), switchMap((data) => {
            const fiscalYear = data.find(e => e.id === action.payload.fiscalYear.id);
            return [new LoadFiscalYearsSuccess({ data }), new SetSelectedFiscalYear({ fiscalYear })];
        }), catchError(error => of(new LoadFiscalYearsFailure({ error })))))));
        this.setCurrentPeriodType$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.SetCurrentPeriodType), concatMap(action => of(action).pipe(withLatestFrom(this.fiscalYearStore.select(getFiscalYears), this.fiscalYearStore.select(getCurrentFiscalYear(action.payload.periodType))))), map(([_action, fiscalYears, currentFiscalYear]) => {
            const fiscalYear = currentFiscalYear !== null && currentFiscalYear !== void 0 ? currentFiscalYear : fiscalYears[0];
            return new SetSelectedFiscalYear({ fiscalYear });
        })));
        this.addSuccessAlert$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.AddNewFiscalYearSuccess, FiscalYearActionTypes.UpdateFiscalYearSuccess, FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeSuccess, FiscalYearActionTypes.UpdateFiscalYearPeriodsSuccess, FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess), concatMap(action => {
            let alertMessage;
            switch (action.type) {
                case FiscalYearActionTypes.AddNewFiscalYearSuccess:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.saved', {
                        endDate: action.payload.newFiscalYearEndDate,
                    });
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearSuccess:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.update', {
                        endDate: action.payload.updatedFiscalYearEndDate,
                    });
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeSuccess:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.periodFrequency.firm.update');
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearPeriodsSuccess: {
                    const { currentPeriodEndDate, periodNumber } = action.payload.fiscalYearCurrentPeriod;
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.periods.update', {
                        currentPeriodEndDate,
                        periodNumber,
                    });
                    break;
                }
                case FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.mappedPeriods.update.success');
                    break;
                default:
                    break;
            }
            const successAlert = {
                type: AlertItemOptionsTypes.success,
                msg: alertMessage,
                closeable: true,
                timeout: DEFAULT_TIMEOUT_FOR_SUCCESS_ALERT,
            };
            return of(new AddAlert({ alert: successAlert }));
        })));
        this.addSuccessAlertAfterMultipleFiscalYearUpdate$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateMultipleFiscalYearSuccess), concatMap(action => {
            let alertMessage;
            switch (action.type) {
                case FiscalYearActionTypes.UpdateMultipleFiscalYearSuccess:
                    alertMessage = this.translateService.instant('bmpp.fiscal.years.save.success');
                    break;
                default:
                    break;
            }
            const successAlert = {
                type: AlertItemOptionsTypes.success,
                msg: alertMessage,
                closeable: true,
                timeout: DEFAULT_TIMEOUT_FOR_SUCCESS_ALERT,
            };
            return of(new AddAlert({ alert: successAlert }));
        })));
        this.addDangerAlert$ = createEffect(() => this.actions$.pipe(ofType(...[
            FiscalYearActionTypes.AddNewFiscalYearFailure,
            FiscalYearActionTypes.UpdateFiscalYearFailure,
            FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeFailure,
            FiscalYearActionTypes.UpdateFiscalYearPeriodsFailure,
            FiscalYearActionTypes.UpdateFiscalYearPeriodsYearEndCloseFailure,
            FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsFailure,
            FiscalYearActionTypes.UpdateMultipleFiscalYearFailure,
        ]), switchMap(action => {
            let alertMessage;
            switch (action.type) {
                case FiscalYearActionTypes.AddNewFiscalYearFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.failedToSave');
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.failedToSave');
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearFrequencyTypeFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.periodFrequency.firm.failedToUpdate');
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearPeriodsFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.periods.update.failure');
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearPeriodsYearEndCloseFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.periods.update.yearEndClose.failure', {
                        currentPeriodEndDate: action.payload.currentPeriodEndDate,
                    });
                    break;
                case FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsFailure:
                    alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.mappedPeriods.update.failure');
                    break;
                case FiscalYearActionTypes.UpdateMultipleFiscalYearFailure:
                    alertMessage = this.translateService.instant('bmpp.fiscal.years.save.failed');
                    break;
                default:
                    break;
            }
            const dangerAlert = {
                type: AlertItemOptionsTypes.danger,
                msg: alertMessage,
                closeable: true,
            };
            return of(new AddAlert({ alert: dangerAlert }));
        })));
        this.addInProgressAlert$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearMappedPeriods), switchMap(() => {
            const alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.mappedPeriods.update.inProgress');
            const inProgressAlert = {
                type: AlertItemOptionsTypes.info,
                msg: alertMessage,
                closeable: true,
            };
            return of(new AddAlert({ alert: inProgressAlert }));
        })));
        this.removeInProgressAlert$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsSuccess, FiscalYearActionTypes.UpdateFiscalYearMappedPeriodsFailure), switchMap(() => {
            const alertMessage = this.translateService.instant('bmpp.ng.fiscal.year.mappedPeriods.update.inProgress');
            const inProgressAlert = {
                type: AlertItemOptionsTypes.info,
                msg: alertMessage,
                closeable: true,
            };
            return of(new RemoveAlert({ alert: inProgressAlert }));
        })));
        this.addNewFiscalYear$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.AddNewFiscalYear), concatMap(action => {
            const fiscalYearWithLocaleDates = this.convertFiscalYearDates(action.payload.fiscalYear);
            return this.fiscalYearService.add(action.payload.ownerId, fiscalYearWithLocaleDates).pipe(map((fiscalYear) => this.convertFiscalYearStringDates(fiscalYear)), map((fiscalYear) => this.addFiscalYearStartDate(fiscalYear)), switchMap((fiscalYear) => {
                const newFiscalYearEndDate = this.dateHelperService.getFormattedDate(fiscalYear.endDate);
                return [new AddNewFiscalYearSuccess({ fiscalYear, newFiscalYearEndDate }), new ResetEditedFiscalYear()];
            }), catchError(error => {
                return of(new AddNewFiscalYearFailure({ error }), new ResetEditedFiscalYear());
            }));
        })));
        this.updateFiscalYear$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYear), concatMap(action => {
            const fiscalYearWithUpdatedPeriods = this.periodFrequencyService.updateFiscalYearPeriods(action.payload.fiscalYear);
            const fiscalYearWithLocaleDates = this.convertFiscalYearDates(fiscalYearWithUpdatedPeriods);
            return this.fiscalYearService.updatePeriods(action.payload.ownerId, fiscalYearWithLocaleDates).pipe(map((fiscalYear) => this.convertFiscalYearStringDates(fiscalYear)), map((fiscalYear) => this.addFiscalYearStartDate(fiscalYear)), switchMap((fiscalYear) => {
                const updatedFiscalYearEndDate = this.dateHelperService.getFormattedDate(fiscalYear.endDate);
                return [new UpdateFiscalYearSuccess({ fiscalYear, updatedFiscalYearEndDate }), new ResetEditedFiscalYear()];
            }), catchError(error => {
                return of(new UpdateFiscalYearFailure({ error }), new ResetEditedFiscalYear());
            }));
        })));
        this.updateCurrentPeriod$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearPeriods), withLatestFrom(this.fiscalYearStore.select(getUpdatedFiscalYear)), mergeMap(([action, updatedFiscalYear]) => {
            const fiscalYearWithLocaleDates = this.convertFiscalYearDates(updatedFiscalYear);
            return this.fiscalYearService
                .update(action.payload.ownerId, fiscalYearWithLocaleDates, action.payload.yearEndCloseSetting)
                .pipe(switchMap((fiscalYear) => {
                const currentPeriod = this.getCurrentPeriodByPeriodType(fiscalYear, action.payload.selectedPeriod.periodType);
                const currentPeriodEndDate = this.dateHelperService.getFormattedDate(currentPeriod.endDate);
                const periodNumber = currentPeriod.sequenceNumber;
                return [
                    new UpdateFiscalYearPeriodsSuccess({
                        fiscalYear,
                        fiscalYearCurrentPeriod: { currentPeriodEndDate, periodNumber },
                    }),
                    new LoadFiscalYears({ ownerId: action.payload.ownerId }),
                ];
            }), catchError(error => {
                const currentPeriod = this.getCurrentPeriodByPeriodType(updatedFiscalYear, action.payload.selectedPeriod.periodType);
                if (action.payload.yearEndCloseSetting && currentPeriod !== undefined) {
                    const currentPeriodEndDate = this.dateHelperService.getFormattedDate(currentPeriod.endDate);
                    return [
                        new UpdateFiscalYearPeriodsYearEndCloseFailure({ error, currentPeriodEndDate }),
                        new UpdateFiscalYearPeriodsFailure({ error }),
                    ];
                }
                return of(new UpdateFiscalYearPeriodsFailure({ error }));
            }));
        })));
        this.updateFiscalYearFrequencyType$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearFrequencyType), withLatestFrom(this.fiscalYearStore.select(getSelectedFiscalYear), this.fiscalYearStore.select(getPeriodType), this.fiscalYearStore.pipe(select(getNewPeriodList), filter(periods => periods !== undefined && periods.length > 0)), this.fiscalYearStore.select(getSelectedPeriodsFrequency)), concatMap(([_, selectedFiscalYear, periodType, immutableEditedPeriods, periodFrequency]) => {
            const editedPeriods = immutableEditedPeriods.map(period => Object.assign(Object.assign({}, period)));
            const untouchedPeriods = selectedFiscalYear.periods.filter(period => period.periodType !== periodType);
            // set deleted previous periods
            const deletedPeriods = selectedFiscalYear.periods
                .filter(period => period.periodType === periodType)
                .map(period => (period = Object.assign(Object.assign({}, period), { isDeleted: true })));
            this.periodFrequencyService.mapCurrentPeriod(selectedFiscalYear.periods, editedPeriods, periodType);
            const updatedFiscalYear = Object.assign(Object.assign({}, selectedFiscalYear), { frequencyType: periodFrequency.frequencyType, periods: [...untouchedPeriods, ...deletedPeriods, ...editedPeriods] });
            const fiscalYearWithLocaleDates = this.convertFiscalYearDates(updatedFiscalYear);
            return this.fiscalYearService.update(selectedFiscalYear.ownerId, fiscalYearWithLocaleDates).pipe(map((fiscalYear) => this.convertFiscalYearStringDates(fiscalYear)), map((fiscalYear) => this.addFiscalYearStartDate(fiscalYear)), switchMap((fiscalYear) => {
                return [new UpdateFiscalYearFrequencyTypeSuccess({ fiscalYear }), new ResetEditedFiscalYear()];
            }), catchError(error => {
                return of(new UpdateFiscalYearFrequencyTypeFailure({ error }), new ResetEditedFiscalYear());
            }));
        })));
        this.updateFiscalYearMappedPeriods$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateFiscalYearMappedPeriods), withLatestFrom(this.fiscalYearStore.select(getSelectedFiscalYear)), concatMap(([action, selectedFiscalYear]) => {
            var _a;
            const untouchedPeriods = (_a = selectedFiscalYear === null || selectedFiscalYear === void 0 ? void 0 : selectedFiscalYear.periods) === null || _a === void 0 ? void 0 : _a.filter(period => period.periodType !== action.payload.periodType);
            const fiscalYearToUpdate = this.convertFiscalYearDates(Object.assign(Object.assign({}, selectedFiscalYear), { periods: [...action.payload.mappedPeriods, ...untouchedPeriods] }));
            return this.fiscalYearService.updatePeriods(selectedFiscalYear.ownerId, fiscalYearToUpdate).pipe(map((updatedFiscalYear) => this.convertFiscalYearStringDates(updatedFiscalYear)), map((updatedFiscalYear) => this.addFiscalYearStartDate(updatedFiscalYear)), switchMap((updatedFiscalYear) => {
                return [new UpdateFiscalYearMappedPeriodsSuccess({ fiscalYear: updatedFiscalYear })];
            }), catchError(error => {
                return of(new UpdateFiscalYearMappedPeriodsFailure({ error }));
            }));
        })));
        this.getAccountActivity$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.LoadAccountActivity), concatMap(action => this.accountService.getAccountActivity(action.payload.ownerId).pipe(map(data => {
            return new LoadAccountActivitySuccess({ data });
        }), catchError(error => {
            return of(new LoadAccountActivityFailure({ error }));
        })))));
        // this effect is called when the multiple fiscal year saving is successful
        // we need to update the respective periods for all the fiscal years.
        this.fetchFiscalYearsAfterMultipleFiscalYearUpdate$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateMultipleFiscalYearSuccess), withLatestFrom(this.fiscalYearStore.select(getSelectedFiscalYear)), concatMap(([action, selectedFiscalYear]) => this.fiscalYearService.get(action.payload.ownerId, true).pipe(map((data) => data.map(fiscalYear => this.convertFiscalYearStringDates(fiscalYear))), map((data) => {
            // calculate fiscal years start date
            const yearsWithStartDate = data.map(fiscalYear => this.addFiscalYearStartDate(fiscalYear));
            // sort fiscal years by sequence number
            const sortedYears = yearsWithStartDate.sort((y1, y2) => y1.sequenceNumber - y2.sequenceNumber);
            return sortedYears;
        }), switchMap((data) => {
            const fiscalYear = data.find(e => e.id === selectedFiscalYear.id);
            return [new LoadFiscalYearsSuccess({ data }), new SetSelectedFiscalYear({ fiscalYear })];
        }), catchError(error => of(new LoadFiscalYearsFailure({ error })))))));
        // this effect is for updating the multiple fiscal years
        this.updateMultipleFiscalYear$ = createEffect(() => this.actions$.pipe(ofType(FiscalYearActionTypes.UpdateMultipleFiscalYear), withLatestFrom(this.fiscalYearStore.select(getFiscalYears)), concatMap(([action, existingFiscalYears]) => {
            let fiscalYearsToUpdate = JSON.parse(JSON.stringify(existingFiscalYears));
            if (action.payload.accountActivity) {
                const maxSequenceNumber = Math.max(...fiscalYearsToUpdate.map(year => year.sequenceNumber));
                fiscalYearsToUpdate = fiscalYearsToUpdate.filter(year => year.sequenceNumber === 1 || year.sequenceNumber === maxSequenceNumber);
            }
            fiscalYearsToUpdate.forEach(function (fiscalYear) {
                const updatedFiscalYear = action.payload.fiscalYearsGridData.find(year => year.id === fiscalYear.id);
                fiscalYear.startDate = new Date(updatedFiscalYear.startDate);
                fiscalYear.endDate = new Date(updatedFiscalYear.endDate);
                fiscalYear.taxCodeYear = updatedFiscalYear.taxYear;
            });
            // update the periods
            const fiscalYearWithUpdatedPeriods = this.periodFrequencyService.updateMultipleFiscalYearPeriods(fiscalYearsToUpdate);
            // conver the datea
            const fiscalYearWithLocaleDates = fiscalYearWithUpdatedPeriods.map(fiscalYear => this.convertFiscalYearDates(fiscalYear));
            return this.fiscalYearService.updateMultipleFiscalYears(action.payload.ownerId, fiscalYearWithLocaleDates).pipe(switchMap(() => {
                // this will call the effect that updates the corresponding periods and will reload the fiscal year for the gird
                return [new UpdateMultipleFiscalYearSuccess({ ownerId: action.payload.ownerId })];
            }), catchError(error => {
                return of(new UpdateMultipleFiscalYearFailure({ error }));
            }));
        })));
    }
    /**
     * Defines fiscal year start date based on first period start date
     * @param fiscalYear - fiscal year without start date
     */
    addFiscalYearStartDate(fiscalYear) {
        var _a;
        return Object.assign(Object.assign({}, fiscalYear), { startDate: (_a = fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.reduce((prev, cur) => (prev.sequenceNumber < cur.sequenceNumber ? prev : cur)).startDate });
    }
    /**
     * Converts obj with Start and End dates from string to Date obj.
     * We retrieve date fields as strings, then we convert it to date obj
     * @param fiscalYear - fiscal year without start date
     */
    convertStringToDate(obj) {
        return Object.assign(Object.assign({}, obj), { startDate: obj.startDate && new Date(obj.startDate), endDate: obj.endDate && new Date(obj.endDate) });
    }
    /**
     * Converts fiscal year dates
     * @param fiscalYear - fiscal year
     */
    convertFiscalYearStringDates(fiscalYear) {
        var _a;
        return Object.assign(Object.assign({}, this.convertStringToDate(fiscalYear)), { periods: (_a = fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.map(this.convertStringToDate) });
    }
    /**
     * Get the current period of a fiscal year
     * @param fiscalYear - fiscal year
     * @param periodType - period type
     */
    getCurrentPeriodByPeriodType(fiscalYear, periodType) {
        return fiscalYear.periods.find(p => p.isCurrentPeriod && p.periodType === periodType);
    }
    /**
     * Converts fiscal year dates
     * @param fiscalYear - fiscal year
     */
    convertFiscalYearDates(fiscalYear) {
        var _a;
        return Object.assign(Object.assign({}, this.formatDateForDto(fiscalYear)), { periods: (_a = fiscalYear === null || fiscalYear === void 0 ? void 0 : fiscalYear.periods) === null || _a === void 0 ? void 0 : _a.map(period => this.formatDateForDto(period)) });
    }
    /**
     * Converts obj with Start and End dates to YYYY-MM-dd format.
     * It keeps the same date values for one format when parsing to JSON
     * @param obj - object with Start and End dates
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatDateForDto(obj) {
        return Object.assign(Object.assign({}, obj), { startDate: (obj === null || obj === void 0 ? void 0 : obj.startDate) && this.getISOFormattedDateString(obj === null || obj === void 0 ? void 0 : obj.startDate), endDate: (obj === null || obj === void 0 ? void 0 : obj.endDate) && this.getISOFormattedDateString(obj === null || obj === void 0 ? void 0 : obj.endDate) });
    }
    /**
     * get the ISO date string date string for the given date string or date
     * @param date - the date to format the iso date format
     * @returns formatted date string
     */
    getISOFormattedDateString(date) {
        // format the date to iso format
        const formattedDate = formatISO(date);
        // get the date from the utc date format, to remove timezone difference and prevent change date on the server
        const utcDate = formattedDate.split('T');
        return utcDate[0];
    }
}
FiscalYearEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.FiscalYearService }, { token: BmppDateHelperService }, { token: i2.Store }, { token: PeriodFrequencyService }, { token: i1$1.TranslateService }, { token: i2$1.AccountService }], target: i0.ɵɵFactoryTarget.Injectable });
FiscalYearEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FiscalYearEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.FiscalYearService }, { type: BmppDateHelperService }, { type: i2.Store }, { type: PeriodFrequencyService }, { type: i1$1.TranslateService }, { type: i2$1.AccountService }]; } });

class TransactionEffects {
    constructor(actions$, transactionService) {
        this.actions$ = actions$;
        this.transactionService = transactionService;
        this.getTransactionCount$ = createEffect(() => this.actions$.pipe(ofType(TransactionActionTypes.GetTransactionCount), concatMap(action => this.transactionService.getTransactionCount(action.payload.ownerId).pipe(switchMap(data => {
            return [new GetTransactionCountSuccess({ data })];
        }), catchError(error => of(new GetTransactionCountFailure({ error })))))));
    }
}
TransactionEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TransactionEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.TransactionService }], target: i0.ɵɵFactoryTarget.Injectable });
TransactionEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TransactionEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TransactionEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.TransactionService }]; } });

class CompanyEffects {
    constructor(actions$, companyService) {
        this.actions$ = actions$;
        this.companyService = companyService;
        this.loadCompanyClient$ = createEffect(() => this.actions$.pipe(ofType(CompanyActionTypes.LoadCompanyClient), concatMap(() => from(getCompanyId())), concatMap(companyId => this.companyService.getCompanyClient(companyId).pipe(switchMap(data => of(new LoadCompanyClientSuccess({ data }))), catchError(error => of(new LoadCompanyClientFailure({ error })))))));
    }
}
CompanyEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CompanyEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.CompanyService }], target: i0.ɵɵFactoryTarget.Injectable });
CompanyEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CompanyEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CompanyEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.CompanyService }]; } });

const PERIOD_END_DATE_OVERLAP_MSG = 'bmpp.ng.periods.edit.wizard.step1.periodOverlapMsg';
const PERIOD_WITHIN_FISCAL_YEAR_MSG = 'bmpp.ng.periods.edit.wizard.step1.periodWithinYearMsg';
const NUMBER_OF_PERIODS_EXCEEDED_MSG = 'bmpp.ng.periods.edit.wizard.step1.numberOfPeriodsExceededMsg';
const NUMBER_OF_PERIODS_REQUIRED_MSG = 'bmpp.ng.periods.edit.wizard.step1.numberOfPeriodsRequiredMsg';

class EditPeriodsEffects {
    constructor(actions$, store, periodFrequencyService) {
        this.actions$ = actions$;
        this.store = store;
        this.periodFrequencyService = periodFrequencyService;
        /**
         * Extracts the period type from the action payload.
         * Based on the period type, selects the periods' frequency and periods to edit.
         * Triggers the `LoadEditPeriodsStateSuccess` action with period type, periods frequency, and periods to edit.
         * If periods' frequency is the custom one, periods length will be used as custom periods number.
         * Otherwise, the `undefined` is passed.
         */
        this.loadEditPeriodsState$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.LoadEditPeriodsState), map(action => action.payload.periodType), mergeMap(periodType => of(periodType).pipe(withLatestFrom(this.store.select(getFiscalYearPeriodFrequency(periodType)), this.store.select(getPeriodList(periodType))))), concatMap(([periodType, periodsFrequency, periods]) => {
            const isCustomPeriodsFrequency = periodsFrequency.frequencyType === FrequencyType.Custom;
            return of(new LoadEditPeriodsStateSuccess({
                periodType,
                periodsFrequency,
                customPeriodsNumber: isCustomPeriodsFrequency ? periods === null || periods === void 0 ? void 0 : periods.length : undefined,
                periods,
            }));
        })));
        /**
         * Extracts custom periods number from the action payload.
         * Selects the `selectedFiscalYear` property from fiscal-year store.
         * Triggers the `ValidateCustomPeriodsNumber` action with custom periods number and selected fiscal year.
         */
        this.setCustomPeriodsNumber$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.SetCustomPeriodsNumber), map(action => action.payload.customPeriodsNumber), withLatestFrom(this.store.select(getSelectedFiscalYear)), concatMap(([customPeriodsNumber, fiscalYear]) => of(new ValidateCustomPeriodsNumber({ customPeriodsNumber, fiscalYear, calculateNewPeriods: true })))));
        /**
         * Validates the provided custom periods number based on the selected fiscal year data.
         * If custom periods number exceeds the count of the days in the fiscal year or number is not provided,
         * triggers the `CustomPeriodsNumberValidationFailure` with a proper error message.
         * Otherwise if `calculateNePeriods` flag is true,
         * triggers the `CustomPeriodsNumberValidationSuccess` and `CalculatePeriodsList` actions.
         * If flag set to false triggers only `CustomPeriodsNumberValidationSuccess`.
         * It is done in such a way because of the https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2590311 requirements.
         */
        this.validateCustomPeriodsNumber$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.ValidateCustomPeriodsNumber), concatMap(action => {
            const numberOfPeriods = action.payload.customPeriodsNumber;
            // number of periods is required
            if (!numberOfPeriods) {
                return of(new CustomPeriodsNumberValidationFailure({ errorMessage: NUMBER_OF_PERIODS_REQUIRED_MSG }));
            }
            const fiscalYear = action.payload.fiscalYear;
            const daysInInterval = differenceInDays(fiscalYear.endDate, fiscalYear.startDate);
            // number of periods within fiscal year days
            if (daysInInterval < numberOfPeriods) {
                return of(new CustomPeriodsNumberValidationFailure({ errorMessage: NUMBER_OF_PERIODS_EXCEEDED_MSG }));
            }
            return action.payload.calculateNewPeriods
                ? of(new CustomPeriodsNumberValidationSuccess(), new CalculatePeriodsList())
                : of(new CustomPeriodsNumberValidationSuccess());
        })));
        /**
         * Triggers the `CalculatePeriodsList` action.
         */
        this.setSelectedPeriodsFrequency$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.SetSelectedPeriodsFrequency), concatMap(_ => of(new CalculatePeriodsList()))));
        /**
         * Applicable only if we are in the mapping mode.
         * Selects the edit periods state and selected fiscal year.
         * Based on the period type, frequency type and custom periods number,
         * calculates the periods list.
         * Also, assigns mappingId to newly created periods using sequence number.
         * Triggers the `SetNewPeriodList` action with the calculated periods list.
         */
        this.calculatePeriodsList$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.CalculatePeriodsList), withLatestFrom(this.store.select(getIsMappingMode), this.store.select(getEditPeriodsState), this.store.select(getSelectedFiscalYear)), filter(([_, isMapping, editPeriodsState, fiscalYear]) => isMapping &&
            editPeriodsState.periodType !== undefined &&
            editPeriodsState.selectedPeriodsFrequency !== undefined &&
            fiscalYear !== undefined), concatMap(([_, __, editPeriodsState, fiscalYear]) => {
            const createPeriodListModel = {
                frequencyType: editPeriodsState.selectedPeriodsFrequency.frequencyType,
                yearBeginDate: fiscalYear.startDate,
                yearEndDate: fiscalYear.endDate,
                numberOfPeriods: editPeriodsState.customPeriodsNumber,
                periodType: editPeriodsState.periodType,
            };
            const periods = this.periodFrequencyService
                .createPeriodList(createPeriodListModel)
                .map(period => (Object.assign(Object.assign({}, period), { mappingId: period.sequenceNumber })));
            return of(new SetNewPeriodList({ periods }));
        })));
        /**
         * Selects the selected fiscal year.
         * Triggers the `ValidatePeriodDate` with the periods new end date, period's number and selected fiscal year.
         */
        this.updatePeriodDate$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.UpdatePeriodDate), withLatestFrom(this.store.select(getSelectedFiscalYear)), concatMap(([action, fiscalYear]) => of(new ValidatePeriodDate({
            periodNewEndDate: action.payload.periodNewEndDate,
            periodSequenceNumber: action.payload.periodSequenceNumber,
            fiscalYear,
        })))));
        /**
         * Selects the edit periods list.
         * Based on the fiscal year, period's new end date and period's sequence number validates the new end date.
         * If the new period's end date bigger than next period's end date or less than previous period's end date
         * or it is out of the fiscal year dates boundaries, triggers the `ValidatePeriodDateFailure`
         * with the period's sequence number and the proper error message.
         * Otherwise triggers the `ValidatePeriodDateSuccess` and `UpdatePeriodsDates` actions.
         */
        this.validatePeriodDate$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.ValidatePeriodDate), withLatestFrom(this.store.select(getCurrentPeriodList)), concatMap(([action, periods]) => {
            const fiscalYear = action.payload.fiscalYear;
            const currentPeriodEndDate = action.payload.periodNewEndDate;
            const currentPeriodSequenceNumber = action.payload.periodSequenceNumber;
            // period end date within the fiscal year interval
            if (currentPeriodEndDate > fiscalYear.endDate || currentPeriodEndDate <= fiscalYear.startDate) {
                return of(new ValidatePeriodDateFailure({
                    validationResult: {
                        sequenceNumber: currentPeriodSequenceNumber,
                        validationMessage: PERIOD_WITHIN_FISCAL_YEAR_MSG,
                    },
                }));
            }
            const previousPeriodSequenceNumber = currentPeriodSequenceNumber - 1;
            const nextPeriodSequenceNumber = currentPeriodSequenceNumber + 1;
            const isDateOverlaps = periods
                // Take the previous and next periods.
                .filter(period => period.sequenceNumber === previousPeriodSequenceNumber || period.sequenceNumber === nextPeriodSequenceNumber)
                // Check if the current period's end date overlaps with any of those.
                .some(period => (period.sequenceNumber === previousPeriodSequenceNumber && period.endDate >= currentPeriodEndDate) ||
                (period.sequenceNumber === nextPeriodSequenceNumber && period.endDate <= currentPeriodEndDate));
            if (isDateOverlaps) {
                return of(new ValidatePeriodDateFailure({
                    validationResult: {
                        sequenceNumber: currentPeriodSequenceNumber,
                        validationMessage: PERIOD_END_DATE_OVERLAP_MSG,
                    },
                }));
            }
            const nextPeriodStartDate = addDays(currentPeriodEndDate, 1);
            return of(new ValidatePeriodDateSuccess({ periodSequenceNumber: currentPeriodSequenceNumber }), new UpdatePeriodsDates({ currentPeriodEndDate, nextPeriodStartDate, currentPeriodSequenceNumber }));
        })));
        /**
         * Based on the isMappingMode flag value updates `newPeriodList` or `editPeriodList`.
         * Updates the periods end date by sequence number and the start date of the period after.
         * Triggers the `SetNewPeriodList` or `SetEditPeriodList` with updated periods based on the isMappingMode flag value.
         */
        this.updatePeriodsDates$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.UpdatePeriodsDates), withLatestFrom(this.store.select(getIsMappingMode), this.store.select(getEditPeriodList), this.store.select(getNewPeriodList)), concatMap(([action, isMappingMode, editPeriodList, newPeriodList]) => {
            var _a;
            const currentPeriodEndDate = action.payload.currentPeriodEndDate;
            const nextPeriodStartDate = action.payload.nextPeriodStartDate;
            const currentPeriodSequenceNumber = action.payload.currentPeriodSequenceNumber;
            const nextPeriodSequenceNumber = currentPeriodSequenceNumber + 1;
            const periodsWithNewDate = (_a = (isMappingMode ? newPeriodList : editPeriodList)) === null || _a === void 0 ? void 0 : _a.map(period => 
            // sets end date of period with sequence number
            (period.sequenceNumber === currentPeriodSequenceNumber && Object.assign(Object.assign({}, period), { endDate: currentPeriodEndDate })) ||
                // sets start date of the next period with next sequence number
                (period.sequenceNumber === nextPeriodSequenceNumber && Object.assign(Object.assign({}, period), { startDate: nextPeriodStartDate })) ||
                // no changes
                period);
            return of(isMappingMode
                ? new SetNewPeriodList({ periods: periodsWithNewDate })
                : new SetEditPeriodList({ periods: periodsWithNewDate }));
        })));
        /**
         * Selects the isCustomPeriodsFrequency flag, custom periods number and selected fiscal year.
         * If the isCustomPeriodsFrequency flag is true triggers the `ValidateCustomPeriodsNumber`,
         * with the selected custom periods number and selected fiscal year.
         * For this action we don't want to calculate the `newPeriodsList`, so the flag `calculateNewPeriods` set to false,
         * for the `ValidateCustomPeriodsNumber` action.
         * Otherwise triggers the `CustomPeriodsNumberValidationSuccess`.
         */
        this.triggerCustomPeriodsNumberValidation$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.TriggerCustomPeriodsNumberValidation), withLatestFrom(this.store.select(getIsCustomPeriodsFrequency), this.store.select(getCustomPeriodsNumber), this.store.select(getSelectedFiscalYear)), concatMap(([_, isCustomPeriodsFrequency, customPeriodsNumber, fiscalYear]) => {
            return isCustomPeriodsFrequency
                ? of(new ValidateCustomPeriodsNumber({ customPeriodsNumber, fiscalYear, calculateNewPeriods: false }))
                : of(new CustomPeriodsNumberValidationSuccess());
        })));
        /**
         * Based on the period's `sequenceNumber`, updates the `mappingId` of the period from the `editPeriodList`.
         * Resets the `editPeriodList` with updated period by triggering the `SetEditPeriodList` action.
         */
        this.mapPeriod$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.MapPeriod), withLatestFrom(this.store.select(getEditPeriodList)), concatMap(([action, periods]) => {
            const periodSequenceNumber = action.payload.periodSequenceNumber;
            const newMappingId = action.payload.newMappingId;
            const periodsWithNewMappingId = periods === null || periods === void 0 ? void 0 : periods.map(period => (period.sequenceNumber === periodSequenceNumber && Object.assign(Object.assign({}, period), { mappingId: newMappingId })) || period);
            return of(new SetEditPeriodList({ periods: periodsWithNewMappingId }));
        })));
        /**
         * Based on the `isMappingMode` flag, either maps `editPeriodList`'s periods to corresponded `newPeriodList`'s periods
         * or sets the `mappingIds` for the `editPeriodList`s periods using the periods' `sequenceNumber`.
         */
        this.mapPeriods$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.MapPeriods), withLatestFrom(this.store.select(getIsMappingMode), this.store.select(getEditPeriodList), this.store.select(getNewPeriodList)), concatMap(([_, isMappingMode, editPeriodList, newPeriodList]) => {
            const mappedPeriods = isMappingMode
                ? this.periodFrequencyService.mapPeriods(editPeriodList, newPeriodList)
                : editPeriodList.map(period => (Object.assign(Object.assign({}, period), { mappingId: period.sequenceNumber })));
            return of(new SetEditPeriodList({ periods: mappedPeriods }));
        })));
        /**
         * Resets the `mappingIds` of the `editPeriodList` to the default ones, which are the `sequenceNumber` of the periods.
         */
        this.discardMapping$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.DiscardMapping), withLatestFrom(this.store.select(getEditPeriodList)), concatMap(([_, editPeriodList]) => {
            const periods = editPeriodList.map(period => (Object.assign(Object.assign({}, period), { mappingId: period.sequenceNumber })));
            return of(new SetEditPeriodList({ periods }));
        })));
        /**
         * Based on the `isMappingMode`'s value, either pass `editPeriodList`'s periods marked as deleted (`isDeleted: true`)
         * and combined with the `newPeriodList`'s periods
         * or passes the `editPeriodList` to the *fiscal-year store action name TBD* action.
         */
        this.savePeriodsMapping$ = createEffect(() => this.actions$.pipe(ofType(EditPeriodsActionTypes.SavePeriodsMapping), withLatestFrom(this.store.select(getIsMappingMode), this.store.select(getEditPeriodList), this.store.select(getNewPeriodList), this.store.select(getPeriodType)), concatMap(([_, isMappingMode, editPeriodList, newPeriodList, periodType]) => {
            const periods = isMappingMode
                ? [...editPeriodList.map(period => (Object.assign(Object.assign({}, period), { isDeleted: true }))), ...newPeriodList]
                : editPeriodList;
            return of(new UpdateFiscalYearMappedPeriods({ mappedPeriods: periods, periodType }));
        })));
    }
}
EditPeriodsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditPeriodsEffects, deps: [{ token: i1$3.Actions }, { token: i2.Store }, { token: PeriodFrequencyService }], target: i0.ɵɵFactoryTarget.Injectable });
EditPeriodsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditPeriodsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EditPeriodsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2.Store }, { type: PeriodFrequencyService }]; } });

const GroupingsTypeEnum = {
    systemId: 'ACCOUNTCLASSIFICATION',
};

class AccountGroupEffects {
    constructor(actions$, accountService, accountGroupService) {
        this.actions$ = actions$;
        this.accountService = accountService;
        this.accountGroupService = accountGroupService;
        /**
         * Consumes accountGroupService.get.
         * Finds the accountGroupId.
         */
        this.getAccountGroupService$ = createEffect(() => this.actions$.pipe(ofType(AccountGroupActionTypes.LoadAccountGroupService), concatMap(action => this.accountGroupService.get(action.payload.ownerId).pipe(switchMap(data => {
            const account = data.find(_account => _account.systemId === GroupingsTypeEnum.systemId);
            const accountGroupId = account.id;
            return of(new LoadAccountGroup({ ownerId: action.payload.ownerId, accountGroupId }));
        }), catchError(error => of(new LoadAccountGroupFailure({ error })))))));
        /**
         * Consumes accontService.getByAccountGroup.
         * Finds the number of ungrouped accounts.
         */
        this.getByAccountGroup$ = createEffect(() => this.actions$.pipe(ofType(AccountGroupActionTypes.LoadAccountGroup), concatMap(action => this.accountService.getByAccountGroup(action.payload.ownerId, action.payload.accountGroupId).pipe(switchMap(accountGroups => {
            const groupedAccounts = accountGroups.filter(account => account.unassignedTotalBalanceCondition === 1).length;
            return of(new LoadAccountGroupSuccess({ data: groupedAccounts }));
        }), catchError(error => of(new LoadAccountGroupFailure({ accountGroupId: action.payload.accountGroupId, error })))))));
    }
}
AccountGroupEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountGroupEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.AccountService }, { token: i2$1.AccountGroupService }], target: i0.ɵɵFactoryTarget.Injectable });
AccountGroupEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountGroupEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountGroupEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.AccountService }, { type: i2$1.AccountGroupService }]; } });

const AccountBalanceTypeEnum = {
    systemId: 'ADJUSTED',
};

var TotalAccountBalancesEnum;
(function (TotalAccountBalancesEnum) {
    TotalAccountBalancesEnum["requestId"] = "TOTALACCOUNTBALANCES";
    TotalAccountBalancesEnum["periodString"] = "0";
    TotalAccountBalancesEnum["yearString"] = "0";
})(TotalAccountBalancesEnum || (TotalAccountBalancesEnum = {}));
var IncludeTypeEnum;
(function (IncludeTypeEnum) {
    IncludeTypeEnum[IncludeTypeEnum["PeriodOnly"] = 0] = "PeriodOnly";
    IncludeTypeEnum[IncludeTypeEnum["BeginningBalance"] = 1] = "BeginningBalance";
    IncludeTypeEnum[IncludeTypeEnum["PriorPeriods"] = 2] = "PriorPeriods";
    IncludeTypeEnum[IncludeTypeEnum["FullYear"] = 3] = "FullYear";
    IncludeTypeEnum[IncludeTypeEnum["BeginningBalanceAndPriorPeriods"] = 4] = "BeginningBalanceAndPriorPeriods";
    IncludeTypeEnum[IncludeTypeEnum["BeginningBalanceAndFullYear"] = 5] = "BeginningBalanceAndFullYear";
})(IncludeTypeEnum || (IncludeTypeEnum = {}));

class AccountsTotalEffects {
    constructor(actions$, accountBalanceTypeService, accountBalanceTotalService) {
        this.actions$ = actions$;
        this.accountBalanceTypeService = accountBalanceTypeService;
        this.accountBalanceTotalService = accountBalanceTotalService;
        /**
         * Consume accountBalanceTypeService.get and accountService.getTotals in parallel
         * find the accountBalance of ADJUSTED systemId and subtract amountDebit from amountCredit to obtain the accountBalanceAmount
         */
        this.getAccountBalanceType$ = createEffect(() => this.actions$.pipe(ofType(AccountsTotalActionTypes.LoadAccountBalanceTypeService), concatMap(action => this.accountBalanceTypeService.get(action.payload.ownerId).pipe(switchMap(data => {
            const accountBalanceTypeId = data.find(accountBalanceType => accountBalanceType.systemId === AccountBalanceTypeEnum.systemId).id;
            const balanceTotalParams = {
                totalAccountBalances: [
                    {
                        requestId: TotalAccountBalancesEnum.requestId,
                        balanceTypeId: accountBalanceTypeId,
                        periodString: TotalAccountBalancesEnum.periodString,
                        yearString: TotalAccountBalancesEnum.yearString,
                        includeType: IncludeTypeEnum.BeginningBalanceAndFullYear,
                        useNetValue: true,
                    },
                ],
            };
            return of(new LoadAccountsTotal({ ownerId: action.payload.ownerId, accountBalanceTotalParameters: balanceTotalParams }));
        }), catchError(error => of(new LoadAccountsTotalFailure({ error })))))));
        /**
         * Consumes accountGroupService.get.
         * Finds the accountGroupId.
         */
        this.getTotals$ = createEffect(() => this.actions$.pipe(ofType(AccountsTotalActionTypes.LoadAccountsTotal), concatMap(action => this.accountBalanceTotalService
            .getAccountBalanceTotals(action.payload.ownerId, action.payload.accountBalanceTotalParameters)
            .pipe(switchMap(responses => {
            try {
                const accountBalance = responses.find(data => data.requestId === TotalAccountBalancesEnum.requestId);
                if (accountBalance.code === 200) {
                    const accountBalanceAmount = accountBalance.amountDebit - accountBalance.amountCredit;
                    return of(new LoadAccountsTotalSuccess({ data: accountBalanceAmount }));
                }
            }
            catch (error) {
                return of(new LoadAccountsTotalFailure({ error }));
            }
        }), catchError(error => of(new LoadAccountsTotalFailure({ error })))))));
    }
}
AccountsTotalEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountsTotalEffects, deps: [{ token: i1$3.Actions }, { token: i2$1.AccountBalanceTypeService }, { token: i2$1.AccountBalanceTotalService }], target: i0.ɵɵFactoryTarget.Injectable });
AccountsTotalEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountsTotalEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AccountsTotalEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i2$1.AccountBalanceTypeService }, { type: i2$1.AccountBalanceTotalService }]; } });

class IacModel {
    constructor() {
        this.hasMultipleFiscalYearIAC = false;
    }
}

const IAC = {
    EditMultipleFYNoActivity: 'EditMultipleFYNoActivity',
};

class IacEffects {
    constructor(actions$) {
        this.actions$ = actions$;
        /**
         * Retrieves all the IAC's.
         */
        this.loadIac$ = createEffect(() => this.actions$.pipe(ofType(LoadIacTypes.LoadIac), concatMap(() => from(this.getIACFromSession()).pipe(map(data => new LoadIacSuccess({ iacs: data })), catchError(error => of(new LoadIacFailure({ error })))))));
    }
    /**
     * Gets the available IACs from the session call, based on the that map the boolean flag to the respective IAC property
     * @returns the Iac model
     */
    getIACFromSession() {
        return __awaiter(this, void 0, void 0, function* () {
            this.iacmodel = new IacModel();
            const IACs = yield session.getIACsWithFallback();
            this.iacmodel.hasMultipleFiscalYearIAC = IACs.includes(IAC.EditMultipleFYNoActivity);
            return this.iacmodel;
        });
    }
}
IacEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: IacEffects, deps: [{ token: i1$3.Actions }], target: i0.ɵɵFactoryTarget.Injectable });
IacEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: IacEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: IacEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }]; } });

class PeriodsModule {
}
PeriodsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PeriodsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsModule, declarations: [AccountingTabComponent,
        AddEditFiscalYearComponent,
        ContactDropdownComponent,
        CurrentPeriodComponent,
        DatePickerComponent,
        FinancialPeriodTabsComponent,
        FirmTabComponent,
        FiscalYearDateComponent,
        FiscalYearDropdownComponent,
        FiscalYearListComponent,
        FixedAssetsTabComponent,
        PeriodFrequencyComponent,
        PeriodListComponent,
        PeriodsComponent,
        SelectTaxYearComponent,
        EditAccountingPeriodsModalComponent,
        PeriodFrequencySelectComponent,
        PeriodsMappingComponent,
        SetCurrentPeriodModalComponent,
        EditPeriodsFrequencyInformationComponent,
        EditFirmPeriodsModalComponent,
        OpenModalLinkComponent,
        ConfirmationDialogComponent,
        AccountWarningComponent,
        BmppFiscalYearModalComponent,
        EditFiscalYearsComponent,
        EditFiscalYearGridDatepickerComponent], imports: [CommonModule, i1$1.TranslateModule, NgbModule,
        BentoModule,
        BentoTranslateModule,
        BluemoonYearEndCloseModule,
        WjGridModule,
        WjInputModule,
        WjGridFilterModule,
        WjGridGrouppanelModule,
        BentoFlexGridControlModule,
        WjGridDetailModule, i1$3.EffectsFeatureModule, FormsModule,
        UkTaxPeriodsModule,
        UkVatPeriodsModule, i2.StoreFeatureModule, i1$3.EffectsFeatureModule], exports: [ContactDropdownComponent,
        DatePickerComponent,
        PeriodsComponent,
        BmppFiscalYearModalComponent,
        AddEditFiscalYearComponent] });
PeriodsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsModule, providers: [
        BmppAlertService,
        BmppDateHelperService,
        BmppDateValidatorService,
        BmppFeatureResourcePermissionService,
        BmppOwnerService,
        OpenModalHelperService,
        LocaleService,
        BmppFeatureResourcePermissionService,
        BmppModalHelperService,
        PeriodFrequencyService,
        AmountFormattingService,
    ], imports: [[
            CommonModule,
            TranslateModule.forChild(),
            NgbModule,
            BentoModule,
            BentoTranslateModule,
            BluemoonYearEndCloseModule,
            WjGridModule,
            WjInputModule,
            WjGridFilterModule,
            WjGridGrouppanelModule,
            BentoFlexGridControlModule,
            WjGridDetailModule,
            EffectsModule.forFeature([
                ContactsEffects,
                EditPeriodsEffects,
                FiscalYearEffects,
                TransactionEffects,
                CompanyEffects,
                AccountsTotalEffects,
                AccountGroupEffects,
                IacEffects,
            ]),
            FormsModule,
            UkTaxPeriodsModule,
            UkVatPeriodsModule,
            StoreModule.forFeature(periodsStateFeatureKey, reducers, {
                metaReducers: metaReducers,
            }),
            EffectsModule.forFeature([FiscalYearEffects]),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PeriodsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AccountingTabComponent,
                        AddEditFiscalYearComponent,
                        ContactDropdownComponent,
                        CurrentPeriodComponent,
                        DatePickerComponent,
                        FinancialPeriodTabsComponent,
                        FirmTabComponent,
                        FiscalYearDateComponent,
                        FiscalYearDropdownComponent,
                        FiscalYearListComponent,
                        FixedAssetsTabComponent,
                        PeriodFrequencyComponent,
                        PeriodListComponent,
                        PeriodsComponent,
                        SelectTaxYearComponent,
                        EditAccountingPeriodsModalComponent,
                        PeriodFrequencySelectComponent,
                        PeriodsMappingComponent,
                        SetCurrentPeriodModalComponent,
                        EditPeriodsFrequencyInformationComponent,
                        EditFirmPeriodsModalComponent,
                        OpenModalLinkComponent,
                        ConfirmationDialogComponent,
                        AccountWarningComponent,
                        BmppFiscalYearModalComponent,
                        EditFiscalYearsComponent,
                        EditFiscalYearGridDatepickerComponent,
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        NgbModule,
                        BentoModule,
                        BentoTranslateModule,
                        BluemoonYearEndCloseModule,
                        WjGridModule,
                        WjInputModule,
                        WjGridFilterModule,
                        WjGridGrouppanelModule,
                        BentoFlexGridControlModule,
                        WjGridDetailModule,
                        EffectsModule.forFeature([
                            ContactsEffects,
                            EditPeriodsEffects,
                            FiscalYearEffects,
                            TransactionEffects,
                            CompanyEffects,
                            AccountsTotalEffects,
                            AccountGroupEffects,
                            IacEffects,
                        ]),
                        FormsModule,
                        UkTaxPeriodsModule,
                        UkVatPeriodsModule,
                        StoreModule.forFeature(periodsStateFeatureKey, reducers, {
                            metaReducers: metaReducers,
                        }),
                        EffectsModule.forFeature([FiscalYearEffects]),
                    ],
                    providers: [
                        BmppAlertService,
                        BmppDateHelperService,
                        BmppDateValidatorService,
                        BmppFeatureResourcePermissionService,
                        BmppOwnerService,
                        OpenModalHelperService,
                        LocaleService,
                        BmppFeatureResourcePermissionService,
                        BmppModalHelperService,
                        PeriodFrequencyService,
                        AmountFormattingService,
                    ],
                    exports: [
                        ContactDropdownComponent,
                        DatePickerComponent,
                        PeriodsComponent,
                        BmppFiscalYearModalComponent,
                        AddEditFiscalYearComponent,
                    ],
                }]
        }] });

/*
 * Public API Surface of periods
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddEditFiscalYearComponent, BmppFiscalYearModalComponent, ContactDropdownComponent, DatePickerComponent, PeriodsComponent, PeriodsModule, addFiscalYearModalName, editFiscalYearModalName, notEditableEndDate, notEditableStartDate };
